// Generated by scripts/generate-geo.ts. Do not edit by hand.
const states: { [countryCode: string]: { code: string; name: string }[] } = {
  AD: [
    { code: "02", name: "states.AD.02" },
    { code: "03", name: "states.AD.03" },
    { code: "04", name: "states.AD.04" },
    { code: "05", name: "states.AD.05" },
    { code: "06", name: "states.AD.06" },
    { code: "07", name: "states.AD.07" },
    { code: "08", name: "states.AD.08" },
  ],
  AE: [
    { code: "AJ", name: "states.AE.AJ" },
    { code: "AZ", name: "states.AE.AZ" },
    { code: "DU", name: "states.AE.DU" },
    { code: "FU", name: "states.AE.FU" },
    { code: "RK", name: "states.AE.RK" },
    { code: "SH", name: "states.AE.SH" },
    { code: "UQ", name: "states.AE.UQ" },
  ],
  AF: [
    { code: "BAL", name: "states.AF.BAL" },
    { code: "BAM", name: "states.AF.BAM" },
    { code: "BDG", name: "states.AF.BDG" },
    { code: "BDS", name: "states.AF.BDS" },
    { code: "BGL", name: "states.AF.BGL" },
    { code: "DAY", name: "states.AF.DAY" },
    { code: "FRA", name: "states.AF.FRA" },
    { code: "FYB", name: "states.AF.FYB" },
    { code: "GHA", name: "states.AF.GHA" },
    { code: "GHO", name: "states.AF.GHO" },
    { code: "HEL", name: "states.AF.HEL" },
    { code: "HER", name: "states.AF.HER" },
    { code: "JOW", name: "states.AF.JOW" },
    { code: "KAB", name: "states.AF.KAB" },
    { code: "KAN", name: "states.AF.KAN" },
    { code: "KAP", name: "states.AF.KAP" },
    { code: "KDZ", name: "states.AF.KDZ" },
    { code: "KHO", name: "states.AF.KHO" },
    { code: "KNR", name: "states.AF.KNR" },
    { code: "LAG", name: "states.AF.LAG" },
    { code: "LOG", name: "states.AF.LOG" },
    { code: "NAN", name: "states.AF.NAN" },
    { code: "NIM", name: "states.AF.NIM" },
    { code: "NUR", name: "states.AF.NUR" },
    { code: "PAN", name: "states.AF.PAN" },
    { code: "PAR", name: "states.AF.PAR" },
    { code: "PIA", name: "states.AF.PIA" },
    { code: "PKA", name: "states.AF.PKA" },
    { code: "SAM", name: "states.AF.SAM" },
    { code: "SAR", name: "states.AF.SAR" },
    { code: "TAK", name: "states.AF.TAK" },
    { code: "URU", name: "states.AF.URU" },
    { code: "ZAB", name: "states.AF.ZAB" },
  ],
  AG: [
    { code: "03", name: "states.AG.03" },
    { code: "04", name: "states.AG.04" },
    { code: "05", name: "states.AG.05" },
    { code: "06", name: "states.AG.06" },
    { code: "07", name: "states.AG.07" },
    { code: "08", name: "states.AG.08" },
    { code: "10", name: "states.AG.10" },
    { code: "11", name: "states.AG.11" },
  ],
  AL: [
    { code: "01", name: "states.AL.01" },
    { code: "02", name: "states.AL.02" },
    { code: "03", name: "states.AL.03" },
    { code: "04", name: "states.AL.04" },
    { code: "05", name: "states.AL.05" },
    { code: "06", name: "states.AL.06" },
    { code: "07", name: "states.AL.07" },
    { code: "08", name: "states.AL.08" },
    { code: "09", name: "states.AL.09" },
    { code: "10", name: "states.AL.10" },
    { code: "11", name: "states.AL.11" },
    { code: "12", name: "states.AL.12" },
    { code: "BR", name: "states.AL.BR" },
    { code: "BU", name: "states.AL.BU" },
    { code: "DI", name: "states.AL.DI" },
    { code: "DL", name: "states.AL.DL" },
    { code: "DR", name: "states.AL.DR" },
    { code: "DV", name: "states.AL.DV" },
    { code: "ER", name: "states.AL.ER" },
    { code: "FR", name: "states.AL.FR" },
    { code: "GJ", name: "states.AL.GJ" },
    { code: "GR", name: "states.AL.GR" },
    { code: "HA", name: "states.AL.HA" },
    { code: "KA", name: "states.AL.KA" },
    { code: "KB", name: "states.AL.KB" },
    { code: "KC", name: "states.AL.KC" },
    { code: "KO", name: "states.AL.KO" },
    { code: "KR", name: "states.AL.KR" },
    { code: "KU", name: "states.AL.KU" },
    { code: "LB", name: "states.AL.LB" },
    { code: "LE", name: "states.AL.LE" },
    { code: "LU", name: "states.AL.LU" },
    { code: "MK", name: "states.AL.MK" },
    { code: "MM", name: "states.AL.MM" },
    { code: "MR", name: "states.AL.MR" },
    { code: "MT", name: "states.AL.MT" },
    { code: "PG", name: "states.AL.PG" },
    { code: "PQ", name: "states.AL.PQ" },
    { code: "PR", name: "states.AL.PR" },
    { code: "PU", name: "states.AL.PU" },
    { code: "SH", name: "states.AL.SH" },
    { code: "SK", name: "states.AL.SK" },
    { code: "SR", name: "states.AL.SR" },
    { code: "TE", name: "states.AL.TE" },
    { code: "TP", name: "states.AL.TP" },
    { code: "TR", name: "states.AL.TR" },
    { code: "VL", name: "states.AL.VL" },
  ],
  AM: [
    { code: "AG", name: "states.AM.AG" },
    { code: "AR", name: "states.AM.AR" },
    { code: "AV", name: "states.AM.AV" },
    { code: "ER", name: "states.AM.ER" },
    { code: "GR", name: "states.AM.GR" },
    { code: "KT", name: "states.AM.KT" },
    { code: "LO", name: "states.AM.LO" },
    { code: "SH", name: "states.AM.SH" },
    { code: "SU", name: "states.AM.SU" },
    { code: "TV", name: "states.AM.TV" },
    { code: "VD", name: "states.AM.VD" },
  ],
  AO: [
    { code: "BGO", name: "states.AO.BGO" },
    { code: "BGU", name: "states.AO.BGU" },
    { code: "BIE", name: "states.AO.BIE" },
    { code: "CAB", name: "states.AO.CAB" },
    { code: "CCU", name: "states.AO.CCU" },
    { code: "CNN", name: "states.AO.CNN" },
    { code: "CNO", name: "states.AO.CNO" },
    { code: "CUS", name: "states.AO.CUS" },
    { code: "HUA", name: "states.AO.HUA" },
    { code: "HUI", name: "states.AO.HUI" },
    { code: "LNO", name: "states.AO.LNO" },
    { code: "LSU", name: "states.AO.LSU" },
    { code: "LUA", name: "states.AO.LUA" },
    { code: "MAL", name: "states.AO.MAL" },
    { code: "MOX", name: "states.AO.MOX" },
    { code: "UIG", name: "states.AO.UIG" },
    { code: "ZAI", name: "states.AO.ZAI" },
  ],
  AR: [
    { code: "A", name: "states.AR.A" },
    { code: "B", name: "states.AR.B" },
    { code: "C", name: "states.AR.C" },
    { code: "D", name: "states.AR.D" },
    { code: "E", name: "states.AR.E" },
    { code: "F", name: "states.AR.F" },
    { code: "G", name: "states.AR.G" },
    { code: "H", name: "states.AR.H" },
    { code: "J", name: "states.AR.J" },
    { code: "K", name: "states.AR.K" },
    { code: "L", name: "states.AR.L" },
    { code: "M", name: "states.AR.M" },
    { code: "N", name: "states.AR.N" },
    { code: "P", name: "states.AR.P" },
    { code: "Q", name: "states.AR.Q" },
    { code: "R", name: "states.AR.R" },
    { code: "S", name: "states.AR.S" },
    { code: "T", name: "states.AR.T" },
    { code: "U", name: "states.AR.U" },
    { code: "V", name: "states.AR.V" },
    { code: "W", name: "states.AR.W" },
    { code: "X", name: "states.AR.X" },
    { code: "Y", name: "states.AR.Y" },
    { code: "Z", name: "states.AR.Z" },
  ],
  AT: [
    { code: "1", name: "states.AT.1" },
    { code: "2", name: "states.AT.2" },
    { code: "3", name: "states.AT.3" },
    { code: "4", name: "states.AT.4" },
    { code: "5", name: "states.AT.5" },
    { code: "6", name: "states.AT.6" },
    { code: "7", name: "states.AT.7" },
    { code: "8", name: "states.AT.8" },
    { code: "9", name: "states.AT.9" },
  ],
  AU: [
    { code: "ACT", name: "states.AU.ACT" },
    { code: "NSW", name: "states.AU.NSW" },
    { code: "NT", name: "states.AU.NT" },
    { code: "QLD", name: "states.AU.QLD" },
    { code: "SA", name: "states.AU.SA" },
    { code: "TAS", name: "states.AU.TAS" },
    { code: "VIC", name: "states.AU.VIC" },
    { code: "WA", name: "states.AU.WA" },
  ],
  AZ: [
    { code: "ABS", name: "states.AZ.ABS" },
    { code: "AGA", name: "states.AZ.AGA" },
    { code: "AGC", name: "states.AZ.AGC" },
    { code: "AGM", name: "states.AZ.AGM" },
    { code: "AGS", name: "states.AZ.AGS" },
    { code: "AGU", name: "states.AZ.AGU" },
    { code: "AST", name: "states.AZ.AST" },
    { code: "BA", name: "states.AZ.BA" },
    { code: "BAB", name: "states.AZ.BAB" },
    { code: "BAL", name: "states.AZ.BAL" },
    { code: "BAR", name: "states.AZ.BAR" },
    { code: "BEY", name: "states.AZ.BEY" },
    { code: "BIL", name: "states.AZ.BIL" },
    { code: "CAB", name: "states.AZ.CAB" },
    { code: "CAL", name: "states.AZ.CAL" },
    { code: "CUL", name: "states.AZ.CUL" },
    { code: "DAS", name: "states.AZ.DAS" },
    { code: "FUZ", name: "states.AZ.FUZ" },
    { code: "GA", name: "states.AZ.GA" },
    { code: "GAD", name: "states.AZ.GAD" },
    { code: "GOR", name: "states.AZ.GOR" },
    { code: "GOY", name: "states.AZ.GOY" },
    { code: "GYG", name: "states.AZ.GYG" },
    { code: "HAC", name: "states.AZ.HAC" },
    { code: "IMI", name: "states.AZ.IMI" },
    { code: "ISM", name: "states.AZ.ISM" },
    { code: "KAL", name: "states.AZ.KAL" },
    { code: "KAN", name: "states.AZ.KAN" },
    { code: "KUR", name: "states.AZ.KUR" },
    { code: "LA", name: "states.AZ.LA" },
    { code: "LAC", name: "states.AZ.LAC" },
    { code: "LAN", name: "states.AZ.LAN" },
    { code: "LER", name: "states.AZ.LER" },
    { code: "MAS", name: "states.AZ.MAS" },
    { code: "MI", name: "states.AZ.MI" },
    { code: "NEF", name: "states.AZ.NEF" },
    { code: "NX", name: "states.AZ.NX" },
    { code: "OGU", name: "states.AZ.OGU" },
    { code: "ORD", name: "states.AZ.ORD" },
    { code: "QAB", name: "states.AZ.QAB" },
    { code: "QAX", name: "states.AZ.QAX" },
    { code: "QAZ", name: "states.AZ.QAZ" },
    { code: "QBA", name: "states.AZ.QBA" },
    { code: "QBI", name: "states.AZ.QBI" },
    { code: "QOB", name: "states.AZ.QOB" },
    { code: "QUS", name: "states.AZ.QUS" },
    { code: "SA", name: "states.AZ.SA" },
    { code: "SAB", name: "states.AZ.SAB" },
    { code: "SAD", name: "states.AZ.SAD" },
    { code: "SAH", name: "states.AZ.SAH" },
    { code: "SAK", name: "states.AZ.SAK" },
    { code: "SAL", name: "states.AZ.SAL" },
    { code: "SAR", name: "states.AZ.SAR" },
    { code: "SAT", name: "states.AZ.SAT" },
    { code: "SBN", name: "states.AZ.SBN" },
    { code: "SIY", name: "states.AZ.SIY" },
    { code: "SKR", name: "states.AZ.SKR" },
    { code: "SM", name: "states.AZ.SM" },
    { code: "SMI", name: "states.AZ.SMI" },
    { code: "SMX", name: "states.AZ.SMX" },
    { code: "SR", name: "states.AZ.SR" },
    { code: "SUS", name: "states.AZ.SUS" },
    { code: "TAR", name: "states.AZ.TAR" },
    { code: "TOV", name: "states.AZ.TOV" },
    { code: "UCA", name: "states.AZ.UCA" },
    { code: "XAC", name: "states.AZ.XAC" },
    { code: "XCI", name: "states.AZ.XCI" },
    { code: "XIZ", name: "states.AZ.XIZ" },
    { code: "XVD", name: "states.AZ.XVD" },
    { code: "YAR", name: "states.AZ.YAR" },
    { code: "YE", name: "states.AZ.YE" },
    { code: "YEV", name: "states.AZ.YEV" },
    { code: "ZAN", name: "states.AZ.ZAN" },
    { code: "ZAQ", name: "states.AZ.ZAQ" },
    { code: "ZAR", name: "states.AZ.ZAR" },
  ],
  BA: [
    { code: "01", name: "states.BA.01" },
    { code: "02", name: "states.BA.02" },
    { code: "03", name: "states.BA.03" },
    { code: "04", name: "states.BA.04" },
    { code: "05", name: "states.BA.05" },
    { code: "06", name: "states.BA.06" },
    { code: "07", name: "states.BA.07" },
    { code: "08", name: "states.BA.08" },
    { code: "09", name: "states.BA.09" },
    { code: "10", name: "states.BA.10" },
    { code: "BIH", name: "states.BA.BIH" },
    { code: "BRC", name: "states.BA.BRC" },
    { code: "SRP", name: "states.BA.SRP" },
  ],
  BB: [
    { code: "01", name: "states.BB.01" },
    { code: "02", name: "states.BB.02" },
    { code: "03", name: "states.BB.03" },
    { code: "04", name: "states.BB.04" },
    { code: "05", name: "states.BB.05" },
    { code: "06", name: "states.BB.06" },
    { code: "07", name: "states.BB.07" },
    { code: "08", name: "states.BB.08" },
    { code: "09", name: "states.BB.09" },
    { code: "10", name: "states.BB.10" },
    { code: "11", name: "states.BB.11" },
  ],
  BD: [
    { code: "01", name: "states.BD.01" },
    { code: "02", name: "states.BD.02" },
    { code: "03", name: "states.BD.03" },
    { code: "04", name: "states.BD.04" },
    { code: "05", name: "states.BD.05" },
    { code: "06", name: "states.BD.06" },
    { code: "07", name: "states.BD.07" },
    { code: "08", name: "states.BD.08" },
    { code: "09", name: "states.BD.09" },
    { code: "10", name: "states.BD.10" },
    { code: "11", name: "states.BD.11" },
    { code: "12", name: "states.BD.12" },
    { code: "13", name: "states.BD.13" },
    { code: "14", name: "states.BD.14" },
    { code: "15", name: "states.BD.15" },
    { code: "16", name: "states.BD.16" },
    { code: "17", name: "states.BD.17" },
    { code: "18", name: "states.BD.18" },
    { code: "19", name: "states.BD.19" },
    { code: "20", name: "states.BD.20" },
    { code: "21", name: "states.BD.21" },
    { code: "22", name: "states.BD.22" },
    { code: "23", name: "states.BD.23" },
    { code: "24", name: "states.BD.24" },
    { code: "25", name: "states.BD.25" },
    { code: "26", name: "states.BD.26" },
    { code: "27", name: "states.BD.27" },
    { code: "28", name: "states.BD.28" },
    { code: "29", name: "states.BD.29" },
    { code: "30", name: "states.BD.30" },
    { code: "31", name: "states.BD.31" },
    { code: "32", name: "states.BD.32" },
    { code: "33", name: "states.BD.33" },
    { code: "34", name: "states.BD.34" },
    { code: "35", name: "states.BD.35" },
    { code: "36", name: "states.BD.36" },
    { code: "38", name: "states.BD.38" },
    { code: "39", name: "states.BD.39" },
    { code: "40", name: "states.BD.40" },
    { code: "41", name: "states.BD.41" },
    { code: "43", name: "states.BD.43" },
    { code: "44", name: "states.BD.44" },
    { code: "45", name: "states.BD.45" },
    { code: "46", name: "states.BD.46" },
    { code: "47", name: "states.BD.47" },
    { code: "48", name: "states.BD.48" },
    { code: "49", name: "states.BD.49" },
    { code: "50", name: "states.BD.50" },
    { code: "51", name: "states.BD.51" },
    { code: "52", name: "states.BD.52" },
    { code: "53", name: "states.BD.53" },
    { code: "54", name: "states.BD.54" },
    { code: "55", name: "states.BD.55" },
    { code: "56", name: "states.BD.56" },
    { code: "57", name: "states.BD.57" },
    { code: "58", name: "states.BD.58" },
    { code: "59", name: "states.BD.59" },
    { code: "60", name: "states.BD.60" },
    { code: "61", name: "states.BD.61" },
    { code: "62", name: "states.BD.62" },
    { code: "63", name: "states.BD.63" },
    { code: "64", name: "states.BD.64" },
    { code: "A", name: "states.BD.A" },
    { code: "B", name: "states.BD.B" },
    { code: "C", name: "states.BD.C" },
    { code: "D", name: "states.BD.D" },
    { code: "E", name: "states.BD.E" },
    { code: "F", name: "states.BD.F" },
    { code: "G", name: "states.BD.G" },
    { code: "H", name: "states.BD.H" },
  ],
  BE: [
    { code: "BRU", name: "states.BE.BRU" },
    { code: "VAN", name: "states.BE.VAN" },
    { code: "VBR", name: "states.BE.VBR" },
    { code: "VLG", name: "states.BE.VLG" },
    { code: "VLI", name: "states.BE.VLI" },
    { code: "VOV", name: "states.BE.VOV" },
    { code: "VWV", name: "states.BE.VWV" },
    { code: "WAL", name: "states.BE.WAL" },
    { code: "WBR", name: "states.BE.WBR" },
    { code: "WHT", name: "states.BE.WHT" },
    { code: "WLG", name: "states.BE.WLG" },
    { code: "WLX", name: "states.BE.WLX" },
    { code: "WNA", name: "states.BE.WNA" },
  ],
  BF: [
    { code: "01", name: "states.BF.01" },
    { code: "02", name: "states.BF.02" },
    { code: "03", name: "states.BF.03" },
    { code: "04", name: "states.BF.04" },
    { code: "05", name: "states.BF.05" },
    { code: "06", name: "states.BF.06" },
    { code: "07", name: "states.BF.07" },
    { code: "08", name: "states.BF.08" },
    { code: "09", name: "states.BF.09" },
    { code: "10", name: "states.BF.10" },
    { code: "11", name: "states.BF.11" },
    { code: "12", name: "states.BF.12" },
    { code: "13", name: "states.BF.13" },
    { code: "BAL", name: "states.BF.BAL" },
    { code: "BAM", name: "states.BF.BAM" },
    { code: "BAN", name: "states.BF.BAN" },
    { code: "BAZ", name: "states.BF.BAZ" },
    { code: "BGR", name: "states.BF.BGR" },
    { code: "BLG", name: "states.BF.BLG" },
    { code: "COM", name: "states.BF.COM" },
    { code: "GAN", name: "states.BF.GAN" },
    { code: "GNA", name: "states.BF.GNA" },
    { code: "GOU", name: "states.BF.GOU" },
    { code: "HOU", name: "states.BF.HOU" },
    { code: "IOB", name: "states.BF.IOB" },
    { code: "KAD", name: "states.BF.KAD" },
    { code: "KEN", name: "states.BF.KEN" },
    { code: "KMD", name: "states.BF.KMD" },
    { code: "KMP", name: "states.BF.KMP" },
    { code: "KOP", name: "states.BF.KOP" },
    { code: "KOS", name: "states.BF.KOS" },
    { code: "KOT", name: "states.BF.KOT" },
    { code: "KOW", name: "states.BF.KOW" },
    { code: "LER", name: "states.BF.LER" },
    { code: "LOR", name: "states.BF.LOR" },
    { code: "MOU", name: "states.BF.MOU" },
    { code: "NAM", name: "states.BF.NAM" },
    { code: "NAO", name: "states.BF.NAO" },
    { code: "NAY", name: "states.BF.NAY" },
    { code: "NOU", name: "states.BF.NOU" },
    { code: "OUB", name: "states.BF.OUB" },
    { code: "OUD", name: "states.BF.OUD" },
    { code: "PAS", name: "states.BF.PAS" },
    { code: "PON", name: "states.BF.PON" },
    { code: "SEN", name: "states.BF.SEN" },
    { code: "SIS", name: "states.BF.SIS" },
    { code: "SMT", name: "states.BF.SMT" },
    { code: "SNG", name: "states.BF.SNG" },
    { code: "SOM", name: "states.BF.SOM" },
    { code: "SOR", name: "states.BF.SOR" },
    { code: "TAP", name: "states.BF.TAP" },
    { code: "TUI", name: "states.BF.TUI" },
    { code: "YAG", name: "states.BF.YAG" },
    { code: "YAT", name: "states.BF.YAT" },
    { code: "ZIR", name: "states.BF.ZIR" },
    { code: "ZON", name: "states.BF.ZON" },
    { code: "ZOU", name: "states.BF.ZOU" },
  ],
  BG: [
    { code: "01", name: "states.BG.01" },
    { code: "02", name: "states.BG.02" },
    { code: "03", name: "states.BG.03" },
    { code: "04", name: "states.BG.04" },
    { code: "05", name: "states.BG.05" },
    { code: "06", name: "states.BG.06" },
    { code: "07", name: "states.BG.07" },
    { code: "08", name: "states.BG.08" },
    { code: "09", name: "states.BG.09" },
    { code: "10", name: "states.BG.10" },
    { code: "11", name: "states.BG.11" },
    { code: "12", name: "states.BG.12" },
    { code: "13", name: "states.BG.13" },
    { code: "14", name: "states.BG.14" },
    { code: "15", name: "states.BG.15" },
    { code: "16", name: "states.BG.16" },
    { code: "17", name: "states.BG.17" },
    { code: "18", name: "states.BG.18" },
    { code: "19", name: "states.BG.19" },
    { code: "20", name: "states.BG.20" },
    { code: "21", name: "states.BG.21" },
    { code: "22", name: "states.BG.22" },
    { code: "23", name: "states.BG.23" },
    { code: "24", name: "states.BG.24" },
    { code: "25", name: "states.BG.25" },
    { code: "26", name: "states.BG.26" },
    { code: "27", name: "states.BG.27" },
    { code: "28", name: "states.BG.28" },
  ],
  BH: [
    { code: "13", name: "states.BH.13" },
    { code: "14", name: "states.BH.14" },
    { code: "15", name: "states.BH.15" },
    { code: "16", name: "states.BH.16" },
    { code: "17", name: "states.BH.17" },
  ],
  BI: [
    { code: "BB", name: "states.BI.BB" },
    { code: "BL", name: "states.BI.BL" },
    { code: "BM", name: "states.BI.BM" },
    { code: "BR", name: "states.BI.BR" },
    { code: "CA", name: "states.BI.CA" },
    { code: "CI", name: "states.BI.CI" },
    { code: "GI", name: "states.BI.GI" },
    { code: "KI", name: "states.BI.KI" },
    { code: "KR", name: "states.BI.KR" },
    { code: "KY", name: "states.BI.KY" },
    { code: "MA", name: "states.BI.MA" },
    { code: "MU", name: "states.BI.MU" },
    { code: "MW", name: "states.BI.MW" },
    { code: "MY", name: "states.BI.MY" },
    { code: "NG", name: "states.BI.NG" },
    { code: "RM", name: "states.BI.RM" },
    { code: "RT", name: "states.BI.RT" },
    { code: "RY", name: "states.BI.RY" },
  ],
  BJ: [
    { code: "AK", name: "states.BJ.AK" },
    { code: "AL", name: "states.BJ.AL" },
    { code: "AQ", name: "states.BJ.AQ" },
    { code: "BO", name: "states.BJ.BO" },
    { code: "CO", name: "states.BJ.CO" },
    { code: "DO", name: "states.BJ.DO" },
    { code: "KO", name: "states.BJ.KO" },
    { code: "LI", name: "states.BJ.LI" },
    { code: "MO", name: "states.BJ.MO" },
    { code: "OU", name: "states.BJ.OU" },
    { code: "PL", name: "states.BJ.PL" },
    { code: "ZO", name: "states.BJ.ZO" },
  ],
  BM: [
    { code: "DEV", name: "states.BM.DEV" },
    { code: "HA", name: "states.BM.HA" },
    { code: "PAG", name: "states.BM.PAG" },
    { code: "PEM", name: "states.BM.PEM" },
    { code: "SAN", name: "states.BM.SAN" },
    { code: "SGE", name: "states.BM.SGE" },
    { code: "SMI", name: "states.BM.SMI" },
    { code: "SOU", name: "states.BM.SOU" },
    { code: "WAR", name: "states.BM.WAR" },
  ],
  BN: [
    { code: "BE", name: "states.BN.BE" },
    { code: "BM", name: "states.BN.BM" },
    { code: "TE", name: "states.BN.TE" },
    { code: "TU", name: "states.BN.TU" },
  ],
  BO: [
    { code: "B", name: "states.BO.B" },
    { code: "C", name: "states.BO.C" },
    { code: "H", name: "states.BO.H" },
    { code: "L", name: "states.BO.L" },
    { code: "N", name: "states.BO.N" },
    { code: "O", name: "states.BO.O" },
    { code: "P", name: "states.BO.P" },
    { code: "S", name: "states.BO.S" },
    { code: "T", name: "states.BO.T" },
  ],
  BR: [
    { code: "AC", name: "states.BR.AC" },
    { code: "AL", name: "states.BR.AL" },
    { code: "AM", name: "states.BR.AM" },
    { code: "AP", name: "states.BR.AP" },
    { code: "BA", name: "states.BR.BA" },
    { code: "CE", name: "states.BR.CE" },
    { code: "DF", name: "states.BR.DF" },
    { code: "ES", name: "states.BR.ES" },
    { code: "GO", name: "states.BR.GO" },
    { code: "MA", name: "states.BR.MA" },
    { code: "MG", name: "states.BR.MG" },
    { code: "MS", name: "states.BR.MS" },
    { code: "MT", name: "states.BR.MT" },
    { code: "PA", name: "states.BR.PA" },
    { code: "PB", name: "states.BR.PB" },
    { code: "PE", name: "states.BR.PE" },
    { code: "PI", name: "states.BR.PI" },
    { code: "PR", name: "states.BR.PR" },
    { code: "RJ", name: "states.BR.RJ" },
    { code: "RN", name: "states.BR.RN" },
    { code: "RO", name: "states.BR.RO" },
    { code: "RR", name: "states.BR.RR" },
    { code: "RS", name: "states.BR.RS" },
    { code: "SC", name: "states.BR.SC" },
    { code: "SE", name: "states.BR.SE" },
    { code: "SP", name: "states.BR.SP" },
    { code: "TO", name: "states.BR.TO" },
  ],
  BS: [
    { code: "AC", name: "states.BS.AC" },
    { code: "AK", name: "states.BS.AK" },
    { code: "BI", name: "states.BS.BI" },
    { code: "BP", name: "states.BS.BP" },
    { code: "BY", name: "states.BS.BY" },
    { code: "CE", name: "states.BS.CE" },
    { code: "CI", name: "states.BS.CI" },
    { code: "CK", name: "states.BS.CK" },
    { code: "CO", name: "states.BS.CO" },
    { code: "CS", name: "states.BS.CS" },
    { code: "EG", name: "states.BS.EG" },
    { code: "EX", name: "states.BS.EX" },
    { code: "FC", name: "states.BS.FC" },
    { code: "FP", name: "states.BS.FP" },
    { code: "GC", name: "states.BS.GC" },
    { code: "GH", name: "states.BS.GH" },
    { code: "GT", name: "states.BS.GT" },
    { code: "HI", name: "states.BS.HI" },
    { code: "HR", name: "states.BS.HR" },
    { code: "HT", name: "states.BS.HT" },
    { code: "IN", name: "states.BS.IN" },
    { code: "KB", name: "states.BS.KB" },
    { code: "LI", name: "states.BS.LI" },
    { code: "MC", name: "states.BS.MC" },
    { code: "MG", name: "states.BS.MG" },
    { code: "MH", name: "states.BS.MH" },
    { code: "NB", name: "states.BS.NB" },
    { code: "NE", name: "states.BS.NE" },
    { code: "NO", name: "states.BS.NO" },
    { code: "NP", name: "states.BS.NP" },
    { code: "NS", name: "states.BS.NS" },
    { code: "RC", name: "states.BS.RC" },
    { code: "RI", name: "states.BS.RI" },
    { code: "RS", name: "states.BS.RS" },
    { code: "SA", name: "states.BS.SA" },
    { code: "SE", name: "states.BS.SE" },
    { code: "SO", name: "states.BS.SO" },
    { code: "SP", name: "states.BS.SP" },
    { code: "SR", name: "states.BS.SR" },
    { code: "SS", name: "states.BS.SS" },
    { code: "SW", name: "states.BS.SW" },
    { code: "WG", name: "states.BS.WG" },
  ],
  BT: [
    { code: "11", name: "states.BT.11" },
    { code: "12", name: "states.BT.12" },
    { code: "13", name: "states.BT.13" },
    { code: "14", name: "states.BT.14" },
    { code: "15", name: "states.BT.15" },
    { code: "21", name: "states.BT.21" },
    { code: "22", name: "states.BT.22" },
    { code: "23", name: "states.BT.23" },
    { code: "24", name: "states.BT.24" },
    { code: "31", name: "states.BT.31" },
    { code: "32", name: "states.BT.32" },
    { code: "33", name: "states.BT.33" },
    { code: "34", name: "states.BT.34" },
    { code: "41", name: "states.BT.41" },
    { code: "42", name: "states.BT.42" },
    { code: "43", name: "states.BT.43" },
    { code: "44", name: "states.BT.44" },
    { code: "45", name: "states.BT.45" },
    { code: "GA", name: "states.BT.GA" },
  ],
  BW: [
    { code: "CE", name: "states.BW.CE" },
    { code: "GH", name: "states.BW.GH" },
    { code: "KG", name: "states.BW.KG" },
    { code: "KL", name: "states.BW.KL" },
    { code: "KW", name: "states.BW.KW" },
    { code: "NE", name: "states.BW.NE" },
    { code: "NG", name: "states.BW.NG" },
    { code: "NW", name: "states.BW.NW" },
    { code: "SE", name: "states.BW.SE" },
    { code: "SO", name: "states.BW.SO" },
  ],
  BY: [
    { code: "BR", name: "states.BY.BR" },
    { code: "HM", name: "states.BY.HM" },
    { code: "HO", name: "states.BY.HO" },
    { code: "HR", name: "states.BY.HR" },
    { code: "MA", name: "states.BY.MA" },
    { code: "MI", name: "states.BY.MI" },
    { code: "VI", name: "states.BY.VI" },
  ],
  BZ: [
    { code: "BZ", name: "states.BZ.BZ" },
    { code: "CY", name: "states.BZ.CY" },
    { code: "CZL", name: "states.BZ.CZL" },
    { code: "OW", name: "states.BZ.OW" },
    { code: "SC", name: "states.BZ.SC" },
    { code: "TOL", name: "states.BZ.TOL" },
  ],
  CA: [
    { code: "AB", name: "states.CA.AB" },
    { code: "BC", name: "states.CA.BC" },
    { code: "MB", name: "states.CA.MB" },
    { code: "NB", name: "states.CA.NB" },
    { code: "NL", name: "states.CA.NL" },
    { code: "NS", name: "states.CA.NS" },
    { code: "NT", name: "states.CA.NT" },
    { code: "NU", name: "states.CA.NU" },
    { code: "ON", name: "states.CA.ON" },
    { code: "PE", name: "states.CA.PE" },
    { code: "QC", name: "states.CA.QC" },
    { code: "SK", name: "states.CA.SK" },
    { code: "YT", name: "states.CA.YT" },
  ],
  CD: [
    { code: "BC", name: "states.CD.BC" },
    { code: "BU", name: "states.CD.BU" },
    { code: "EQ", name: "states.CD.EQ" },
    { code: "HK", name: "states.CD.HK" },
    { code: "HL", name: "states.CD.HL" },
    { code: "HU", name: "states.CD.HU" },
    { code: "IT", name: "states.CD.IT" },
    { code: "KC", name: "states.CD.KC" },
    { code: "KE", name: "states.CD.KE" },
    { code: "KG", name: "states.CD.KG" },
    { code: "KL", name: "states.CD.KL" },
    { code: "KN", name: "states.CD.KN" },
    { code: "KS", name: "states.CD.KS" },
    { code: "LO", name: "states.CD.LO" },
    { code: "LU", name: "states.CD.LU" },
    { code: "MA", name: "states.CD.MA" },
    { code: "MN", name: "states.CD.MN" },
    { code: "MO", name: "states.CD.MO" },
    { code: "NK", name: "states.CD.NK" },
    { code: "NU", name: "states.CD.NU" },
    { code: "SA", name: "states.CD.SA" },
    { code: "SK", name: "states.CD.SK" },
    { code: "SU", name: "states.CD.SU" },
    { code: "TA", name: "states.CD.TA" },
    { code: "TO", name: "states.CD.TO" },
    { code: "TU", name: "states.CD.TU" },
  ],
  CF: [
    { code: "AC", name: "states.CF.AC" },
    { code: "BB", name: "states.CF.BB" },
    { code: "BGF", name: "states.CF.BGF" },
    { code: "BK", name: "states.CF.BK" },
    { code: "HK", name: "states.CF.HK" },
    { code: "HM", name: "states.CF.HM" },
    { code: "HS", name: "states.CF.HS" },
    { code: "KB", name: "states.CF.KB" },
    { code: "KG", name: "states.CF.KG" },
    { code: "LB", name: "states.CF.LB" },
    { code: "MB", name: "states.CF.MB" },
    { code: "MP", name: "states.CF.MP" },
    { code: "NM", name: "states.CF.NM" },
    { code: "OP", name: "states.CF.OP" },
    { code: "SE", name: "states.CF.SE" },
    { code: "UK", name: "states.CF.UK" },
    { code: "VK", name: "states.CF.VK" },
  ],
  CG: [
    { code: "11", name: "states.CG.11" },
    { code: "12", name: "states.CG.12" },
    { code: "13", name: "states.CG.13" },
    { code: "14", name: "states.CG.14" },
    { code: "15", name: "states.CG.15" },
    { code: "16", name: "states.CG.16" },
    { code: "2", name: "states.CG.2" },
    { code: "5", name: "states.CG.5" },
    { code: "7", name: "states.CG.7" },
    { code: "8", name: "states.CG.8" },
    { code: "9", name: "states.CG.9" },
    { code: "BZV", name: "states.CG.BZV" },
  ],
  CH: [
    { code: "AG", name: "states.CH.AG" },
    { code: "AI", name: "states.CH.AI" },
    { code: "AR", name: "states.CH.AR" },
    { code: "BE", name: "states.CH.BE" },
    { code: "BL", name: "states.CH.BL" },
    { code: "BS", name: "states.CH.BS" },
    { code: "FR", name: "states.CH.FR" },
    { code: "GE", name: "states.CH.GE" },
    { code: "GL", name: "states.CH.GL" },
    { code: "GR", name: "states.CH.GR" },
    { code: "JU", name: "states.CH.JU" },
    { code: "LU", name: "states.CH.LU" },
    { code: "NE", name: "states.CH.NE" },
    { code: "NW", name: "states.CH.NW" },
    { code: "OW", name: "states.CH.OW" },
    { code: "SG", name: "states.CH.SG" },
    { code: "SH", name: "states.CH.SH" },
    { code: "SO", name: "states.CH.SO" },
    { code: "SZ", name: "states.CH.SZ" },
    { code: "TG", name: "states.CH.TG" },
    { code: "TI", name: "states.CH.TI" },
    { code: "UR", name: "states.CH.UR" },
    { code: "VD", name: "states.CH.VD" },
    { code: "VS", name: "states.CH.VS" },
    { code: "ZG", name: "states.CH.ZG" },
    { code: "ZH", name: "states.CH.ZH" },
  ],
  CI: [
    { code: "01", name: "states.CI.01" },
    { code: "02", name: "states.CI.02" },
    { code: "03", name: "states.CI.03" },
    { code: "04", name: "states.CI.04" },
    { code: "05", name: "states.CI.05" },
    { code: "06", name: "states.CI.06" },
    { code: "07", name: "states.CI.07" },
    { code: "09", name: "states.CI.09" },
    { code: "10", name: "states.CI.10" },
    { code: "11", name: "states.CI.11" },
    { code: "12", name: "states.CI.12" },
    { code: "13", name: "states.CI.13" },
    { code: "14", name: "states.CI.14" },
    { code: "15", name: "states.CI.15" },
    { code: "16", name: "states.CI.16" },
    { code: "17", name: "states.CI.17" },
    { code: "18", name: "states.CI.18" },
    { code: "19", name: "states.CI.19" },
    { code: "AB", name: "states.CI.AB" },
    { code: "BS", name: "states.CI.BS" },
    { code: "CM", name: "states.CI.CM" },
    { code: "DN", name: "states.CI.DN" },
    { code: "GD", name: "states.CI.GD" },
    { code: "LC", name: "states.CI.LC" },
    { code: "LG", name: "states.CI.LG" },
    { code: "MG", name: "states.CI.MG" },
    { code: "SM", name: "states.CI.SM" },
    { code: "VB", name: "states.CI.VB" },
    { code: "WR", name: "states.CI.WR" },
    { code: "YM", name: "states.CI.YM" },
    { code: "ZZ", name: "states.CI.ZZ" },
  ],
  CL: [
    { code: "AI", name: "states.CL.AI" },
    { code: "AN", name: "states.CL.AN" },
    { code: "AP", name: "states.CL.AP" },
    { code: "AR", name: "states.CL.AR" },
    { code: "AT", name: "states.CL.AT" },
    { code: "BI", name: "states.CL.BI" },
    { code: "CO", name: "states.CL.CO" },
    { code: "LI", name: "states.CL.LI" },
    { code: "LL", name: "states.CL.LL" },
    { code: "LR", name: "states.CL.LR" },
    { code: "MA", name: "states.CL.MA" },
    { code: "ML", name: "states.CL.ML" },
    { code: "NB", name: "states.CL.NB" },
    { code: "RM", name: "states.CL.RM" },
    { code: "TA", name: "states.CL.TA" },
    { code: "VS", name: "states.CL.VS" },
  ],
  CM: [
    { code: "AD", name: "states.CM.AD" },
    { code: "CE", name: "states.CM.CE" },
    { code: "EN", name: "states.CM.EN" },
    { code: "ES", name: "states.CM.ES" },
    { code: "LT", name: "states.CM.LT" },
    { code: "NO", name: "states.CM.NO" },
    { code: "NW", name: "states.CM.NW" },
    { code: "OU", name: "states.CM.OU" },
    { code: "SU", name: "states.CM.SU" },
    { code: "SW", name: "states.CM.SW" },
  ],
  CN: [
    { code: "AH", name: "states.CN.AH" },
    { code: "BJ", name: "states.CN.BJ" },
    { code: "CQ", name: "states.CN.CQ" },
    { code: "FJ", name: "states.CN.FJ" },
    { code: "GD", name: "states.CN.GD" },
    { code: "GS", name: "states.CN.GS" },
    { code: "GX", name: "states.CN.GX" },
    { code: "GZ", name: "states.CN.GZ" },
    { code: "HA", name: "states.CN.HA" },
    { code: "HB", name: "states.CN.HB" },
    { code: "HE", name: "states.CN.HE" },
    { code: "HI", name: "states.CN.HI" },
    { code: "HK", name: "states.CN.HK" },
    { code: "HL", name: "states.CN.HL" },
    { code: "HN", name: "states.CN.HN" },
    { code: "JL", name: "states.CN.JL" },
    { code: "JS", name: "states.CN.JS" },
    { code: "JX", name: "states.CN.JX" },
    { code: "LN", name: "states.CN.LN" },
    { code: "MO", name: "states.CN.MO" },
    { code: "NM", name: "states.CN.NM" },
    { code: "NX", name: "states.CN.NX" },
    { code: "QH", name: "states.CN.QH" },
    { code: "SC", name: "states.CN.SC" },
    { code: "SD", name: "states.CN.SD" },
    { code: "SH", name: "states.CN.SH" },
    { code: "SN", name: "states.CN.SN" },
    { code: "SX", name: "states.CN.SX" },
    { code: "TJ", name: "states.CN.TJ" },
    { code: "TW", name: "states.CN.TW" },
    { code: "XJ", name: "states.CN.XJ" },
    { code: "XZ", name: "states.CN.XZ" },
    { code: "YN", name: "states.CN.YN" },
    { code: "ZJ", name: "states.CN.ZJ" },
  ],
  CO: [
    { code: "AMA", name: "states.CO.AMA" },
    { code: "ANT", name: "states.CO.ANT" },
    { code: "ARA", name: "states.CO.ARA" },
    { code: "ATL", name: "states.CO.ATL" },
    { code: "BOL", name: "states.CO.BOL" },
    { code: "BOY", name: "states.CO.BOY" },
    { code: "CAL", name: "states.CO.CAL" },
    { code: "CAQ", name: "states.CO.CAQ" },
    { code: "CAS", name: "states.CO.CAS" },
    { code: "CAU", name: "states.CO.CAU" },
    { code: "CES", name: "states.CO.CES" },
    { code: "CHO", name: "states.CO.CHO" },
    { code: "COR", name: "states.CO.COR" },
    { code: "CUN", name: "states.CO.CUN" },
    { code: "DC", name: "states.CO.DC" },
    { code: "GUA", name: "states.CO.GUA" },
    { code: "GUV", name: "states.CO.GUV" },
    { code: "HUI", name: "states.CO.HUI" },
    { code: "LAG", name: "states.CO.LAG" },
    { code: "MAG", name: "states.CO.MAG" },
    { code: "MET", name: "states.CO.MET" },
    { code: "NAR", name: "states.CO.NAR" },
    { code: "NSA", name: "states.CO.NSA" },
    { code: "PUT", name: "states.CO.PUT" },
    { code: "QUI", name: "states.CO.QUI" },
    { code: "RIS", name: "states.CO.RIS" },
    { code: "SAN", name: "states.CO.SAN" },
    { code: "SAP", name: "states.CO.SAP" },
    { code: "SUC", name: "states.CO.SUC" },
    { code: "TOL", name: "states.CO.TOL" },
    { code: "VAC", name: "states.CO.VAC" },
    { code: "VAU", name: "states.CO.VAU" },
    { code: "VID", name: "states.CO.VID" },
  ],
  CR: [
    { code: "A", name: "states.CR.A" },
    { code: "C", name: "states.CR.C" },
    { code: "G", name: "states.CR.G" },
    { code: "H", name: "states.CR.H" },
    { code: "L", name: "states.CR.L" },
    { code: "P", name: "states.CR.P" },
    { code: "SJ", name: "states.CR.SJ" },
  ],
  CU: [
    { code: "01", name: "states.CU.01" },
    { code: "03", name: "states.CU.03" },
    { code: "04", name: "states.CU.04" },
    { code: "05", name: "states.CU.05" },
    { code: "06", name: "states.CU.06" },
    { code: "07", name: "states.CU.07" },
    { code: "08", name: "states.CU.08" },
    { code: "09", name: "states.CU.09" },
    { code: "10", name: "states.CU.10" },
    { code: "11", name: "states.CU.11" },
    { code: "12", name: "states.CU.12" },
    { code: "13", name: "states.CU.13" },
    { code: "14", name: "states.CU.14" },
    { code: "15", name: "states.CU.15" },
    { code: "16", name: "states.CU.16" },
    { code: "99", name: "states.CU.99" },
  ],
  CV: [
    { code: "B", name: "states.CV.B" },
    { code: "BR", name: "states.CV.BR" },
    { code: "BV", name: "states.CV.BV" },
    { code: "CA", name: "states.CV.CA" },
    { code: "CF", name: "states.CV.CF" },
    { code: "CR", name: "states.CV.CR" },
    { code: "MA", name: "states.CV.MA" },
    { code: "MO", name: "states.CV.MO" },
    { code: "PA", name: "states.CV.PA" },
    { code: "PN", name: "states.CV.PN" },
    { code: "PR", name: "states.CV.PR" },
    { code: "RB", name: "states.CV.RB" },
    { code: "RG", name: "states.CV.RG" },
    { code: "RS", name: "states.CV.RS" },
    { code: "S", name: "states.CV.S" },
    { code: "SD", name: "states.CV.SD" },
    { code: "SF", name: "states.CV.SF" },
    { code: "SL", name: "states.CV.SL" },
    { code: "SM", name: "states.CV.SM" },
    { code: "SO", name: "states.CV.SO" },
    { code: "SV", name: "states.CV.SV" },
    { code: "TA", name: "states.CV.TA" },
    { code: "TS", name: "states.CV.TS" },
  ],
  CY: [
    { code: "01", name: "states.CY.01" },
    { code: "02", name: "states.CY.02" },
    { code: "03", name: "states.CY.03" },
    { code: "04", name: "states.CY.04" },
    { code: "05", name: "states.CY.05" },
    { code: "06", name: "states.CY.06" },
  ],
  CZ: [
    { code: "10", name: "states.CZ.10" },
    { code: "20", name: "states.CZ.20" },
    { code: "201", name: "states.CZ.201" },
    { code: "202", name: "states.CZ.202" },
    { code: "203", name: "states.CZ.203" },
    { code: "204", name: "states.CZ.204" },
    { code: "205", name: "states.CZ.205" },
    { code: "206", name: "states.CZ.206" },
    { code: "207", name: "states.CZ.207" },
    { code: "208", name: "states.CZ.208" },
    { code: "209", name: "states.CZ.209" },
    { code: "20A", name: "states.CZ.20A" },
    { code: "20B", name: "states.CZ.20B" },
    { code: "20C", name: "states.CZ.20C" },
    { code: "31", name: "states.CZ.31" },
    { code: "311", name: "states.CZ.311" },
    { code: "312", name: "states.CZ.312" },
    { code: "313", name: "states.CZ.313" },
    { code: "314", name: "states.CZ.314" },
    { code: "315", name: "states.CZ.315" },
    { code: "316", name: "states.CZ.316" },
    { code: "317", name: "states.CZ.317" },
    { code: "32", name: "states.CZ.32" },
    { code: "321", name: "states.CZ.321" },
    { code: "322", name: "states.CZ.322" },
    { code: "323", name: "states.CZ.323" },
    { code: "324", name: "states.CZ.324" },
    { code: "325", name: "states.CZ.325" },
    { code: "326", name: "states.CZ.326" },
    { code: "327", name: "states.CZ.327" },
    { code: "41", name: "states.CZ.41" },
    { code: "411", name: "states.CZ.411" },
    { code: "412", name: "states.CZ.412" },
    { code: "413", name: "states.CZ.413" },
    { code: "42", name: "states.CZ.42" },
    { code: "421", name: "states.CZ.421" },
    { code: "422", name: "states.CZ.422" },
    { code: "423", name: "states.CZ.423" },
    { code: "424", name: "states.CZ.424" },
    { code: "425", name: "states.CZ.425" },
    { code: "426", name: "states.CZ.426" },
    { code: "427", name: "states.CZ.427" },
    { code: "51", name: "states.CZ.51" },
    { code: "511", name: "states.CZ.511" },
    { code: "512", name: "states.CZ.512" },
    { code: "513", name: "states.CZ.513" },
    { code: "514", name: "states.CZ.514" },
    { code: "52", name: "states.CZ.52" },
    { code: "521", name: "states.CZ.521" },
    { code: "522", name: "states.CZ.522" },
    { code: "523", name: "states.CZ.523" },
    { code: "524", name: "states.CZ.524" },
    { code: "525", name: "states.CZ.525" },
    { code: "53", name: "states.CZ.53" },
    { code: "531", name: "states.CZ.531" },
    { code: "532", name: "states.CZ.532" },
    { code: "533", name: "states.CZ.533" },
    { code: "534", name: "states.CZ.534" },
    { code: "63", name: "states.CZ.63" },
    { code: "631", name: "states.CZ.631" },
    { code: "632", name: "states.CZ.632" },
    { code: "633", name: "states.CZ.633" },
    { code: "634", name: "states.CZ.634" },
    { code: "635", name: "states.CZ.635" },
    { code: "64", name: "states.CZ.64" },
    { code: "641", name: "states.CZ.641" },
    { code: "642", name: "states.CZ.642" },
    { code: "643", name: "states.CZ.643" },
    { code: "644", name: "states.CZ.644" },
    { code: "645", name: "states.CZ.645" },
    { code: "646", name: "states.CZ.646" },
    { code: "647", name: "states.CZ.647" },
    { code: "71", name: "states.CZ.71" },
    { code: "711", name: "states.CZ.711" },
    { code: "712", name: "states.CZ.712" },
    { code: "713", name: "states.CZ.713" },
    { code: "714", name: "states.CZ.714" },
    { code: "715", name: "states.CZ.715" },
    { code: "72", name: "states.CZ.72" },
    { code: "721", name: "states.CZ.721" },
    { code: "722", name: "states.CZ.722" },
    { code: "723", name: "states.CZ.723" },
    { code: "724", name: "states.CZ.724" },
    { code: "80", name: "states.CZ.80" },
    { code: "801", name: "states.CZ.801" },
    { code: "802", name: "states.CZ.802" },
    { code: "803", name: "states.CZ.803" },
    { code: "804", name: "states.CZ.804" },
    { code: "805", name: "states.CZ.805" },
    { code: "806", name: "states.CZ.806" },
  ],
  DE: [
    { code: "BB", name: "states.DE.BB" },
    { code: "BE", name: "states.DE.BE" },
    { code: "BW", name: "states.DE.BW" },
    { code: "BY", name: "states.DE.BY" },
    { code: "HB", name: "states.DE.HB" },
    { code: "HE", name: "states.DE.HE" },
    { code: "HH", name: "states.DE.HH" },
    { code: "MV", name: "states.DE.MV" },
    { code: "NI", name: "states.DE.NI" },
    { code: "NW", name: "states.DE.NW" },
    { code: "RP", name: "states.DE.RP" },
    { code: "SH", name: "states.DE.SH" },
    { code: "SL", name: "states.DE.SL" },
    { code: "SN", name: "states.DE.SN" },
    { code: "ST", name: "states.DE.ST" },
    { code: "TH", name: "states.DE.TH" },
  ],
  DJ: [
    { code: "AR", name: "states.DJ.AR" },
    { code: "AS", name: "states.DJ.AS" },
    { code: "DI", name: "states.DJ.DI" },
    { code: "DJ", name: "states.DJ.DJ" },
    { code: "OB", name: "states.DJ.OB" },
    { code: "TA", name: "states.DJ.TA" },
  ],
  DK: [
    { code: "81", name: "states.DK.81" },
    { code: "82", name: "states.DK.82" },
    { code: "83", name: "states.DK.83" },
    { code: "84", name: "states.DK.84" },
    { code: "85", name: "states.DK.85" },
  ],
  DM: [
    { code: "02", name: "states.DM.02" },
    { code: "03", name: "states.DM.03" },
    { code: "04", name: "states.DM.04" },
    { code: "05", name: "states.DM.05" },
    { code: "06", name: "states.DM.06" },
    { code: "07", name: "states.DM.07" },
    { code: "08", name: "states.DM.08" },
    { code: "09", name: "states.DM.09" },
    { code: "10", name: "states.DM.10" },
    { code: "11", name: "states.DM.11" },
  ],
  DO: [
    { code: "01", name: "states.DO.01" },
    { code: "02", name: "states.DO.02" },
    { code: "03", name: "states.DO.03" },
    { code: "04", name: "states.DO.04" },
    { code: "05", name: "states.DO.05" },
    { code: "06", name: "states.DO.06" },
    { code: "08", name: "states.DO.08" },
    { code: "09", name: "states.DO.09" },
    { code: "10", name: "states.DO.10" },
    { code: "11", name: "states.DO.11" },
    { code: "12", name: "states.DO.12" },
    { code: "13", name: "states.DO.13" },
    { code: "14", name: "states.DO.14" },
    { code: "15", name: "states.DO.15" },
    { code: "16", name: "states.DO.16" },
    { code: "17", name: "states.DO.17" },
    { code: "18", name: "states.DO.18" },
    { code: "19", name: "states.DO.19" },
    { code: "20", name: "states.DO.20" },
    { code: "21", name: "states.DO.21" },
    { code: "22", name: "states.DO.22" },
    { code: "23", name: "states.DO.23" },
    { code: "24", name: "states.DO.24" },
    { code: "25", name: "states.DO.25" },
    { code: "26", name: "states.DO.26" },
    { code: "27", name: "states.DO.27" },
    { code: "28", name: "states.DO.28" },
    { code: "29", name: "states.DO.29" },
    { code: "30", name: "states.DO.30" },
    { code: "31", name: "states.DO.31" },
    { code: "32", name: "states.DO.32" },
  ],
  DZ: [
    { code: "01", name: "states.DZ.01" },
    { code: "02", name: "states.DZ.02" },
    { code: "03", name: "states.DZ.03" },
    { code: "04", name: "states.DZ.04" },
    { code: "05", name: "states.DZ.05" },
    { code: "06", name: "states.DZ.06" },
    { code: "07", name: "states.DZ.07" },
    { code: "08", name: "states.DZ.08" },
    { code: "09", name: "states.DZ.09" },
    { code: "10", name: "states.DZ.10" },
    { code: "11", name: "states.DZ.11" },
    { code: "12", name: "states.DZ.12" },
    { code: "13", name: "states.DZ.13" },
    { code: "14", name: "states.DZ.14" },
    { code: "15", name: "states.DZ.15" },
    { code: "16", name: "states.DZ.16" },
    { code: "17", name: "states.DZ.17" },
    { code: "18", name: "states.DZ.18" },
    { code: "19", name: "states.DZ.19" },
    { code: "20", name: "states.DZ.20" },
    { code: "21", name: "states.DZ.21" },
    { code: "22", name: "states.DZ.22" },
    { code: "23", name: "states.DZ.23" },
    { code: "24", name: "states.DZ.24" },
    { code: "25", name: "states.DZ.25" },
    { code: "26", name: "states.DZ.26" },
    { code: "27", name: "states.DZ.27" },
    { code: "28", name: "states.DZ.28" },
    { code: "29", name: "states.DZ.29" },
    { code: "30", name: "states.DZ.30" },
    { code: "31", name: "states.DZ.31" },
    { code: "32", name: "states.DZ.32" },
    { code: "33", name: "states.DZ.33" },
    { code: "34", name: "states.DZ.34" },
    { code: "35", name: "states.DZ.35" },
    { code: "36", name: "states.DZ.36" },
    { code: "37", name: "states.DZ.37" },
    { code: "38", name: "states.DZ.38" },
    { code: "39", name: "states.DZ.39" },
    { code: "40", name: "states.DZ.40" },
    { code: "41", name: "states.DZ.41" },
    { code: "42", name: "states.DZ.42" },
    { code: "43", name: "states.DZ.43" },
    { code: "44", name: "states.DZ.44" },
    { code: "45", name: "states.DZ.45" },
    { code: "46", name: "states.DZ.46" },
    { code: "47", name: "states.DZ.47" },
    { code: "48", name: "states.DZ.48" },
    { code: "49", name: "states.DZ.49" },
    { code: "50", name: "states.DZ.50" },
    { code: "51", name: "states.DZ.51" },
    { code: "52", name: "states.DZ.52" },
    { code: "53", name: "states.DZ.53" },
    { code: "54", name: "states.DZ.54" },
    { code: "55", name: "states.DZ.55" },
    { code: "56", name: "states.DZ.56" },
    { code: "57", name: "states.DZ.57" },
    { code: "58", name: "states.DZ.58" },
  ],
  EC: [
    { code: "A", name: "states.EC.A" },
    { code: "B", name: "states.EC.B" },
    { code: "C", name: "states.EC.C" },
    { code: "D", name: "states.EC.D" },
    { code: "E", name: "states.EC.E" },
    { code: "F", name: "states.EC.F" },
    { code: "G", name: "states.EC.G" },
    { code: "H", name: "states.EC.H" },
    { code: "I", name: "states.EC.I" },
    { code: "L", name: "states.EC.L" },
    { code: "M", name: "states.EC.M" },
    { code: "N", name: "states.EC.N" },
    { code: "O", name: "states.EC.O" },
    { code: "P", name: "states.EC.P" },
    { code: "R", name: "states.EC.R" },
    { code: "S", name: "states.EC.S" },
    { code: "SD", name: "states.EC.SD" },
    { code: "SE", name: "states.EC.SE" },
    { code: "T", name: "states.EC.T" },
    { code: "U", name: "states.EC.U" },
    { code: "W", name: "states.EC.W" },
    { code: "X", name: "states.EC.X" },
    { code: "Y", name: "states.EC.Y" },
    { code: "Z", name: "states.EC.Z" },
  ],
  EE: [
    { code: "37", name: "states.EE.37" },
    { code: "39", name: "states.EE.39" },
    { code: "44", name: "states.EE.44" },
    { code: "49", name: "states.EE.49" },
    { code: "51", name: "states.EE.51" },
    { code: "57", name: "states.EE.57" },
    { code: "59", name: "states.EE.59" },
    { code: "65", name: "states.EE.65" },
    { code: "67", name: "states.EE.67" },
    { code: "70", name: "states.EE.70" },
    { code: "74", name: "states.EE.74" },
    { code: "78", name: "states.EE.78" },
    { code: "82", name: "states.EE.82" },
    { code: "84", name: "states.EE.84" },
    { code: "86", name: "states.EE.86" },
  ],
  EG: [
    { code: "ALX", name: "states.EG.ALX" },
    { code: "ASN", name: "states.EG.ASN" },
    { code: "AST", name: "states.EG.AST" },
    { code: "BA", name: "states.EG.BA" },
    { code: "BH", name: "states.EG.BH" },
    { code: "BNS", name: "states.EG.BNS" },
    { code: "C", name: "states.EG.C" },
    { code: "DK", name: "states.EG.DK" },
    { code: "DT", name: "states.EG.DT" },
    { code: "FYM", name: "states.EG.FYM" },
    { code: "GH", name: "states.EG.GH" },
    { code: "GZ", name: "states.EG.GZ" },
    { code: "IS", name: "states.EG.IS" },
    { code: "JS", name: "states.EG.JS" },
    { code: "KB", name: "states.EG.KB" },
    { code: "KFS", name: "states.EG.KFS" },
    { code: "KN", name: "states.EG.KN" },
    { code: "LX", name: "states.EG.LX" },
    { code: "MN", name: "states.EG.MN" },
    { code: "MNF", name: "states.EG.MNF" },
    { code: "MT", name: "states.EG.MT" },
    { code: "PTS", name: "states.EG.PTS" },
    { code: "SHG", name: "states.EG.SHG" },
    { code: "SHR", name: "states.EG.SHR" },
    { code: "SIN", name: "states.EG.SIN" },
    { code: "SUZ", name: "states.EG.SUZ" },
    { code: "WAD", name: "states.EG.WAD" },
  ],
  ER: [
    { code: "AN", name: "states.ER.AN" },
    { code: "DK", name: "states.ER.DK" },
    { code: "DU", name: "states.ER.DU" },
    { code: "GB", name: "states.ER.GB" },
    { code: "MA", name: "states.ER.MA" },
    { code: "SK", name: "states.ER.SK" },
  ],
  ES: [
    { code: "AN", name: "states.ES.AN" },
    { code: "AR", name: "states.ES.AR" },
    { code: "AS", name: "states.ES.AS" },
    { code: "AV", name: "states.ES.AV" },
    { code: "BU", name: "states.ES.BU" },
    { code: "CB", name: "states.ES.CB" },
    { code: "CE", name: "states.ES.CE" },
    { code: "CL", name: "states.ES.CL" },
    { code: "CM", name: "states.ES.CM" },
    { code: "CN", name: "states.ES.CN" },
    { code: "CT", name: "states.ES.CT" },
    { code: "EX", name: "states.ES.EX" },
    { code: "GA", name: "states.ES.GA" },
    { code: "LE", name: "states.ES.LE" },
    { code: "MC", name: "states.ES.MC" },
    { code: "MD", name: "states.ES.MD" },
    { code: "ML", name: "states.ES.ML" },
    { code: "NC", name: "states.ES.NC" },
    { code: "P", name: "states.ES.P" },
    { code: "PM", name: "states.ES.PM" },
    { code: "PV", name: "states.ES.PV" },
    { code: "RI", name: "states.ES.RI" },
    { code: "SA", name: "states.ES.SA" },
    { code: "SG", name: "states.ES.SG" },
    { code: "SO", name: "states.ES.SO" },
    { code: "VA", name: "states.ES.VA" },
    { code: "VC", name: "states.ES.VC" },
    { code: "ZA", name: "states.ES.ZA" },
  ],
  ET: [
    { code: "AA", name: "states.ET.AA" },
    { code: "AF", name: "states.ET.AF" },
    { code: "AM", name: "states.ET.AM" },
    { code: "BE", name: "states.ET.BE" },
    { code: "DD", name: "states.ET.DD" },
    { code: "GA", name: "states.ET.GA" },
    { code: "HA", name: "states.ET.HA" },
    { code: "OR", name: "states.ET.OR" },
    { code: "SN", name: "states.ET.SN" },
    { code: "SO", name: "states.ET.SO" },
    { code: "TI", name: "states.ET.TI" },
  ],
  FI: [
    { code: "01", name: "states.FI.01" },
    { code: "02", name: "states.FI.02" },
    { code: "03", name: "states.FI.03" },
    { code: "04", name: "states.FI.04" },
    { code: "05", name: "states.FI.05" },
    { code: "06", name: "states.FI.06" },
    { code: "07", name: "states.FI.07" },
    { code: "08", name: "states.FI.08" },
    { code: "09", name: "states.FI.09" },
    { code: "11", name: "states.FI.11" },
    { code: "12", name: "states.FI.12" },
    { code: "13", name: "states.FI.13" },
    { code: "14", name: "states.FI.14" },
    { code: "15", name: "states.FI.15" },
    { code: "16", name: "states.FI.16" },
    { code: "17", name: "states.FI.17" },
    { code: "18", name: "states.FI.18" },
    { code: "19", name: "states.FI.19" },
    { code: "IS", name: "states.FI.IS" },
    { code: "LL", name: "states.FI.LL" },
    { code: "OL", name: "states.FI.OL" },
  ],
  FJ: [
    { code: "01", name: "states.FJ.01" },
    { code: "02", name: "states.FJ.02" },
    { code: "03", name: "states.FJ.03" },
    { code: "04", name: "states.FJ.04" },
    { code: "05", name: "states.FJ.05" },
    { code: "06", name: "states.FJ.06" },
    { code: "07", name: "states.FJ.07" },
    { code: "08", name: "states.FJ.08" },
    { code: "09", name: "states.FJ.09" },
    { code: "10", name: "states.FJ.10" },
    { code: "11", name: "states.FJ.11" },
    { code: "12", name: "states.FJ.12" },
    { code: "13", name: "states.FJ.13" },
    { code: "14", name: "states.FJ.14" },
    { code: "C", name: "states.FJ.C" },
    { code: "E", name: "states.FJ.E" },
    { code: "N", name: "states.FJ.N" },
    { code: "R", name: "states.FJ.R" },
    { code: "W", name: "states.FJ.W" },
  ],
  FM: [
    { code: "KSA", name: "states.FM.KSA" },
    { code: "PNI", name: "states.FM.PNI" },
    { code: "TRK", name: "states.FM.TRK" },
    { code: "YAP", name: "states.FM.YAP" },
  ],
  FR: [
    { code: "01", name: "states.FR.01" },
    { code: "02", name: "states.FR.02" },
    { code: "03", name: "states.FR.03" },
    { code: "04", name: "states.FR.04" },
    { code: "05", name: "states.FR.05" },
    { code: "06", name: "states.FR.06" },
    { code: "07", name: "states.FR.07" },
    { code: "08", name: "states.FR.08" },
    { code: "09", name: "states.FR.09" },
    { code: "10", name: "states.FR.10" },
    { code: "11", name: "states.FR.11" },
    { code: "12", name: "states.FR.12" },
    { code: "13", name: "states.FR.13" },
    { code: "14", name: "states.FR.14" },
    { code: "15", name: "states.FR.15" },
    { code: "16", name: "states.FR.16" },
    { code: "17", name: "states.FR.17" },
    { code: "18", name: "states.FR.18" },
    { code: "19", name: "states.FR.19" },
    { code: "20R", name: "states.FR.20R" },
    { code: "21", name: "states.FR.21" },
    { code: "22", name: "states.FR.22" },
    { code: "23", name: "states.FR.23" },
    { code: "24", name: "states.FR.24" },
    { code: "25", name: "states.FR.25" },
    { code: "26", name: "states.FR.26" },
    { code: "27", name: "states.FR.27" },
    { code: "28", name: "states.FR.28" },
    { code: "29", name: "states.FR.29" },
    { code: "2A", name: "states.FR.2A" },
    { code: "2B", name: "states.FR.2B" },
    { code: "30", name: "states.FR.30" },
    { code: "31", name: "states.FR.31" },
    { code: "32", name: "states.FR.32" },
    { code: "33", name: "states.FR.33" },
    { code: "34", name: "states.FR.34" },
    { code: "35", name: "states.FR.35" },
    { code: "36", name: "states.FR.36" },
    { code: "37", name: "states.FR.37" },
    { code: "38", name: "states.FR.38" },
    { code: "39", name: "states.FR.39" },
    { code: "40", name: "states.FR.40" },
    { code: "41", name: "states.FR.41" },
    { code: "42", name: "states.FR.42" },
    { code: "43", name: "states.FR.43" },
    { code: "44", name: "states.FR.44" },
    { code: "45", name: "states.FR.45" },
    { code: "46", name: "states.FR.46" },
    { code: "47", name: "states.FR.47" },
    { code: "48", name: "states.FR.48" },
    { code: "49", name: "states.FR.49" },
    { code: "50", name: "states.FR.50" },
    { code: "51", name: "states.FR.51" },
    { code: "52", name: "states.FR.52" },
    { code: "53", name: "states.FR.53" },
    { code: "54", name: "states.FR.54" },
    { code: "55", name: "states.FR.55" },
    { code: "56", name: "states.FR.56" },
    { code: "57", name: "states.FR.57" },
    { code: "58", name: "states.FR.58" },
    { code: "59", name: "states.FR.59" },
    { code: "60", name: "states.FR.60" },
    { code: "61", name: "states.FR.61" },
    { code: "62", name: "states.FR.62" },
    { code: "63", name: "states.FR.63" },
    { code: "64", name: "states.FR.64" },
    { code: "65", name: "states.FR.65" },
    { code: "66", name: "states.FR.66" },
    { code: "67", name: "states.FR.67" },
    { code: "68", name: "states.FR.68" },
    { code: "69", name: "states.FR.69" },
    { code: "69M", name: "states.FR.69M" },
    { code: "6AE", name: "states.FR.6AE" },
    { code: "70", name: "states.FR.70" },
    { code: "71", name: "states.FR.71" },
    { code: "72", name: "states.FR.72" },
    { code: "73", name: "states.FR.73" },
    { code: "74", name: "states.FR.74" },
    { code: "75C", name: "states.FR.75C" },
    { code: "76", name: "states.FR.76" },
    { code: "77", name: "states.FR.77" },
    { code: "78", name: "states.FR.78" },
    { code: "79", name: "states.FR.79" },
    { code: "80", name: "states.FR.80" },
    { code: "81", name: "states.FR.81" },
    { code: "82", name: "states.FR.82" },
    { code: "83", name: "states.FR.83" },
    { code: "84", name: "states.FR.84" },
    { code: "85", name: "states.FR.85" },
    { code: "86", name: "states.FR.86" },
    { code: "87", name: "states.FR.87" },
    { code: "88", name: "states.FR.88" },
    { code: "89", name: "states.FR.89" },
    { code: "90", name: "states.FR.90" },
    { code: "91", name: "states.FR.91" },
    { code: "92", name: "states.FR.92" },
    { code: "93", name: "states.FR.93" },
    { code: "94", name: "states.FR.94" },
    { code: "95", name: "states.FR.95" },
    { code: "971", name: "states.FR.971" },
    { code: "972", name: "states.FR.972" },
    { code: "973", name: "states.FR.973" },
    { code: "974", name: "states.FR.974" },
    { code: "976", name: "states.FR.976" },
    { code: "ARA", name: "states.FR.ARA" },
    { code: "BFC", name: "states.FR.BFC" },
    { code: "BL", name: "states.FR.BL" },
    { code: "BRE", name: "states.FR.BRE" },
    { code: "CP", name: "states.FR.CP" },
    { code: "CVL", name: "states.FR.CVL" },
    { code: "GES", name: "states.FR.GES" },
    { code: "HDF", name: "states.FR.HDF" },
    { code: "IDF", name: "states.FR.IDF" },
    { code: "MF", name: "states.FR.MF" },
    { code: "NAQ", name: "states.FR.NAQ" },
    { code: "NOR", name: "states.FR.NOR" },
    { code: "OCC", name: "states.FR.OCC" },
    { code: "PAC", name: "states.FR.PAC" },
    { code: "PDL", name: "states.FR.PDL" },
    { code: "PF", name: "states.FR.PF" },
    { code: "PM", name: "states.FR.PM" },
    { code: "TF", name: "states.FR.TF" },
    { code: "WF", name: "states.FR.WF" },
  ],
  GA: [
    { code: "1", name: "states.GA.1" },
    { code: "2", name: "states.GA.2" },
    { code: "3", name: "states.GA.3" },
    { code: "4", name: "states.GA.4" },
    { code: "5", name: "states.GA.5" },
    { code: "6", name: "states.GA.6" },
    { code: "7", name: "states.GA.7" },
    { code: "8", name: "states.GA.8" },
    { code: "9", name: "states.GA.9" },
  ],
  GB: [
    { code: "ABC", name: "states.GB.ABC" },
    { code: "ABD", name: "states.GB.ABD" },
    { code: "ABE", name: "states.GB.ABE" },
    { code: "AGB", name: "states.GB.AGB" },
    { code: "AND", name: "states.GB.AND" },
    { code: "ANN", name: "states.GB.ANN" },
    { code: "ANS", name: "states.GB.ANS" },
    { code: "ANT", name: "states.GB.ANT" },
    { code: "ARD", name: "states.GB.ARD" },
    { code: "ARM", name: "states.GB.ARM" },
    { code: "BAS", name: "states.GB.BAS" },
    { code: "BBD", name: "states.GB.BBD" },
    { code: "BDF", name: "states.GB.BDF" },
    { code: "BDG", name: "states.GB.BDG" },
    { code: "BEN", name: "states.GB.BEN" },
    { code: "BEX", name: "states.GB.BEX" },
    { code: "BFS", name: "states.GB.BFS" },
    { code: "BGE", name: "states.GB.BGE" },
    { code: "BGW", name: "states.GB.BGW" },
    { code: "BIR", name: "states.GB.BIR" },
    { code: "BKM", name: "states.GB.BKM" },
    { code: "BLA", name: "states.GB.BLA" },
    { code: "BLY", name: "states.GB.BLY" },
    { code: "BMH", name: "states.GB.BMH" },
    { code: "BNB", name: "states.GB.BNB" },
    { code: "BNE", name: "states.GB.BNE" },
    { code: "BNH", name: "states.GB.BNH" },
    { code: "BNS", name: "states.GB.BNS" },
    { code: "BOL", name: "states.GB.BOL" },
    { code: "BPL", name: "states.GB.BPL" },
    { code: "BRC", name: "states.GB.BRC" },
    { code: "BRD", name: "states.GB.BRD" },
    { code: "BRY", name: "states.GB.BRY" },
    { code: "BST", name: "states.GB.BST" },
    { code: "BUR", name: "states.GB.BUR" },
    { code: "CAM", name: "states.GB.CAM" },
    { code: "CAY", name: "states.GB.CAY" },
    { code: "CBF", name: "states.GB.CBF" },
    { code: "CCG", name: "states.GB.CCG" },
    { code: "CGN", name: "states.GB.CGN" },
    { code: "CGV", name: "states.GB.CGV" },
    { code: "CHE", name: "states.GB.CHE" },
    { code: "CHW", name: "states.GB.CHW" },
    { code: "CKF", name: "states.GB.CKF" },
    { code: "CKT", name: "states.GB.CKT" },
    { code: "CLD", name: "states.GB.CLD" },
    { code: "CLK", name: "states.GB.CLK" },
    { code: "CLR", name: "states.GB.CLR" },
    { code: "CMA", name: "states.GB.CMA" },
    { code: "CMD", name: "states.GB.CMD" },
    { code: "CMN", name: "states.GB.CMN" },
    { code: "CON", name: "states.GB.CON" },
    { code: "COV", name: "states.GB.COV" },
    { code: "CRF", name: "states.GB.CRF" },
    { code: "CRY", name: "states.GB.CRY" },
    { code: "CSR", name: "states.GB.CSR" },
    { code: "CWY", name: "states.GB.CWY" },
    { code: "DAL", name: "states.GB.DAL" },
    { code: "DBY", name: "states.GB.DBY" },
    { code: "DEN", name: "states.GB.DEN" },
    { code: "DER", name: "states.GB.DER" },
    { code: "DEV", name: "states.GB.DEV" },
    { code: "DGN", name: "states.GB.DGN" },
    { code: "DGY", name: "states.GB.DGY" },
    { code: "DNC", name: "states.GB.DNC" },
    { code: "DND", name: "states.GB.DND" },
    { code: "DOR", name: "states.GB.DOR" },
    { code: "DOW", name: "states.GB.DOW" },
    { code: "DRS", name: "states.GB.DRS" },
    { code: "DRY", name: "states.GB.DRY" },
    { code: "DUD", name: "states.GB.DUD" },
    { code: "DUR", name: "states.GB.DUR" },
    { code: "EAL", name: "states.GB.EAL" },
    { code: "EAY", name: "states.GB.EAY" },
    { code: "EDH", name: "states.GB.EDH" },
    { code: "EDU", name: "states.GB.EDU" },
    { code: "ELN", name: "states.GB.ELN" },
    { code: "ELS", name: "states.GB.ELS" },
    { code: "ENF", name: "states.GB.ENF" },
    { code: "ENG", name: "states.GB.ENG" },
    { code: "ERW", name: "states.GB.ERW" },
    { code: "ERY", name: "states.GB.ERY" },
    { code: "ESS", name: "states.GB.ESS" },
    { code: "ESX", name: "states.GB.ESX" },
    { code: "FAL", name: "states.GB.FAL" },
    { code: "FER", name: "states.GB.FER" },
    { code: "FIF", name: "states.GB.FIF" },
    { code: "FLN", name: "states.GB.FLN" },
    { code: "FMO", name: "states.GB.FMO" },
    { code: "GAT", name: "states.GB.GAT" },
    { code: "GLG", name: "states.GB.GLG" },
    { code: "GLS", name: "states.GB.GLS" },
    { code: "GRE", name: "states.GB.GRE" },
    { code: "GWN", name: "states.GB.GWN" },
    { code: "HAL", name: "states.GB.HAL" },
    { code: "HAM", name: "states.GB.HAM" },
    { code: "HAV", name: "states.GB.HAV" },
    { code: "HCK", name: "states.GB.HCK" },
    { code: "HEF", name: "states.GB.HEF" },
    { code: "HIL", name: "states.GB.HIL" },
    { code: "HLD", name: "states.GB.HLD" },
    { code: "HMF", name: "states.GB.HMF" },
    { code: "HNS", name: "states.GB.HNS" },
    { code: "HPL", name: "states.GB.HPL" },
    { code: "HRT", name: "states.GB.HRT" },
    { code: "HRW", name: "states.GB.HRW" },
    { code: "HRY", name: "states.GB.HRY" },
    { code: "IOS", name: "states.GB.IOS" },
    { code: "IOW", name: "states.GB.IOW" },
    { code: "ISL", name: "states.GB.ISL" },
    { code: "IVC", name: "states.GB.IVC" },
    { code: "KEC", name: "states.GB.KEC" },
    { code: "KEN", name: "states.GB.KEN" },
    { code: "KHL", name: "states.GB.KHL" },
    { code: "KIR", name: "states.GB.KIR" },
    { code: "KTT", name: "states.GB.KTT" },
    { code: "KWL", name: "states.GB.KWL" },
    { code: "LAN", name: "states.GB.LAN" },
    { code: "LBC", name: "states.GB.LBC" },
    { code: "LBH", name: "states.GB.LBH" },
    { code: "LCE", name: "states.GB.LCE" },
    { code: "LDS", name: "states.GB.LDS" },
    { code: "LEC", name: "states.GB.LEC" },
    { code: "LEW", name: "states.GB.LEW" },
    { code: "LIN", name: "states.GB.LIN" },
    { code: "LIV", name: "states.GB.LIV" },
    { code: "LMV", name: "states.GB.LMV" },
    { code: "LND", name: "states.GB.LND" },
    { code: "LRN", name: "states.GB.LRN" },
    { code: "LSB", name: "states.GB.LSB" },
    { code: "MAN", name: "states.GB.MAN" },
    { code: "MDB", name: "states.GB.MDB" },
    { code: "MDW", name: "states.GB.MDW" },
    { code: "MEA", name: "states.GB.MEA" },
    { code: "MFT", name: "states.GB.MFT" },
    { code: "MIK", name: "states.GB.MIK" },
    { code: "MLN", name: "states.GB.MLN" },
    { code: "MON", name: "states.GB.MON" },
    { code: "MRT", name: "states.GB.MRT" },
    { code: "MRY", name: "states.GB.MRY" },
    { code: "MTY", name: "states.GB.MTY" },
    { code: "MUL", name: "states.GB.MUL" },
    { code: "MYL", name: "states.GB.MYL" },
    { code: "NAY", name: "states.GB.NAY" },
    { code: "NBL", name: "states.GB.NBL" },
    { code: "NDN", name: "states.GB.NDN" },
    { code: "NEL", name: "states.GB.NEL" },
    { code: "NET", name: "states.GB.NET" },
    { code: "NFK", name: "states.GB.NFK" },
    { code: "NGM", name: "states.GB.NGM" },
    { code: "NIR", name: "states.GB.NIR" },
    { code: "NLK", name: "states.GB.NLK" },
    { code: "NLN", name: "states.GB.NLN" },
    { code: "NMD", name: "states.GB.NMD" },
    { code: "NSM", name: "states.GB.NSM" },
    { code: "NTA", name: "states.GB.NTA" },
    { code: "NTH", name: "states.GB.NTH" },
    { code: "NTL", name: "states.GB.NTL" },
    { code: "NTT", name: "states.GB.NTT" },
    { code: "NTY", name: "states.GB.NTY" },
    { code: "NWM", name: "states.GB.NWM" },
    { code: "NWP", name: "states.GB.NWP" },
    { code: "NYK", name: "states.GB.NYK" },
    { code: "NYM", name: "states.GB.NYM" },
    { code: "OLD", name: "states.GB.OLD" },
    { code: "OMH", name: "states.GB.OMH" },
    { code: "ORK", name: "states.GB.ORK" },
    { code: "OXF", name: "states.GB.OXF" },
    { code: "PEM", name: "states.GB.PEM" },
    { code: "PKN", name: "states.GB.PKN" },
    { code: "PLY", name: "states.GB.PLY" },
    { code: "POL", name: "states.GB.POL" },
    { code: "POR", name: "states.GB.POR" },
    { code: "POW", name: "states.GB.POW" },
    { code: "PTE", name: "states.GB.PTE" },
    { code: "RCC", name: "states.GB.RCC" },
    { code: "RCH", name: "states.GB.RCH" },
    { code: "RCT", name: "states.GB.RCT" },
    { code: "RDB", name: "states.GB.RDB" },
    { code: "RDG", name: "states.GB.RDG" },
    { code: "RFW", name: "states.GB.RFW" },
    { code: "RIC", name: "states.GB.RIC" },
    { code: "ROT", name: "states.GB.ROT" },
    { code: "RUT", name: "states.GB.RUT" },
    { code: "SAW", name: "states.GB.SAW" },
    { code: "SAY", name: "states.GB.SAY" },
    { code: "SCB", name: "states.GB.SCB" },
    { code: "SCT", name: "states.GB.SCT" },
    { code: "SFK", name: "states.GB.SFK" },
    { code: "SFT", name: "states.GB.SFT" },
    { code: "SGC", name: "states.GB.SGC" },
    { code: "SH-AC", name: "states.GB.SH-AC" },
    { code: "SH-HL", name: "states.GB.SH-HL" },
    { code: "SHF", name: "states.GB.SHF" },
    { code: "SHN", name: "states.GB.SHN" },
    { code: "SHR", name: "states.GB.SHR" },
    { code: "SKP", name: "states.GB.SKP" },
    { code: "SLF", name: "states.GB.SLF" },
    { code: "SLG", name: "states.GB.SLG" },
    { code: "SLK", name: "states.GB.SLK" },
    { code: "SND", name: "states.GB.SND" },
    { code: "SOL", name: "states.GB.SOL" },
    { code: "SOM", name: "states.GB.SOM" },
    { code: "SOS", name: "states.GB.SOS" },
    { code: "SRY", name: "states.GB.SRY" },
    { code: "STB", name: "states.GB.STB" },
    { code: "STE", name: "states.GB.STE" },
    { code: "STG", name: "states.GB.STG" },
    { code: "STH", name: "states.GB.STH" },
    { code: "STN", name: "states.GB.STN" },
    { code: "STS", name: "states.GB.STS" },
    { code: "STT", name: "states.GB.STT" },
    { code: "STY", name: "states.GB.STY" },
    { code: "SWA", name: "states.GB.SWA" },
    { code: "SWD", name: "states.GB.SWD" },
    { code: "SWK", name: "states.GB.SWK" },
    { code: "TAM", name: "states.GB.TAM" },
    { code: "TFW", name: "states.GB.TFW" },
    { code: "THR", name: "states.GB.THR" },
    { code: "TOB", name: "states.GB.TOB" },
    { code: "TOF", name: "states.GB.TOF" },
    { code: "TRF", name: "states.GB.TRF" },
    { code: "TWH", name: "states.GB.TWH" },
    { code: "UKM", name: "states.GB.UKM" },
    { code: "VGL", name: "states.GB.VGL" },
    { code: "WAR", name: "states.GB.WAR" },
    { code: "WBK", name: "states.GB.WBK" },
    { code: "WDU", name: "states.GB.WDU" },
    { code: "WFT", name: "states.GB.WFT" },
    { code: "WGN", name: "states.GB.WGN" },
    { code: "WIL", name: "states.GB.WIL" },
    { code: "WKF", name: "states.GB.WKF" },
    { code: "WLL", name: "states.GB.WLL" },
    { code: "WLN", name: "states.GB.WLN" },
    { code: "WLS", name: "states.GB.WLS" },
    { code: "WLV", name: "states.GB.WLV" },
    { code: "WND", name: "states.GB.WND" },
    { code: "WNM", name: "states.GB.WNM" },
    { code: "WOK", name: "states.GB.WOK" },
    { code: "WOR", name: "states.GB.WOR" },
    { code: "WRL", name: "states.GB.WRL" },
    { code: "WRT", name: "states.GB.WRT" },
    { code: "WRX", name: "states.GB.WRX" },
    { code: "WSM", name: "states.GB.WSM" },
    { code: "WSX", name: "states.GB.WSX" },
    { code: "YOR", name: "states.GB.YOR" },
    { code: "ZET", name: "states.GB.ZET" },
  ],
  GD: [
    { code: "01", name: "states.GD.01" },
    { code: "02", name: "states.GD.02" },
    { code: "03", name: "states.GD.03" },
    { code: "04", name: "states.GD.04" },
    { code: "05", name: "states.GD.05" },
    { code: "06", name: "states.GD.06" },
    { code: "10", name: "states.GD.10" },
  ],
  GE: [
    { code: "29", name: "states.GE.29" },
    { code: "50", name: "states.GE.50" },
    { code: "AB", name: "states.GE.AB" },
    { code: "AJ", name: "states.GE.AJ" },
    { code: "GU", name: "states.GE.GU" },
    { code: "IM", name: "states.GE.IM" },
    { code: "KA", name: "states.GE.KA" },
    { code: "KK", name: "states.GE.KK" },
    { code: "MM", name: "states.GE.MM" },
    { code: "RL", name: "states.GE.RL" },
    { code: "SJ", name: "states.GE.SJ" },
    { code: "SK", name: "states.GE.SK" },
    { code: "SZ", name: "states.GE.SZ" },
    { code: "TB", name: "states.GE.TB" },
  ],
  GH: [
    { code: "AA", name: "states.GH.AA" },
    { code: "AF", name: "states.GH.AF" },
    { code: "AH", name: "states.GH.AH" },
    { code: "BE", name: "states.GH.BE" },
    { code: "BO", name: "states.GH.BO" },
    { code: "CP", name: "states.GH.CP" },
    { code: "EP", name: "states.GH.EP" },
    { code: "NE", name: "states.GH.NE" },
    { code: "NP", name: "states.GH.NP" },
    { code: "OT", name: "states.GH.OT" },
    { code: "SV", name: "states.GH.SV" },
    { code: "TV", name: "states.GH.TV" },
    { code: "UE", name: "states.GH.UE" },
    { code: "UW", name: "states.GH.UW" },
    { code: "WN", name: "states.GH.WN" },
    { code: "WP", name: "states.GH.WP" },
  ],
  GM: [
    { code: "B", name: "states.GM.B" },
    { code: "L", name: "states.GM.L" },
    { code: "M", name: "states.GM.M" },
    { code: "N", name: "states.GM.N" },
    { code: "U", name: "states.GM.U" },
    { code: "W", name: "states.GM.W" },
  ],
  GN: [
    { code: "B", name: "states.GN.B" },
    { code: "BE", name: "states.GN.BE" },
    { code: "BF", name: "states.GN.BF" },
    { code: "BK", name: "states.GN.BK" },
    { code: "C", name: "states.GN.C" },
    { code: "CO", name: "states.GN.CO" },
    { code: "D", name: "states.GN.D" },
    { code: "DB", name: "states.GN.DB" },
    { code: "DI", name: "states.GN.DI" },
    { code: "DL", name: "states.GN.DL" },
    { code: "DU", name: "states.GN.DU" },
    { code: "FA", name: "states.GN.FA" },
    { code: "FO", name: "states.GN.FO" },
    { code: "FR", name: "states.GN.FR" },
    { code: "GA", name: "states.GN.GA" },
    { code: "GU", name: "states.GN.GU" },
    { code: "K", name: "states.GN.K" },
    { code: "KA", name: "states.GN.KA" },
    { code: "KB", name: "states.GN.KB" },
    { code: "KD", name: "states.GN.KD" },
    { code: "KE", name: "states.GN.KE" },
    { code: "KN", name: "states.GN.KN" },
    { code: "KO", name: "states.GN.KO" },
    { code: "KS", name: "states.GN.KS" },
    { code: "L", name: "states.GN.L" },
    { code: "LA", name: "states.GN.LA" },
    { code: "LE", name: "states.GN.LE" },
    { code: "LO", name: "states.GN.LO" },
    { code: "M", name: "states.GN.M" },
    { code: "MC", name: "states.GN.MC" },
    { code: "MD", name: "states.GN.MD" },
    { code: "ML", name: "states.GN.ML" },
    { code: "MM", name: "states.GN.MM" },
    { code: "N", name: "states.GN.N" },
    { code: "NZ", name: "states.GN.NZ" },
    { code: "PI", name: "states.GN.PI" },
    { code: "SI", name: "states.GN.SI" },
    { code: "TE", name: "states.GN.TE" },
    { code: "TO", name: "states.GN.TO" },
    { code: "YO", name: "states.GN.YO" },
  ],
  GQ: [
    { code: "AN", name: "states.GQ.AN" },
    { code: "BN", name: "states.GQ.BN" },
    { code: "BS", name: "states.GQ.BS" },
    { code: "C", name: "states.GQ.C" },
    { code: "CS", name: "states.GQ.CS" },
    { code: "I", name: "states.GQ.I" },
    { code: "KN", name: "states.GQ.KN" },
    { code: "LI", name: "states.GQ.LI" },
    { code: "WN", name: "states.GQ.WN" },
  ],
  GR: [
    { code: "01", name: "states.GR.01" },
    { code: "03", name: "states.GR.03" },
    { code: "04", name: "states.GR.04" },
    { code: "06", name: "states.GR.06" },
    { code: "11", name: "states.GR.11" },
    { code: "12", name: "states.GR.12" },
    { code: "13", name: "states.GR.13" },
    { code: "15", name: "states.GR.15" },
    { code: "16", name: "states.GR.16" },
    { code: "22", name: "states.GR.22" },
    { code: "23", name: "states.GR.23" },
    { code: "24", name: "states.GR.24" },
    { code: "33", name: "states.GR.33" },
    { code: "34", name: "states.GR.34" },
    { code: "41", name: "states.GR.41" },
    { code: "42", name: "states.GR.42" },
    { code: "51", name: "states.GR.51" },
    { code: "52", name: "states.GR.52" },
    { code: "53", name: "states.GR.53" },
    { code: "54", name: "states.GR.54" },
    { code: "56", name: "states.GR.56" },
    { code: "57", name: "states.GR.57" },
    { code: "58", name: "states.GR.58" },
    { code: "59", name: "states.GR.59" },
    { code: "62", name: "states.GR.62" },
    { code: "94", name: "states.GR.94" },
    { code: "A", name: "states.GR.A" },
    { code: "A2", name: "states.GR.A2" },
    { code: "B", name: "states.GR.B" },
    { code: "C", name: "states.GR.C" },
    { code: "D", name: "states.GR.D" },
    { code: "F", name: "states.GR.F" },
    { code: "G", name: "states.GR.G" },
    { code: "H", name: "states.GR.H" },
    { code: "I", name: "states.GR.I" },
    { code: "J", name: "states.GR.J" },
    { code: "L", name: "states.GR.L" },
    { code: "M", name: "states.GR.M" },
  ],
  GT: [
    { code: "AV", name: "states.GT.AV" },
    { code: "BV", name: "states.GT.BV" },
    { code: "CM", name: "states.GT.CM" },
    { code: "CQ", name: "states.GT.CQ" },
    { code: "ES", name: "states.GT.ES" },
    { code: "GU", name: "states.GT.GU" },
    { code: "HU", name: "states.GT.HU" },
    { code: "IZ", name: "states.GT.IZ" },
    { code: "JA", name: "states.GT.JA" },
    { code: "JU", name: "states.GT.JU" },
    { code: "PE", name: "states.GT.PE" },
    { code: "PR", name: "states.GT.PR" },
    { code: "QC", name: "states.GT.QC" },
    { code: "QZ", name: "states.GT.QZ" },
    { code: "RE", name: "states.GT.RE" },
    { code: "SA", name: "states.GT.SA" },
    { code: "SM", name: "states.GT.SM" },
    { code: "SO", name: "states.GT.SO" },
    { code: "SR", name: "states.GT.SR" },
    { code: "SU", name: "states.GT.SU" },
    { code: "TO", name: "states.GT.TO" },
  ],
  GW: [
    { code: "BA", name: "states.GW.BA" },
    { code: "BL", name: "states.GW.BL" },
    { code: "BM", name: "states.GW.BM" },
    { code: "CA", name: "states.GW.CA" },
    { code: "GA", name: "states.GW.GA" },
    { code: "L", name: "states.GW.L" },
    { code: "N", name: "states.GW.N" },
    { code: "OI", name: "states.GW.OI" },
    { code: "QU", name: "states.GW.QU" },
    { code: "S", name: "states.GW.S" },
    { code: "TO", name: "states.GW.TO" },
  ],
  GY: [
    { code: "BA", name: "states.GY.BA" },
    { code: "CU", name: "states.GY.CU" },
    { code: "DE", name: "states.GY.DE" },
    { code: "EB", name: "states.GY.EB" },
    { code: "ES", name: "states.GY.ES" },
    { code: "MA", name: "states.GY.MA" },
    { code: "PM", name: "states.GY.PM" },
    { code: "PT", name: "states.GY.PT" },
    { code: "UD", name: "states.GY.UD" },
    { code: "UT", name: "states.GY.UT" },
  ],
  HK: [
    { code: "HCW", name: "states.HK.HCW" },
    { code: "HEA", name: "states.HK.HEA" },
    { code: "HSO", name: "states.HK.HSO" },
    { code: "HWC", name: "states.HK.HWC" },
    { code: "KKC", name: "states.HK.KKC" },
    { code: "KKT", name: "states.HK.KKT" },
    { code: "KSS", name: "states.HK.KSS" },
    { code: "KWT", name: "states.HK.KWT" },
    { code: "KYT", name: "states.HK.KYT" },
    { code: "NIS", name: "states.HK.NIS" },
    { code: "NKT", name: "states.HK.NKT" },
    { code: "NNO", name: "states.HK.NNO" },
    { code: "NSK", name: "states.HK.NSK" },
    { code: "NST", name: "states.HK.NST" },
    { code: "NTM", name: "states.HK.NTM" },
    { code: "NTW", name: "states.HK.NTW" },
    { code: "NYL", name: "states.HK.NYL" },
  ],
  HN: [
    { code: "AT", name: "states.HN.AT" },
    { code: "CH", name: "states.HN.CH" },
    { code: "CL", name: "states.HN.CL" },
    { code: "CM", name: "states.HN.CM" },
    { code: "CP", name: "states.HN.CP" },
    { code: "CR", name: "states.HN.CR" },
    { code: "EP", name: "states.HN.EP" },
    { code: "FM", name: "states.HN.FM" },
    { code: "GD", name: "states.HN.GD" },
    { code: "IB", name: "states.HN.IB" },
    { code: "IN", name: "states.HN.IN" },
    { code: "LE", name: "states.HN.LE" },
    { code: "LP", name: "states.HN.LP" },
    { code: "OC", name: "states.HN.OC" },
    { code: "OL", name: "states.HN.OL" },
    { code: "SB", name: "states.HN.SB" },
    { code: "VA", name: "states.HN.VA" },
    { code: "YO", name: "states.HN.YO" },
  ],
  HR: [
    { code: "01", name: "states.HR.01" },
    { code: "02", name: "states.HR.02" },
    { code: "03", name: "states.HR.03" },
    { code: "05", name: "states.HR.05" },
    { code: "06", name: "states.HR.06" },
    { code: "07", name: "states.HR.07" },
    { code: "08", name: "states.HR.08" },
    { code: "09", name: "states.HR.09" },
    { code: "10", name: "states.HR.10" },
    { code: "11", name: "states.HR.11" },
    { code: "12", name: "states.HR.12" },
    { code: "13", name: "states.HR.13" },
    { code: "14", name: "states.HR.14" },
    { code: "15", name: "states.HR.15" },
    { code: "16", name: "states.HR.16" },
    { code: "17", name: "states.HR.17" },
    { code: "18", name: "states.HR.18" },
    { code: "19", name: "states.HR.19" },
    { code: "20", name: "states.HR.20" },
    { code: "21", name: "states.HR.21" },
  ],
  HT: [
    { code: "AR", name: "states.HT.AR" },
    { code: "CE", name: "states.HT.CE" },
    { code: "GA", name: "states.HT.GA" },
    { code: "ND", name: "states.HT.ND" },
    { code: "NE", name: "states.HT.NE" },
    { code: "NI", name: "states.HT.NI" },
    { code: "NO", name: "states.HT.NO" },
    { code: "OU", name: "states.HT.OU" },
    { code: "SD", name: "states.HT.SD" },
    { code: "SE", name: "states.HT.SE" },
  ],
  HU: [
    { code: "BA", name: "states.HU.BA" },
    { code: "BC", name: "states.HU.BC" },
    { code: "BE", name: "states.HU.BE" },
    { code: "BK", name: "states.HU.BK" },
    { code: "BU", name: "states.HU.BU" },
    { code: "BZ", name: "states.HU.BZ" },
    { code: "CS", name: "states.HU.CS" },
    { code: "DE", name: "states.HU.DE" },
    { code: "DU", name: "states.HU.DU" },
    { code: "EG", name: "states.HU.EG" },
    { code: "ER", name: "states.HU.ER" },
    { code: "FE", name: "states.HU.FE" },
    { code: "GS", name: "states.HU.GS" },
    { code: "GY", name: "states.HU.GY" },
    { code: "HB", name: "states.HU.HB" },
    { code: "HE", name: "states.HU.HE" },
    { code: "HV", name: "states.HU.HV" },
    { code: "JN", name: "states.HU.JN" },
    { code: "KM", name: "states.HU.KM" },
    { code: "KV", name: "states.HU.KV" },
    { code: "MI", name: "states.HU.MI" },
    { code: "NK", name: "states.HU.NK" },
    { code: "NO", name: "states.HU.NO" },
    { code: "NY", name: "states.HU.NY" },
    { code: "PE", name: "states.HU.PE" },
    { code: "PS", name: "states.HU.PS" },
    { code: "SD", name: "states.HU.SD" },
    { code: "SF", name: "states.HU.SF" },
    { code: "SH", name: "states.HU.SH" },
    { code: "SK", name: "states.HU.SK" },
    { code: "SN", name: "states.HU.SN" },
    { code: "SO", name: "states.HU.SO" },
    { code: "SS", name: "states.HU.SS" },
    { code: "ST", name: "states.HU.ST" },
    { code: "SZ", name: "states.HU.SZ" },
    { code: "TB", name: "states.HU.TB" },
    { code: "TO", name: "states.HU.TO" },
    { code: "VA", name: "states.HU.VA" },
    { code: "VE", name: "states.HU.VE" },
    { code: "VM", name: "states.HU.VM" },
    { code: "ZA", name: "states.HU.ZA" },
    { code: "ZE", name: "states.HU.ZE" },
  ],
  ID: [
    { code: "AC", name: "states.ID.AC" },
    { code: "BA", name: "states.ID.BA" },
    { code: "BB", name: "states.ID.BB" },
    { code: "BE", name: "states.ID.BE" },
    { code: "BT", name: "states.ID.BT" },
    { code: "GO", name: "states.ID.GO" },
    { code: "JA", name: "states.ID.JA" },
    { code: "JB", name: "states.ID.JB" },
    { code: "JI", name: "states.ID.JI" },
    { code: "JK", name: "states.ID.JK" },
    { code: "JT", name: "states.ID.JT" },
    { code: "KA", name: "states.ID.KA" },
    { code: "KI", name: "states.ID.KI" },
    { code: "KR", name: "states.ID.KR" },
    { code: "KS", name: "states.ID.KS" },
    { code: "KT", name: "states.ID.KT" },
    { code: "KU", name: "states.ID.KU" },
    { code: "LA", name: "states.ID.LA" },
    { code: "MA", name: "states.ID.MA" },
    { code: "MU", name: "states.ID.MU" },
    { code: "NB", name: "states.ID.NB" },
    { code: "NT", name: "states.ID.NT" },
    { code: "PA", name: "states.ID.PA" },
    { code: "PB", name: "states.ID.PB" },
    { code: "RI", name: "states.ID.RI" },
    { code: "SA", name: "states.ID.SA" },
    { code: "SB", name: "states.ID.SB" },
    { code: "SG", name: "states.ID.SG" },
    { code: "SN", name: "states.ID.SN" },
    { code: "SR", name: "states.ID.SR" },
    { code: "SS", name: "states.ID.SS" },
    { code: "ST", name: "states.ID.ST" },
    { code: "SU", name: "states.ID.SU" },
    { code: "YO", name: "states.ID.YO" },
  ],
  IE: [
    { code: "C", name: "states.IE.C" },
    { code: "CE", name: "states.IE.CE" },
    { code: "CN", name: "states.IE.CN" },
    { code: "CO", name: "states.IE.CO" },
    { code: "CW", name: "states.IE.CW" },
    { code: "D", name: "states.IE.D" },
    { code: "DL", name: "states.IE.DL" },
    { code: "G", name: "states.IE.G" },
    { code: "KE", name: "states.IE.KE" },
    { code: "KK", name: "states.IE.KK" },
    { code: "KY", name: "states.IE.KY" },
    { code: "L", name: "states.IE.L" },
    { code: "LD", name: "states.IE.LD" },
    { code: "LH", name: "states.IE.LH" },
    { code: "LK", name: "states.IE.LK" },
    { code: "LS", name: "states.IE.LS" },
    { code: "M", name: "states.IE.M" },
    { code: "MH", name: "states.IE.MH" },
    { code: "MN", name: "states.IE.MN" },
    { code: "MO", name: "states.IE.MO" },
    { code: "OY", name: "states.IE.OY" },
    { code: "RN", name: "states.IE.RN" },
    { code: "SO", name: "states.IE.SO" },
    { code: "TA", name: "states.IE.TA" },
    { code: "U", name: "states.IE.U" },
    { code: "WD", name: "states.IE.WD" },
    { code: "WH", name: "states.IE.WH" },
    { code: "WW", name: "states.IE.WW" },
    { code: "WX", name: "states.IE.WX" },
  ],
  IL: [
    { code: "D", name: "states.IL.D" },
    { code: "HA", name: "states.IL.HA" },
    { code: "JM", name: "states.IL.JM" },
    { code: "M", name: "states.IL.M" },
    { code: "TA", name: "states.IL.TA" },
    { code: "Z", name: "states.IL.Z" },
  ],
  IN: [
    { code: "AN", name: "states.IN.AN" },
    { code: "AP", name: "states.IN.AP" },
    { code: "AR", name: "states.IN.AR" },
    { code: "AS", name: "states.IN.AS" },
    { code: "BR", name: "states.IN.BR" },
    { code: "CH", name: "states.IN.CH" },
    { code: "CT", name: "states.IN.CT" },
    { code: "DH", name: "states.IN.DH" },
    { code: "DL", name: "states.IN.DL" },
    { code: "GA", name: "states.IN.GA" },
    { code: "GJ", name: "states.IN.GJ" },
    { code: "HP", name: "states.IN.HP" },
    { code: "HR", name: "states.IN.HR" },
    { code: "JH", name: "states.IN.JH" },
    { code: "JK", name: "states.IN.JK" },
    { code: "KA", name: "states.IN.KA" },
    { code: "KL", name: "states.IN.KL" },
    { code: "LA", name: "states.IN.LA" },
    { code: "LD", name: "states.IN.LD" },
    { code: "MH", name: "states.IN.MH" },
    { code: "ML", name: "states.IN.ML" },
    { code: "MN", name: "states.IN.MN" },
    { code: "MP", name: "states.IN.MP" },
    { code: "MZ", name: "states.IN.MZ" },
    { code: "NL", name: "states.IN.NL" },
    { code: "OR", name: "states.IN.OR" },
    { code: "PB", name: "states.IN.PB" },
    { code: "PY", name: "states.IN.PY" },
    { code: "RJ", name: "states.IN.RJ" },
    { code: "SK", name: "states.IN.SK" },
    { code: "TG", name: "states.IN.TG" },
    { code: "TN", name: "states.IN.TN" },
    { code: "TR", name: "states.IN.TR" },
    { code: "UP", name: "states.IN.UP" },
    { code: "UT", name: "states.IN.UT" },
    { code: "WB", name: "states.IN.WB" },
  ],
  IQ: [
    { code: "AN", name: "states.IQ.AN" },
    { code: "AR", name: "states.IQ.AR" },
    { code: "BA", name: "states.IQ.BA" },
    { code: "BB", name: "states.IQ.BB" },
    { code: "BG", name: "states.IQ.BG" },
    { code: "DA", name: "states.IQ.DA" },
    { code: "DI", name: "states.IQ.DI" },
    { code: "DQ", name: "states.IQ.DQ" },
    { code: "KA", name: "states.IQ.KA" },
    { code: "KI", name: "states.IQ.KI" },
    { code: "MA", name: "states.IQ.MA" },
    { code: "MU", name: "states.IQ.MU" },
    { code: "NA", name: "states.IQ.NA" },
    { code: "NI", name: "states.IQ.NI" },
    { code: "QA", name: "states.IQ.QA" },
    { code: "SD", name: "states.IQ.SD" },
    { code: "SU", name: "states.IQ.SU" },
    { code: "WA", name: "states.IQ.WA" },
  ],
  IR: [
    { code: "00", name: "states.IR.00" },
    { code: "01", name: "states.IR.01" },
    { code: "02", name: "states.IR.02" },
    { code: "03", name: "states.IR.03" },
    { code: "04", name: "states.IR.04" },
    { code: "05", name: "states.IR.05" },
    { code: "06", name: "states.IR.06" },
    { code: "07", name: "states.IR.07" },
    { code: "08", name: "states.IR.08" },
    { code: "09", name: "states.IR.09" },
    { code: "10", name: "states.IR.10" },
    { code: "11", name: "states.IR.11" },
    { code: "12", name: "states.IR.12" },
    { code: "13", name: "states.IR.13" },
    { code: "14", name: "states.IR.14" },
    { code: "15", name: "states.IR.15" },
    { code: "16", name: "states.IR.16" },
    { code: "17", name: "states.IR.17" },
    { code: "18", name: "states.IR.18" },
    { code: "19", name: "states.IR.19" },
    { code: "20", name: "states.IR.20" },
    { code: "21", name: "states.IR.21" },
    { code: "22", name: "states.IR.22" },
    { code: "23", name: "states.IR.23" },
    { code: "24", name: "states.IR.24" },
    { code: "25", name: "states.IR.25" },
    { code: "26", name: "states.IR.26" },
    { code: "27", name: "states.IR.27" },
    { code: "28", name: "states.IR.28" },
    { code: "29", name: "states.IR.29" },
    { code: "30", name: "states.IR.30" },
  ],
  IS: [
    { code: "1", name: "states.IS.1" },
    { code: "2", name: "states.IS.2" },
    { code: "3", name: "states.IS.3" },
    { code: "4", name: "states.IS.4" },
    { code: "5", name: "states.IS.5" },
    { code: "6", name: "states.IS.6" },
    { code: "7", name: "states.IS.7" },
    { code: "8", name: "states.IS.8" },
  ],
  IT: [
    { code: "21", name: "states.IT.21" },
    { code: "23", name: "states.IT.23" },
    { code: "25", name: "states.IT.25" },
    { code: "32", name: "states.IT.32" },
    { code: "34", name: "states.IT.34" },
    { code: "36", name: "states.IT.36" },
    { code: "42", name: "states.IT.42" },
    { code: "45", name: "states.IT.45" },
    { code: "52", name: "states.IT.52" },
    { code: "55", name: "states.IT.55" },
    { code: "57", name: "states.IT.57" },
    { code: "62", name: "states.IT.62" },
    { code: "65", name: "states.IT.65" },
    { code: "67", name: "states.IT.67" },
    { code: "72", name: "states.IT.72" },
    { code: "75", name: "states.IT.75" },
    { code: "77", name: "states.IT.77" },
    { code: "78", name: "states.IT.78" },
    { code: "82", name: "states.IT.82" },
    { code: "88", name: "states.IT.88" },
    { code: "AG", name: "states.IT.AG" },
    { code: "AL", name: "states.IT.AL" },
    { code: "AN", name: "states.IT.AN" },
    { code: "AP", name: "states.IT.AP" },
    { code: "AQ", name: "states.IT.AQ" },
    { code: "AT", name: "states.IT.AT" },
    { code: "AV", name: "states.IT.AV" },
    { code: "BA", name: "states.IT.BA" },
    { code: "BG", name: "states.IT.BG" },
    { code: "BI", name: "states.IT.BI" },
    { code: "BL", name: "states.IT.BL" },
    { code: "BN", name: "states.IT.BN" },
    { code: "BO", name: "states.IT.BO" },
    { code: "BR", name: "states.IT.BR" },
    { code: "BS", name: "states.IT.BS" },
    { code: "BT", name: "states.IT.BT" },
    { code: "BZ", name: "states.IT.BZ" },
    { code: "CA", name: "states.IT.CA" },
    { code: "CB", name: "states.IT.CB" },
    { code: "CE", name: "states.IT.CE" },
    { code: "CH", name: "states.IT.CH" },
    { code: "CI", name: "states.IT.CI" },
    { code: "CL", name: "states.IT.CL" },
    { code: "CN", name: "states.IT.CN" },
    { code: "CO", name: "states.IT.CO" },
    { code: "CR", name: "states.IT.CR" },
    { code: "CS", name: "states.IT.CS" },
    { code: "CT", name: "states.IT.CT" },
    { code: "CZ", name: "states.IT.CZ" },
    { code: "EN", name: "states.IT.EN" },
    { code: "FC", name: "states.IT.FC" },
    { code: "FE", name: "states.IT.FE" },
    { code: "FG", name: "states.IT.FG" },
    { code: "FI", name: "states.IT.FI" },
    { code: "FM", name: "states.IT.FM" },
    { code: "FR", name: "states.IT.FR" },
    { code: "GE", name: "states.IT.GE" },
    { code: "GO", name: "states.IT.GO" },
    { code: "GR", name: "states.IT.GR" },
    { code: "IM", name: "states.IT.IM" },
    { code: "IS", name: "states.IT.IS" },
    { code: "KR", name: "states.IT.KR" },
    { code: "LC", name: "states.IT.LC" },
    { code: "LE", name: "states.IT.LE" },
    { code: "LI", name: "states.IT.LI" },
    { code: "LO", name: "states.IT.LO" },
    { code: "LT", name: "states.IT.LT" },
    { code: "LU", name: "states.IT.LU" },
    { code: "MB", name: "states.IT.MB" },
    { code: "MC", name: "states.IT.MC" },
    { code: "ME", name: "states.IT.ME" },
    { code: "MI", name: "states.IT.MI" },
    { code: "MN", name: "states.IT.MN" },
    { code: "MO", name: "states.IT.MO" },
    { code: "MS", name: "states.IT.MS" },
    { code: "MT", name: "states.IT.MT" },
    { code: "NA", name: "states.IT.NA" },
    { code: "NO", name: "states.IT.NO" },
    { code: "NU", name: "states.IT.NU" },
    { code: "OG", name: "states.IT.OG" },
    { code: "OR", name: "states.IT.OR" },
    { code: "OT", name: "states.IT.OT" },
    { code: "PA", name: "states.IT.PA" },
    { code: "PC", name: "states.IT.PC" },
    { code: "PD", name: "states.IT.PD" },
    { code: "PE", name: "states.IT.PE" },
    { code: "PG", name: "states.IT.PG" },
    { code: "PI", name: "states.IT.PI" },
    { code: "PN", name: "states.IT.PN" },
    { code: "PO", name: "states.IT.PO" },
    { code: "PR", name: "states.IT.PR" },
    { code: "PT", name: "states.IT.PT" },
    { code: "PU", name: "states.IT.PU" },
    { code: "PV", name: "states.IT.PV" },
    { code: "PZ", name: "states.IT.PZ" },
    { code: "RA", name: "states.IT.RA" },
    { code: "RC", name: "states.IT.RC" },
    { code: "RE", name: "states.IT.RE" },
    { code: "RG", name: "states.IT.RG" },
    { code: "RI", name: "states.IT.RI" },
    { code: "RM", name: "states.IT.RM" },
    { code: "RN", name: "states.IT.RN" },
    { code: "RO", name: "states.IT.RO" },
    { code: "SA", name: "states.IT.SA" },
    { code: "SI", name: "states.IT.SI" },
    { code: "SO", name: "states.IT.SO" },
    { code: "SP", name: "states.IT.SP" },
    { code: "SR", name: "states.IT.SR" },
    { code: "SS", name: "states.IT.SS" },
    { code: "SV", name: "states.IT.SV" },
    { code: "TA", name: "states.IT.TA" },
    { code: "TE", name: "states.IT.TE" },
    { code: "TN", name: "states.IT.TN" },
    { code: "TO", name: "states.IT.TO" },
    { code: "TP", name: "states.IT.TP" },
    { code: "TR", name: "states.IT.TR" },
    { code: "TS", name: "states.IT.TS" },
    { code: "TV", name: "states.IT.TV" },
    { code: "UD", name: "states.IT.UD" },
    { code: "VA", name: "states.IT.VA" },
    { code: "VB", name: "states.IT.VB" },
    { code: "VC", name: "states.IT.VC" },
    { code: "VE", name: "states.IT.VE" },
    { code: "VI", name: "states.IT.VI" },
    { code: "VR", name: "states.IT.VR" },
    { code: "VS", name: "states.IT.VS" },
    { code: "VT", name: "states.IT.VT" },
    { code: "VV", name: "states.IT.VV" },
  ],
  JM: [
    { code: "01", name: "states.JM.01" },
    { code: "02", name: "states.JM.02" },
    { code: "03", name: "states.JM.03" },
    { code: "04", name: "states.JM.04" },
    { code: "05", name: "states.JM.05" },
    { code: "06", name: "states.JM.06" },
    { code: "07", name: "states.JM.07" },
    { code: "08", name: "states.JM.08" },
    { code: "09", name: "states.JM.09" },
    { code: "10", name: "states.JM.10" },
    { code: "11", name: "states.JM.11" },
    { code: "12", name: "states.JM.12" },
    { code: "13", name: "states.JM.13" },
    { code: "14", name: "states.JM.14" },
  ],
  JO: [
    { code: "AJ", name: "states.JO.AJ" },
    { code: "AM", name: "states.JO.AM" },
    { code: "AQ", name: "states.JO.AQ" },
    { code: "AT", name: "states.JO.AT" },
    { code: "AZ", name: "states.JO.AZ" },
    { code: "BA", name: "states.JO.BA" },
    { code: "IR", name: "states.JO.IR" },
    { code: "JA", name: "states.JO.JA" },
    { code: "KA", name: "states.JO.KA" },
    { code: "MA", name: "states.JO.MA" },
    { code: "MD", name: "states.JO.MD" },
    { code: "MN", name: "states.JO.MN" },
  ],
  JP: [
    { code: "01", name: "states.JP.01" },
    { code: "02", name: "states.JP.02" },
    { code: "03", name: "states.JP.03" },
    { code: "04", name: "states.JP.04" },
    { code: "05", name: "states.JP.05" },
    { code: "06", name: "states.JP.06" },
    { code: "07", name: "states.JP.07" },
    { code: "08", name: "states.JP.08" },
    { code: "09", name: "states.JP.09" },
    { code: "10", name: "states.JP.10" },
    { code: "11", name: "states.JP.11" },
    { code: "12", name: "states.JP.12" },
    { code: "13", name: "states.JP.13" },
    { code: "14", name: "states.JP.14" },
    { code: "15", name: "states.JP.15" },
    { code: "16", name: "states.JP.16" },
    { code: "17", name: "states.JP.17" },
    { code: "18", name: "states.JP.18" },
    { code: "19", name: "states.JP.19" },
    { code: "20", name: "states.JP.20" },
    { code: "21", name: "states.JP.21" },
    { code: "22", name: "states.JP.22" },
    { code: "23", name: "states.JP.23" },
    { code: "24", name: "states.JP.24" },
    { code: "25", name: "states.JP.25" },
    { code: "26", name: "states.JP.26" },
    { code: "27", name: "states.JP.27" },
    { code: "28", name: "states.JP.28" },
    { code: "29", name: "states.JP.29" },
    { code: "30", name: "states.JP.30" },
    { code: "31", name: "states.JP.31" },
    { code: "32", name: "states.JP.32" },
    { code: "33", name: "states.JP.33" },
    { code: "34", name: "states.JP.34" },
    { code: "35", name: "states.JP.35" },
    { code: "36", name: "states.JP.36" },
    { code: "37", name: "states.JP.37" },
    { code: "38", name: "states.JP.38" },
    { code: "39", name: "states.JP.39" },
    { code: "40", name: "states.JP.40" },
    { code: "41", name: "states.JP.41" },
    { code: "42", name: "states.JP.42" },
    { code: "43", name: "states.JP.43" },
    { code: "44", name: "states.JP.44" },
    { code: "45", name: "states.JP.45" },
    { code: "46", name: "states.JP.46" },
    { code: "47", name: "states.JP.47" },
  ],
  KE: [
    { code: "01", name: "states.KE.01" },
    { code: "02", name: "states.KE.02" },
    { code: "03", name: "states.KE.03" },
    { code: "04", name: "states.KE.04" },
    { code: "05", name: "states.KE.05" },
    { code: "06", name: "states.KE.06" },
    { code: "07", name: "states.KE.07" },
    { code: "08", name: "states.KE.08" },
    { code: "09", name: "states.KE.09" },
    { code: "10", name: "states.KE.10" },
    { code: "11", name: "states.KE.11" },
    { code: "12", name: "states.KE.12" },
    { code: "13", name: "states.KE.13" },
    { code: "14", name: "states.KE.14" },
    { code: "15", name: "states.KE.15" },
    { code: "16", name: "states.KE.16" },
    { code: "17", name: "states.KE.17" },
    { code: "18", name: "states.KE.18" },
    { code: "19", name: "states.KE.19" },
    { code: "20", name: "states.KE.20" },
    { code: "21", name: "states.KE.21" },
    { code: "22", name: "states.KE.22" },
    { code: "23", name: "states.KE.23" },
    { code: "24", name: "states.KE.24" },
    { code: "25", name: "states.KE.25" },
    { code: "26", name: "states.KE.26" },
    { code: "27", name: "states.KE.27" },
    { code: "28", name: "states.KE.28" },
    { code: "29", name: "states.KE.29" },
    { code: "30", name: "states.KE.30" },
    { code: "31", name: "states.KE.31" },
    { code: "32", name: "states.KE.32" },
    { code: "33", name: "states.KE.33" },
    { code: "34", name: "states.KE.34" },
    { code: "35", name: "states.KE.35" },
    { code: "36", name: "states.KE.36" },
    { code: "37", name: "states.KE.37" },
    { code: "38", name: "states.KE.38" },
    { code: "39", name: "states.KE.39" },
    { code: "40", name: "states.KE.40" },
    { code: "41", name: "states.KE.41" },
    { code: "42", name: "states.KE.42" },
    { code: "43", name: "states.KE.43" },
    { code: "44", name: "states.KE.44" },
    { code: "45", name: "states.KE.45" },
    { code: "46", name: "states.KE.46" },
    { code: "47", name: "states.KE.47" },
  ],
  KG: [
    { code: "B", name: "states.KG.B" },
    { code: "C", name: "states.KG.C" },
    { code: "GB", name: "states.KG.GB" },
    { code: "GO", name: "states.KG.GO" },
    { code: "J", name: "states.KG.J" },
    { code: "N", name: "states.KG.N" },
    { code: "O", name: "states.KG.O" },
    { code: "T", name: "states.KG.T" },
    { code: "Y", name: "states.KG.Y" },
  ],
  KH: [
    { code: "1", name: "states.KH.1" },
    { code: "10", name: "states.KH.10" },
    { code: "11", name: "states.KH.11" },
    { code: "12", name: "states.KH.12" },
    { code: "13", name: "states.KH.13" },
    { code: "14", name: "states.KH.14" },
    { code: "15", name: "states.KH.15" },
    { code: "16", name: "states.KH.16" },
    { code: "17", name: "states.KH.17" },
    { code: "18", name: "states.KH.18" },
    { code: "19", name: "states.KH.19" },
    { code: "2", name: "states.KH.2" },
    { code: "20", name: "states.KH.20" },
    { code: "21", name: "states.KH.21" },
    { code: "22", name: "states.KH.22" },
    { code: "23", name: "states.KH.23" },
    { code: "24", name: "states.KH.24" },
    { code: "3", name: "states.KH.3" },
    { code: "4", name: "states.KH.4" },
    { code: "5", name: "states.KH.5" },
    { code: "6", name: "states.KH.6" },
    { code: "7", name: "states.KH.7" },
    { code: "8", name: "states.KH.8" },
    { code: "9", name: "states.KH.9" },
    { code: "NTP", name: "states.KH.NTP" },
  ],
  KI: [
    { code: "G", name: "states.KI.G" },
    { code: "L", name: "states.KI.L" },
    { code: "P", name: "states.KI.P" },
  ],
  KM: [
    { code: "A", name: "states.KM.A" },
    { code: "G", name: "states.KM.G" },
    { code: "M", name: "states.KM.M" },
  ],
  KN: [
    { code: "01", name: "states.KN.01" },
    { code: "02", name: "states.KN.02" },
    { code: "04", name: "states.KN.04" },
    { code: "05", name: "states.KN.05" },
    { code: "06", name: "states.KN.06" },
    { code: "07", name: "states.KN.07" },
    { code: "08", name: "states.KN.08" },
    { code: "09", name: "states.KN.09" },
    { code: "10", name: "states.KN.10" },
    { code: "11", name: "states.KN.11" },
    { code: "12", name: "states.KN.12" },
    { code: "13", name: "states.KN.13" },
    { code: "15", name: "states.KN.15" },
    { code: "K", name: "states.KN.K" },
    { code: "N", name: "states.KN.N" },
  ],
  KP: [
    { code: "01", name: "states.KP.01" },
    { code: "02", name: "states.KP.02" },
    { code: "03", name: "states.KP.03" },
    { code: "04", name: "states.KP.04" },
    { code: "05", name: "states.KP.05" },
    { code: "06", name: "states.KP.06" },
    { code: "07", name: "states.KP.07" },
    { code: "08", name: "states.KP.08" },
    { code: "09", name: "states.KP.09" },
    { code: "10", name: "states.KP.10" },
    { code: "13", name: "states.KP.13" },
  ],
  KR: [
    { code: "11", name: "states.KR.11" },
    { code: "26", name: "states.KR.26" },
    { code: "27", name: "states.KR.27" },
    { code: "28", name: "states.KR.28" },
    { code: "29", name: "states.KR.29" },
    { code: "30", name: "states.KR.30" },
    { code: "31", name: "states.KR.31" },
    { code: "41", name: "states.KR.41" },
    { code: "42", name: "states.KR.42" },
    { code: "43", name: "states.KR.43" },
    { code: "44", name: "states.KR.44" },
    { code: "45", name: "states.KR.45" },
    { code: "46", name: "states.KR.46" },
    { code: "47", name: "states.KR.47" },
    { code: "48", name: "states.KR.48" },
    { code: "49", name: "states.KR.49" },
    { code: "50", name: "states.KR.50" },
  ],
  KW: [
    { code: "AH", name: "states.KW.AH" },
    { code: "FA", name: "states.KW.FA" },
    { code: "HA", name: "states.KW.HA" },
    { code: "JA", name: "states.KW.JA" },
    { code: "KU", name: "states.KW.KU" },
    { code: "MU", name: "states.KW.MU" },
  ],
  KZ: [
    { code: "AKM", name: "states.KZ.AKM" },
    { code: "AKT", name: "states.KZ.AKT" },
    { code: "ALA", name: "states.KZ.ALA" },
    { code: "ALM", name: "states.KZ.ALM" },
    { code: "AST", name: "states.KZ.AST" },
    { code: "ATY", name: "states.KZ.ATY" },
    { code: "BAY", name: "states.KZ.BAY" },
    { code: "KAR", name: "states.KZ.KAR" },
    { code: "KUS", name: "states.KZ.KUS" },
    { code: "KZY", name: "states.KZ.KZY" },
    { code: "MAN", name: "states.KZ.MAN" },
    { code: "PAV", name: "states.KZ.PAV" },
    { code: "SEV", name: "states.KZ.SEV" },
    { code: "VOS", name: "states.KZ.VOS" },
    { code: "YUZ", name: "states.KZ.YUZ" },
    { code: "ZAP", name: "states.KZ.ZAP" },
    { code: "ZHA", name: "states.KZ.ZHA" },
  ],
  LA: [
    { code: "AT", name: "states.LA.AT" },
    { code: "BK", name: "states.LA.BK" },
    { code: "BL", name: "states.LA.BL" },
    { code: "CH", name: "states.LA.CH" },
    { code: "HO", name: "states.LA.HO" },
    { code: "KH", name: "states.LA.KH" },
    { code: "LM", name: "states.LA.LM" },
    { code: "LP", name: "states.LA.LP" },
    { code: "OU", name: "states.LA.OU" },
    { code: "PH", name: "states.LA.PH" },
    { code: "SL", name: "states.LA.SL" },
    { code: "SV", name: "states.LA.SV" },
    { code: "VI", name: "states.LA.VI" },
    { code: "VT", name: "states.LA.VT" },
    { code: "XA", name: "states.LA.XA" },
    { code: "XE", name: "states.LA.XE" },
    { code: "XI", name: "states.LA.XI" },
    { code: "XN", name: "states.LA.XN" },
    { code: "XS", name: "states.LA.XS" },
  ],
  LB: [
    { code: "AK", name: "states.LB.AK" },
    { code: "AS", name: "states.LB.AS" },
    { code: "BA", name: "states.LB.BA" },
    { code: "BH", name: "states.LB.BH" },
    { code: "BI", name: "states.LB.BI" },
    { code: "JA", name: "states.LB.JA" },
    { code: "JL", name: "states.LB.JL" },
    { code: "NA", name: "states.LB.NA" },
  ],
  LC: [
    { code: "01", name: "states.LC.01" },
    { code: "02", name: "states.LC.02" },
    { code: "03", name: "states.LC.03" },
    { code: "04", name: "states.LC.04" },
    { code: "05", name: "states.LC.05" },
    { code: "06", name: "states.LC.06" },
    { code: "07", name: "states.LC.07" },
    { code: "08", name: "states.LC.08" },
    { code: "09", name: "states.LC.09" },
    { code: "10", name: "states.LC.10" },
    { code: "11", name: "states.LC.11" },
    { code: "12", name: "states.LC.12" },
  ],
  LI: [
    { code: "01", name: "states.LI.01" },
    { code: "02", name: "states.LI.02" },
    { code: "03", name: "states.LI.03" },
    { code: "04", name: "states.LI.04" },
    { code: "05", name: "states.LI.05" },
    { code: "06", name: "states.LI.06" },
    { code: "07", name: "states.LI.07" },
    { code: "08", name: "states.LI.08" },
    { code: "09", name: "states.LI.09" },
    { code: "10", name: "states.LI.10" },
    { code: "11", name: "states.LI.11" },
  ],
  LK: [
    { code: "1", name: "states.LK.1" },
    { code: "11", name: "states.LK.11" },
    { code: "12", name: "states.LK.12" },
    { code: "13", name: "states.LK.13" },
    { code: "2", name: "states.LK.2" },
    { code: "21", name: "states.LK.21" },
    { code: "22", name: "states.LK.22" },
    { code: "23", name: "states.LK.23" },
    { code: "3", name: "states.LK.3" },
    { code: "31", name: "states.LK.31" },
    { code: "32", name: "states.LK.32" },
    { code: "33", name: "states.LK.33" },
    { code: "4", name: "states.LK.4" },
    { code: "41", name: "states.LK.41" },
    { code: "42", name: "states.LK.42" },
    { code: "43", name: "states.LK.43" },
    { code: "44", name: "states.LK.44" },
    { code: "45", name: "states.LK.45" },
    { code: "5", name: "states.LK.5" },
    { code: "51", name: "states.LK.51" },
    { code: "52", name: "states.LK.52" },
    { code: "53", name: "states.LK.53" },
    { code: "6", name: "states.LK.6" },
    { code: "62", name: "states.LK.62" },
    { code: "7", name: "states.LK.7" },
    { code: "71", name: "states.LK.71" },
    { code: "72", name: "states.LK.72" },
    { code: "8", name: "states.LK.8" },
    { code: "81", name: "states.LK.81" },
    { code: "82", name: "states.LK.82" },
    { code: "9", name: "states.LK.9" },
    { code: "91", name: "states.LK.91" },
    { code: "92", name: "states.LK.92" },
  ],
  LR: [
    { code: "BG", name: "states.LR.BG" },
    { code: "BM", name: "states.LR.BM" },
    { code: "CM", name: "states.LR.CM" },
    { code: "GB", name: "states.LR.GB" },
    { code: "GG", name: "states.LR.GG" },
    { code: "GK", name: "states.LR.GK" },
    { code: "GP", name: "states.LR.GP" },
    { code: "LO", name: "states.LR.LO" },
    { code: "MG", name: "states.LR.MG" },
    { code: "MO", name: "states.LR.MO" },
    { code: "MY", name: "states.LR.MY" },
    { code: "NI", name: "states.LR.NI" },
    { code: "RG", name: "states.LR.RG" },
    { code: "RI", name: "states.LR.RI" },
    { code: "SI", name: "states.LR.SI" },
  ],
  LS: [
    { code: "A", name: "states.LS.A" },
    { code: "B", name: "states.LS.B" },
    { code: "C", name: "states.LS.C" },
    { code: "D", name: "states.LS.D" },
    { code: "E", name: "states.LS.E" },
    { code: "F", name: "states.LS.F" },
    { code: "G", name: "states.LS.G" },
    { code: "H", name: "states.LS.H" },
    { code: "J", name: "states.LS.J" },
    { code: "K", name: "states.LS.K" },
  ],
  LT: [
    { code: "01", name: "states.LT.01" },
    { code: "02", name: "states.LT.02" },
    { code: "03", name: "states.LT.03" },
    { code: "05", name: "states.LT.05" },
    { code: "06", name: "states.LT.06" },
    { code: "07", name: "states.LT.07" },
    { code: "08", name: "states.LT.08" },
    { code: "09", name: "states.LT.09" },
    { code: "10", name: "states.LT.10" },
    { code: "11", name: "states.LT.11" },
    { code: "12", name: "states.LT.12" },
    { code: "13", name: "states.LT.13" },
    { code: "14", name: "states.LT.14" },
    { code: "15", name: "states.LT.15" },
    { code: "16", name: "states.LT.16" },
    { code: "17", name: "states.LT.17" },
    { code: "18", name: "states.LT.18" },
    { code: "19", name: "states.LT.19" },
    { code: "20", name: "states.LT.20" },
    { code: "21", name: "states.LT.21" },
    { code: "22", name: "states.LT.22" },
    { code: "23", name: "states.LT.23" },
    { code: "24", name: "states.LT.24" },
    { code: "25", name: "states.LT.25" },
    { code: "26", name: "states.LT.26" },
    { code: "27", name: "states.LT.27" },
    { code: "28", name: "states.LT.28" },
    { code: "29", name: "states.LT.29" },
    { code: "30", name: "states.LT.30" },
    { code: "31", name: "states.LT.31" },
    { code: "32", name: "states.LT.32" },
    { code: "33", name: "states.LT.33" },
    { code: "34", name: "states.LT.34" },
    { code: "35", name: "states.LT.35" },
    { code: "36", name: "states.LT.36" },
    { code: "37", name: "states.LT.37" },
    { code: "38", name: "states.LT.38" },
    { code: "39", name: "states.LT.39" },
    { code: "40", name: "states.LT.40" },
    { code: "41", name: "states.LT.41" },
    { code: "42", name: "states.LT.42" },
    { code: "43", name: "states.LT.43" },
    { code: "44", name: "states.LT.44" },
    { code: "45", name: "states.LT.45" },
    { code: "46", name: "states.LT.46" },
    { code: "47", name: "states.LT.47" },
    { code: "48", name: "states.LT.48" },
    { code: "49", name: "states.LT.49" },
    { code: "50", name: "states.LT.50" },
    { code: "51", name: "states.LT.51" },
    { code: "52", name: "states.LT.52" },
    { code: "53", name: "states.LT.53" },
    { code: "54", name: "states.LT.54" },
    { code: "55", name: "states.LT.55" },
    { code: "56", name: "states.LT.56" },
    { code: "57", name: "states.LT.57" },
    { code: "58", name: "states.LT.58" },
    { code: "59", name: "states.LT.59" },
    { code: "60", name: "states.LT.60" },
    { code: "AL", name: "states.LT.AL" },
    { code: "KL", name: "states.LT.KL" },
    { code: "KU", name: "states.LT.KU" },
    { code: "MR", name: "states.LT.MR" },
    { code: "PN", name: "states.LT.PN" },
    { code: "SA", name: "states.LT.SA" },
    { code: "TA", name: "states.LT.TA" },
    { code: "TE", name: "states.LT.TE" },
    { code: "UT", name: "states.LT.UT" },
    { code: "VL", name: "states.LT.VL" },
  ],
  LU: [
    { code: "CA", name: "states.LU.CA" },
    { code: "CL", name: "states.LU.CL" },
    { code: "D", name: "states.LU.D" },
    { code: "DI", name: "states.LU.DI" },
    { code: "EC", name: "states.LU.EC" },
    { code: "ES", name: "states.LU.ES" },
    { code: "G", name: "states.LU.G" },
    { code: "GR", name: "states.LU.GR" },
    { code: "L", name: "states.LU.L" },
    { code: "LU", name: "states.LU.LU" },
    { code: "ME", name: "states.LU.ME" },
    { code: "RD", name: "states.LU.RD" },
    { code: "RM", name: "states.LU.RM" },
    { code: "VD", name: "states.LU.VD" },
    { code: "WI", name: "states.LU.WI" },
  ],
  LV: [
    { code: "001", name: "states.LV.001" },
    { code: "002", name: "states.LV.002" },
    { code: "003", name: "states.LV.003" },
    { code: "004", name: "states.LV.004" },
    { code: "005", name: "states.LV.005" },
    { code: "006", name: "states.LV.006" },
    { code: "007", name: "states.LV.007" },
    { code: "008", name: "states.LV.008" },
    { code: "009", name: "states.LV.009" },
    { code: "010", name: "states.LV.010" },
    { code: "012", name: "states.LV.012" },
    { code: "013", name: "states.LV.013" },
    { code: "014", name: "states.LV.014" },
    { code: "015", name: "states.LV.015" },
    { code: "016", name: "states.LV.016" },
    { code: "017", name: "states.LV.017" },
    { code: "018", name: "states.LV.018" },
    { code: "019", name: "states.LV.019" },
    { code: "020", name: "states.LV.020" },
    { code: "021", name: "states.LV.021" },
    { code: "022", name: "states.LV.022" },
    { code: "023", name: "states.LV.023" },
    { code: "024", name: "states.LV.024" },
    { code: "025", name: "states.LV.025" },
    { code: "026", name: "states.LV.026" },
    { code: "027", name: "states.LV.027" },
    { code: "028", name: "states.LV.028" },
    { code: "029", name: "states.LV.029" },
    { code: "030", name: "states.LV.030" },
    { code: "031", name: "states.LV.031" },
    { code: "032", name: "states.LV.032" },
    { code: "033", name: "states.LV.033" },
    { code: "034", name: "states.LV.034" },
    { code: "035", name: "states.LV.035" },
    { code: "036", name: "states.LV.036" },
    { code: "037", name: "states.LV.037" },
    { code: "038", name: "states.LV.038" },
    { code: "039", name: "states.LV.039" },
    { code: "040", name: "states.LV.040" },
    { code: "041", name: "states.LV.041" },
    { code: "042", name: "states.LV.042" },
    { code: "043", name: "states.LV.043" },
    { code: "044", name: "states.LV.044" },
    { code: "045", name: "states.LV.045" },
    { code: "046", name: "states.LV.046" },
    { code: "047", name: "states.LV.047" },
    { code: "048", name: "states.LV.048" },
    { code: "049", name: "states.LV.049" },
    { code: "050", name: "states.LV.050" },
    { code: "051", name: "states.LV.051" },
    { code: "052", name: "states.LV.052" },
    { code: "053", name: "states.LV.053" },
    { code: "054", name: "states.LV.054" },
    { code: "055", name: "states.LV.055" },
    { code: "056", name: "states.LV.056" },
    { code: "057", name: "states.LV.057" },
    { code: "058", name: "states.LV.058" },
    { code: "059", name: "states.LV.059" },
    { code: "060", name: "states.LV.060" },
    { code: "061", name: "states.LV.061" },
    { code: "062", name: "states.LV.062" },
    { code: "063", name: "states.LV.063" },
    { code: "064", name: "states.LV.064" },
    { code: "065", name: "states.LV.065" },
    { code: "066", name: "states.LV.066" },
    { code: "067", name: "states.LV.067" },
    { code: "068", name: "states.LV.068" },
    { code: "069", name: "states.LV.069" },
    { code: "070", name: "states.LV.070" },
    { code: "071", name: "states.LV.071" },
    { code: "072", name: "states.LV.072" },
    { code: "073", name: "states.LV.073" },
    { code: "074", name: "states.LV.074" },
    { code: "075", name: "states.LV.075" },
    { code: "076", name: "states.LV.076" },
    { code: "077", name: "states.LV.077" },
    { code: "078", name: "states.LV.078" },
    { code: "079", name: "states.LV.079" },
    { code: "080", name: "states.LV.080" },
    { code: "081", name: "states.LV.081" },
    { code: "082", name: "states.LV.082" },
    { code: "083", name: "states.LV.083" },
    { code: "084", name: "states.LV.084" },
    { code: "085", name: "states.LV.085" },
    { code: "086", name: "states.LV.086" },
    { code: "087", name: "states.LV.087" },
    { code: "088", name: "states.LV.088" },
    { code: "089", name: "states.LV.089" },
    { code: "090", name: "states.LV.090" },
    { code: "091", name: "states.LV.091" },
    { code: "092", name: "states.LV.092" },
    { code: "093", name: "states.LV.093" },
    { code: "094", name: "states.LV.094" },
    { code: "095", name: "states.LV.095" },
    { code: "096", name: "states.LV.096" },
    { code: "097", name: "states.LV.097" },
    { code: "098", name: "states.LV.098" },
    { code: "099", name: "states.LV.099" },
    { code: "100", name: "states.LV.100" },
    { code: "101", name: "states.LV.101" },
    { code: "102", name: "states.LV.102" },
    { code: "103", name: "states.LV.103" },
    { code: "104", name: "states.LV.104" },
    { code: "105", name: "states.LV.105" },
    { code: "106", name: "states.LV.106" },
    { code: "107", name: "states.LV.107" },
    { code: "108", name: "states.LV.108" },
    { code: "109", name: "states.LV.109" },
    { code: "110", name: "states.LV.110" },
    { code: "DGV", name: "states.LV.DGV" },
    { code: "JEL", name: "states.LV.JEL" },
    { code: "JKB", name: "states.LV.JKB" },
    { code: "JUR", name: "states.LV.JUR" },
    { code: "LPX", name: "states.LV.LPX" },
    { code: "REZ", name: "states.LV.REZ" },
    { code: "RIX", name: "states.LV.RIX" },
    { code: "VEN", name: "states.LV.VEN" },
    { code: "VMR", name: "states.LV.VMR" },
  ],
  LY: [
    { code: "BA", name: "states.LY.BA" },
    { code: "DR", name: "states.LY.DR" },
    { code: "GT", name: "states.LY.GT" },
    { code: "JA", name: "states.LY.JA" },
    { code: "JG", name: "states.LY.JG" },
    { code: "JI", name: "states.LY.JI" },
    { code: "JU", name: "states.LY.JU" },
    { code: "KF", name: "states.LY.KF" },
    { code: "MB", name: "states.LY.MB" },
    { code: "MI", name: "states.LY.MI" },
    { code: "MJ", name: "states.LY.MJ" },
    { code: "MQ", name: "states.LY.MQ" },
    { code: "NL", name: "states.LY.NL" },
    { code: "NQ", name: "states.LY.NQ" },
    { code: "SB", name: "states.LY.SB" },
    { code: "SR", name: "states.LY.SR" },
    { code: "TB", name: "states.LY.TB" },
    { code: "WA", name: "states.LY.WA" },
    { code: "WD", name: "states.LY.WD" },
    { code: "WS", name: "states.LY.WS" },
    { code: "ZA", name: "states.LY.ZA" },
  ],
  MA: [
    { code: "01", name: "states.MA.01" },
    { code: "02", name: "states.MA.02" },
    { code: "03", name: "states.MA.03" },
    { code: "04", name: "states.MA.04" },
    { code: "05", name: "states.MA.05" },
    { code: "06", name: "states.MA.06" },
    { code: "07", name: "states.MA.07" },
    { code: "08", name: "states.MA.08" },
    { code: "09", name: "states.MA.09" },
    { code: "10", name: "states.MA.10" },
    { code: "11", name: "states.MA.11" },
    { code: "12", name: "states.MA.12" },
    { code: "AGD", name: "states.MA.AGD" },
    { code: "AOU", name: "states.MA.AOU" },
    { code: "ASZ", name: "states.MA.ASZ" },
    { code: "AZI", name: "states.MA.AZI" },
    { code: "BEM", name: "states.MA.BEM" },
    { code: "BER", name: "states.MA.BER" },
    { code: "BES", name: "states.MA.BES" },
    { code: "BOD", name: "states.MA.BOD" },
    { code: "BOM", name: "states.MA.BOM" },
    { code: "BRR", name: "states.MA.BRR" },
    { code: "CAS", name: "states.MA.CAS" },
    { code: "CHE", name: "states.MA.CHE" },
    { code: "CHI", name: "states.MA.CHI" },
    { code: "CHT", name: "states.MA.CHT" },
    { code: "DRI", name: "states.MA.DRI" },
    { code: "ERR", name: "states.MA.ERR" },
    { code: "ESI", name: "states.MA.ESI" },
    { code: "ESM", name: "states.MA.ESM" },
    { code: "FAH", name: "states.MA.FAH" },
    { code: "FES", name: "states.MA.FES" },
    { code: "FIG", name: "states.MA.FIG" },
    { code: "FQH", name: "states.MA.FQH" },
    { code: "GUE", name: "states.MA.GUE" },
    { code: "GUF", name: "states.MA.GUF" },
    { code: "HAJ", name: "states.MA.HAJ" },
    { code: "HAO", name: "states.MA.HAO" },
    { code: "HOC", name: "states.MA.HOC" },
    { code: "IFR", name: "states.MA.IFR" },
    { code: "INE", name: "states.MA.INE" },
    { code: "JDI", name: "states.MA.JDI" },
    { code: "JRA", name: "states.MA.JRA" },
    { code: "KEN", name: "states.MA.KEN" },
    { code: "KES", name: "states.MA.KES" },
    { code: "KHE", name: "states.MA.KHE" },
    { code: "KHN", name: "states.MA.KHN" },
    { code: "KHO", name: "states.MA.KHO" },
    { code: "LAA", name: "states.MA.LAA" },
    { code: "LAR", name: "states.MA.LAR" },
    { code: "MAR", name: "states.MA.MAR" },
    { code: "MDF", name: "states.MA.MDF" },
    { code: "MED", name: "states.MA.MED" },
    { code: "MEK", name: "states.MA.MEK" },
    { code: "MID", name: "states.MA.MID" },
    { code: "MOH", name: "states.MA.MOH" },
    { code: "MOU", name: "states.MA.MOU" },
    { code: "NAD", name: "states.MA.NAD" },
    { code: "NOU", name: "states.MA.NOU" },
    { code: "OUA", name: "states.MA.OUA" },
    { code: "OUD", name: "states.MA.OUD" },
    { code: "OUJ", name: "states.MA.OUJ" },
    { code: "OUZ", name: "states.MA.OUZ" },
    { code: "RAB", name: "states.MA.RAB" },
    { code: "REH", name: "states.MA.REH" },
    { code: "SAF", name: "states.MA.SAF" },
    { code: "SAL", name: "states.MA.SAL" },
    { code: "SEF", name: "states.MA.SEF" },
    { code: "SET", name: "states.MA.SET" },
    { code: "SIB", name: "states.MA.SIB" },
    { code: "SIF", name: "states.MA.SIF" },
    { code: "SIK", name: "states.MA.SIK" },
    { code: "SIL", name: "states.MA.SIL" },
    { code: "SKH", name: "states.MA.SKH" },
    { code: "TAF", name: "states.MA.TAF" },
    { code: "TAI", name: "states.MA.TAI" },
    { code: "TAO", name: "states.MA.TAO" },
    { code: "TAR", name: "states.MA.TAR" },
    { code: "TAT", name: "states.MA.TAT" },
    { code: "TAZ", name: "states.MA.TAZ" },
    { code: "TET", name: "states.MA.TET" },
    { code: "TIN", name: "states.MA.TIN" },
    { code: "TIZ", name: "states.MA.TIZ" },
    { code: "TNG", name: "states.MA.TNG" },
    { code: "TNT", name: "states.MA.TNT" },
    { code: "YUS", name: "states.MA.YUS" },
    { code: "ZAG", name: "states.MA.ZAG" },
  ],
  MC: [
    { code: "CL", name: "states.MC.CL" },
    { code: "CO", name: "states.MC.CO" },
    { code: "MG", name: "states.MC.MG" },
  ],
  MD: [
    { code: "AN", name: "states.MD.AN" },
    { code: "BA", name: "states.MD.BA" },
    { code: "BD", name: "states.MD.BD" },
    { code: "BR", name: "states.MD.BR" },
    { code: "BS", name: "states.MD.BS" },
    { code: "CA", name: "states.MD.CA" },
    { code: "CL", name: "states.MD.CL" },
    { code: "CM", name: "states.MD.CM" },
    { code: "CR", name: "states.MD.CR" },
    { code: "CS", name: "states.MD.CS" },
    { code: "CT", name: "states.MD.CT" },
    { code: "CU", name: "states.MD.CU" },
    { code: "DO", name: "states.MD.DO" },
    { code: "DR", name: "states.MD.DR" },
    { code: "DU", name: "states.MD.DU" },
    { code: "ED", name: "states.MD.ED" },
    { code: "FA", name: "states.MD.FA" },
    { code: "FL", name: "states.MD.FL" },
    { code: "GA", name: "states.MD.GA" },
    { code: "GL", name: "states.MD.GL" },
    { code: "HI", name: "states.MD.HI" },
    { code: "IA", name: "states.MD.IA" },
    { code: "NI", name: "states.MD.NI" },
    { code: "OC", name: "states.MD.OC" },
    { code: "OR", name: "states.MD.OR" },
    { code: "RE", name: "states.MD.RE" },
    { code: "RI", name: "states.MD.RI" },
    { code: "SD", name: "states.MD.SD" },
    { code: "SI", name: "states.MD.SI" },
    { code: "SN", name: "states.MD.SN" },
    { code: "SO", name: "states.MD.SO" },
    { code: "ST", name: "states.MD.ST" },
    { code: "SV", name: "states.MD.SV" },
    { code: "TA", name: "states.MD.TA" },
    { code: "TE", name: "states.MD.TE" },
    { code: "UN", name: "states.MD.UN" },
  ],
  ME: [
    { code: "01", name: "states.ME.01" },
    { code: "02", name: "states.ME.02" },
    { code: "03", name: "states.ME.03" },
    { code: "04", name: "states.ME.04" },
    { code: "05", name: "states.ME.05" },
    { code: "06", name: "states.ME.06" },
    { code: "07", name: "states.ME.07" },
    { code: "09", name: "states.ME.09" },
    { code: "10", name: "states.ME.10" },
    { code: "11", name: "states.ME.11" },
    { code: "12", name: "states.ME.12" },
    { code: "13", name: "states.ME.13" },
    { code: "14", name: "states.ME.14" },
    { code: "15", name: "states.ME.15" },
    { code: "16", name: "states.ME.16" },
    { code: "17", name: "states.ME.17" },
    { code: "18", name: "states.ME.18" },
    { code: "19", name: "states.ME.19" },
    { code: "20", name: "states.ME.20" },
    { code: "21", name: "states.ME.21" },
    { code: "22", name: "states.ME.22" },
    { code: "23", name: "states.ME.23" },
  ],
  MG: [
    { code: "A", name: "states.MG.A" },
    { code: "D", name: "states.MG.D" },
    { code: "F", name: "states.MG.F" },
    { code: "M", name: "states.MG.M" },
    { code: "T", name: "states.MG.T" },
    { code: "U", name: "states.MG.U" },
  ],
  MH: [
    { code: "L", name: "states.MH.L" },
    { code: "T", name: "states.MH.T" },
  ],
  MK: [
    { code: "01", name: "states.MK.01" },
    { code: "02", name: "states.MK.02" },
    { code: "03", name: "states.MK.03" },
    { code: "04", name: "states.MK.04" },
    { code: "05", name: "states.MK.05" },
    { code: "06", name: "states.MK.06" },
    { code: "07", name: "states.MK.07" },
    { code: "08", name: "states.MK.08" },
    { code: "09", name: "states.MK.09" },
    { code: "10", name: "states.MK.10" },
    { code: "11", name: "states.MK.11" },
    { code: "12", name: "states.MK.12" },
    { code: "13", name: "states.MK.13" },
    { code: "14", name: "states.MK.14" },
    { code: "15", name: "states.MK.15" },
    { code: "16", name: "states.MK.16" },
    { code: "17", name: "states.MK.17" },
    { code: "18", name: "states.MK.18" },
    { code: "19", name: "states.MK.19" },
    { code: "20", name: "states.MK.20" },
    { code: "22", name: "states.MK.22" },
    { code: "23", name: "states.MK.23" },
    { code: "24", name: "states.MK.24" },
    { code: "25", name: "states.MK.25" },
    { code: "26", name: "states.MK.26" },
    { code: "27", name: "states.MK.27" },
    { code: "28", name: "states.MK.28" },
    { code: "29", name: "states.MK.29" },
    { code: "30", name: "states.MK.30" },
    { code: "31", name: "states.MK.31" },
    { code: "32", name: "states.MK.32" },
    { code: "33", name: "states.MK.33" },
    { code: "34", name: "states.MK.34" },
    { code: "35", name: "states.MK.35" },
    { code: "36", name: "states.MK.36" },
    { code: "37", name: "states.MK.37" },
    { code: "38", name: "states.MK.38" },
    { code: "39", name: "states.MK.39" },
    { code: "40", name: "states.MK.40" },
    { code: "41", name: "states.MK.41" },
    { code: "42", name: "states.MK.42" },
    { code: "43", name: "states.MK.43" },
    { code: "44", name: "states.MK.44" },
    { code: "45", name: "states.MK.45" },
    { code: "46", name: "states.MK.46" },
    { code: "47", name: "states.MK.47" },
    { code: "48", name: "states.MK.48" },
    { code: "49", name: "states.MK.49" },
    { code: "50", name: "states.MK.50" },
    { code: "51", name: "states.MK.51" },
    { code: "52", name: "states.MK.52" },
    { code: "53", name: "states.MK.53" },
    { code: "54", name: "states.MK.54" },
    { code: "55", name: "states.MK.55" },
    { code: "56", name: "states.MK.56" },
    { code: "57", name: "states.MK.57" },
    { code: "58", name: "states.MK.58" },
    { code: "59", name: "states.MK.59" },
    { code: "60", name: "states.MK.60" },
    { code: "61", name: "states.MK.61" },
    { code: "62", name: "states.MK.62" },
    { code: "63", name: "states.MK.63" },
    { code: "64", name: "states.MK.64" },
    { code: "65", name: "states.MK.65" },
    { code: "66", name: "states.MK.66" },
    { code: "67", name: "states.MK.67" },
    { code: "68", name: "states.MK.68" },
    { code: "69", name: "states.MK.69" },
    { code: "70", name: "states.MK.70" },
    { code: "71", name: "states.MK.71" },
    { code: "72", name: "states.MK.72" },
    { code: "73", name: "states.MK.73" },
    { code: "74", name: "states.MK.74" },
    { code: "75", name: "states.MK.75" },
    { code: "76", name: "states.MK.76" },
    { code: "77", name: "states.MK.77" },
    { code: "78", name: "states.MK.78" },
    { code: "79", name: "states.MK.79" },
    { code: "80", name: "states.MK.80" },
    { code: "81", name: "states.MK.81" },
    { code: "82", name: "states.MK.82" },
    { code: "83", name: "states.MK.83" },
    { code: "84", name: "states.MK.84" },
    { code: "85", name: "states.MK.85" },
  ],
  ML: [
    { code: "1", name: "states.ML.1" },
    { code: "10", name: "states.ML.10" },
    { code: "2", name: "states.ML.2" },
    { code: "3", name: "states.ML.3" },
    { code: "4", name: "states.ML.4" },
    { code: "5", name: "states.ML.5" },
    { code: "6", name: "states.ML.6" },
    { code: "7", name: "states.ML.7" },
    { code: "8", name: "states.ML.8" },
    { code: "9", name: "states.ML.9" },
    { code: "BKO", name: "states.ML.BKO" },
  ],
  MM: [
    { code: "01", name: "states.MM.01" },
    { code: "02", name: "states.MM.02" },
    { code: "03", name: "states.MM.03" },
    { code: "04", name: "states.MM.04" },
    { code: "05", name: "states.MM.05" },
    { code: "06", name: "states.MM.06" },
    { code: "07", name: "states.MM.07" },
    { code: "11", name: "states.MM.11" },
    { code: "12", name: "states.MM.12" },
    { code: "13", name: "states.MM.13" },
    { code: "14", name: "states.MM.14" },
    { code: "15", name: "states.MM.15" },
    { code: "16", name: "states.MM.16" },
    { code: "17", name: "states.MM.17" },
    { code: "18", name: "states.MM.18" },
  ],
  MN: [
    { code: "035", name: "states.MN.035" },
    { code: "037", name: "states.MN.037" },
    { code: "039", name: "states.MN.039" },
    { code: "041", name: "states.MN.041" },
    { code: "043", name: "states.MN.043" },
    { code: "046", name: "states.MN.046" },
    { code: "047", name: "states.MN.047" },
    { code: "049", name: "states.MN.049" },
    { code: "051", name: "states.MN.051" },
    { code: "053", name: "states.MN.053" },
    { code: "055", name: "states.MN.055" },
    { code: "057", name: "states.MN.057" },
    { code: "059", name: "states.MN.059" },
    { code: "061", name: "states.MN.061" },
    { code: "063", name: "states.MN.063" },
    { code: "064", name: "states.MN.064" },
    { code: "065", name: "states.MN.065" },
    { code: "067", name: "states.MN.067" },
    { code: "069", name: "states.MN.069" },
    { code: "071", name: "states.MN.071" },
    { code: "073", name: "states.MN.073" },
  ],
  MR: [
    { code: "01", name: "states.MR.01" },
    { code: "02", name: "states.MR.02" },
    { code: "03", name: "states.MR.03" },
    { code: "04", name: "states.MR.04" },
    { code: "05", name: "states.MR.05" },
    { code: "06", name: "states.MR.06" },
    { code: "07", name: "states.MR.07" },
    { code: "08", name: "states.MR.08" },
    { code: "09", name: "states.MR.09" },
    { code: "10", name: "states.MR.10" },
    { code: "11", name: "states.MR.11" },
    { code: "12", name: "states.MR.12" },
    { code: "13", name: "states.MR.13" },
    { code: "14", name: "states.MR.14" },
    { code: "15", name: "states.MR.15" },
  ],
  MT: [
    { code: "01", name: "states.MT.01" },
    { code: "02", name: "states.MT.02" },
    { code: "03", name: "states.MT.03" },
    { code: "04", name: "states.MT.04" },
    { code: "05", name: "states.MT.05" },
    { code: "06", name: "states.MT.06" },
    { code: "07", name: "states.MT.07" },
    { code: "08", name: "states.MT.08" },
    { code: "09", name: "states.MT.09" },
    { code: "10", name: "states.MT.10" },
    { code: "11", name: "states.MT.11" },
    { code: "12", name: "states.MT.12" },
    { code: "13", name: "states.MT.13" },
    { code: "14", name: "states.MT.14" },
    { code: "15", name: "states.MT.15" },
    { code: "16", name: "states.MT.16" },
    { code: "17", name: "states.MT.17" },
    { code: "18", name: "states.MT.18" },
    { code: "19", name: "states.MT.19" },
    { code: "20", name: "states.MT.20" },
    { code: "21", name: "states.MT.21" },
    { code: "22", name: "states.MT.22" },
    { code: "23", name: "states.MT.23" },
    { code: "24", name: "states.MT.24" },
    { code: "25", name: "states.MT.25" },
    { code: "26", name: "states.MT.26" },
    { code: "27", name: "states.MT.27" },
    { code: "28", name: "states.MT.28" },
    { code: "29", name: "states.MT.29" },
    { code: "30", name: "states.MT.30" },
    { code: "31", name: "states.MT.31" },
    { code: "32", name: "states.MT.32" },
    { code: "33", name: "states.MT.33" },
    { code: "34", name: "states.MT.34" },
    { code: "35", name: "states.MT.35" },
    { code: "36", name: "states.MT.36" },
    { code: "37", name: "states.MT.37" },
    { code: "38", name: "states.MT.38" },
    { code: "39", name: "states.MT.39" },
    { code: "40", name: "states.MT.40" },
    { code: "41", name: "states.MT.41" },
    { code: "42", name: "states.MT.42" },
    { code: "43", name: "states.MT.43" },
    { code: "44", name: "states.MT.44" },
    { code: "45", name: "states.MT.45" },
    { code: "46", name: "states.MT.46" },
    { code: "48", name: "states.MT.48" },
    { code: "49", name: "states.MT.49" },
    { code: "50", name: "states.MT.50" },
    { code: "51", name: "states.MT.51" },
    { code: "52", name: "states.MT.52" },
    { code: "53", name: "states.MT.53" },
    { code: "54", name: "states.MT.54" },
    { code: "55", name: "states.MT.55" },
    { code: "56", name: "states.MT.56" },
    { code: "57", name: "states.MT.57" },
    { code: "58", name: "states.MT.58" },
    { code: "59", name: "states.MT.59" },
    { code: "60", name: "states.MT.60" },
    { code: "61", name: "states.MT.61" },
    { code: "62", name: "states.MT.62" },
    { code: "63", name: "states.MT.63" },
    { code: "64", name: "states.MT.64" },
    { code: "65", name: "states.MT.65" },
    { code: "66", name: "states.MT.66" },
    { code: "67", name: "states.MT.67" },
    { code: "68", name: "states.MT.68" },
  ],
  MU: [
    { code: "AG", name: "states.MU.AG" },
    { code: "BL", name: "states.MU.BL" },
    { code: "BR", name: "states.MU.BR" },
    { code: "CC", name: "states.MU.CC" },
    { code: "CU", name: "states.MU.CU" },
    { code: "FL", name: "states.MU.FL" },
    { code: "GP", name: "states.MU.GP" },
    { code: "MO", name: "states.MU.MO" },
    { code: "PA", name: "states.MU.PA" },
    { code: "PL", name: "states.MU.PL" },
    { code: "PU", name: "states.MU.PU" },
    { code: "PW", name: "states.MU.PW" },
    { code: "QB", name: "states.MU.QB" },
    { code: "RO", name: "states.MU.RO" },
    { code: "RR", name: "states.MU.RR" },
    { code: "SA", name: "states.MU.SA" },
    { code: "VP", name: "states.MU.VP" },
  ],
  MV: [
    { code: "00", name: "states.MV.00" },
    { code: "01", name: "states.MV.01" },
    { code: "02", name: "states.MV.02" },
    { code: "03", name: "states.MV.03" },
    { code: "04", name: "states.MV.04" },
    { code: "05", name: "states.MV.05" },
    { code: "07", name: "states.MV.07" },
    { code: "08", name: "states.MV.08" },
    { code: "12", name: "states.MV.12" },
    { code: "13", name: "states.MV.13" },
    { code: "14", name: "states.MV.14" },
    { code: "17", name: "states.MV.17" },
    { code: "23", name: "states.MV.23" },
    { code: "24", name: "states.MV.24" },
    { code: "25", name: "states.MV.25" },
    { code: "26", name: "states.MV.26" },
    { code: "27", name: "states.MV.27" },
    { code: "28", name: "states.MV.28" },
    { code: "29", name: "states.MV.29" },
    { code: "CE", name: "states.MV.CE" },
    { code: "MLE", name: "states.MV.MLE" },
    { code: "NC", name: "states.MV.NC" },
    { code: "NO", name: "states.MV.NO" },
    { code: "SC", name: "states.MV.SC" },
    { code: "SU", name: "states.MV.SU" },
    { code: "US", name: "states.MV.US" },
  ],
  MW: [
    { code: "BA", name: "states.MW.BA" },
    { code: "BL", name: "states.MW.BL" },
    { code: "C", name: "states.MW.C" },
    { code: "CK", name: "states.MW.CK" },
    { code: "CR", name: "states.MW.CR" },
    { code: "CT", name: "states.MW.CT" },
    { code: "DE", name: "states.MW.DE" },
    { code: "DO", name: "states.MW.DO" },
    { code: "KR", name: "states.MW.KR" },
    { code: "KS", name: "states.MW.KS" },
    { code: "LI", name: "states.MW.LI" },
    { code: "LK", name: "states.MW.LK" },
    { code: "MC", name: "states.MW.MC" },
    { code: "MG", name: "states.MW.MG" },
    { code: "MH", name: "states.MW.MH" },
    { code: "MU", name: "states.MW.MU" },
    { code: "MW", name: "states.MW.MW" },
    { code: "MZ", name: "states.MW.MZ" },
    { code: "N", name: "states.MW.N" },
    { code: "NB", name: "states.MW.NB" },
    { code: "NI", name: "states.MW.NI" },
    { code: "NK", name: "states.MW.NK" },
    { code: "NS", name: "states.MW.NS" },
    { code: "NU", name: "states.MW.NU" },
    { code: "PH", name: "states.MW.PH" },
    { code: "RU", name: "states.MW.RU" },
    { code: "S", name: "states.MW.S" },
    { code: "SA", name: "states.MW.SA" },
    { code: "TH", name: "states.MW.TH" },
    { code: "ZO", name: "states.MW.ZO" },
  ],
  MX: [
    { code: "AGU", name: "states.MX.AGU" },
    { code: "BCN", name: "states.MX.BCN" },
    { code: "BCS", name: "states.MX.BCS" },
    { code: "CAM", name: "states.MX.CAM" },
    { code: "CDMX", name: "states.MX.CDMX" },
    { code: "CHH", name: "states.MX.CHH" },
    { code: "CHP", name: "states.MX.CHP" },
    { code: "COA", name: "states.MX.COA" },
    { code: "COL", name: "states.MX.COL" },
    { code: "DUR", name: "states.MX.DUR" },
    { code: "GRO", name: "states.MX.GRO" },
    { code: "GUA", name: "states.MX.GUA" },
    { code: "HID", name: "states.MX.HID" },
    { code: "JAL", name: "states.MX.JAL" },
    { code: "MEX", name: "states.MX.MEX" },
    { code: "MIC", name: "states.MX.MIC" },
    { code: "MOR", name: "states.MX.MOR" },
    { code: "NAY", name: "states.MX.NAY" },
    { code: "NLE", name: "states.MX.NLE" },
    { code: "OAX", name: "states.MX.OAX" },
    { code: "PUE", name: "states.MX.PUE" },
    { code: "QUE", name: "states.MX.QUE" },
    { code: "ROO", name: "states.MX.ROO" },
    { code: "SIN", name: "states.MX.SIN" },
    { code: "SLP", name: "states.MX.SLP" },
    { code: "SON", name: "states.MX.SON" },
    { code: "TAB", name: "states.MX.TAB" },
    { code: "TAM", name: "states.MX.TAM" },
    { code: "TLA", name: "states.MX.TLA" },
    { code: "VER", name: "states.MX.VER" },
    { code: "YUC", name: "states.MX.YUC" },
    { code: "ZAC", name: "states.MX.ZAC" },
  ],
  MY: [
    { code: "01", name: "states.MY.01" },
    { code: "02", name: "states.MY.02" },
    { code: "03", name: "states.MY.03" },
    { code: "04", name: "states.MY.04" },
    { code: "05", name: "states.MY.05" },
    { code: "06", name: "states.MY.06" },
    { code: "07", name: "states.MY.07" },
    { code: "08", name: "states.MY.08" },
    { code: "09", name: "states.MY.09" },
    { code: "10", name: "states.MY.10" },
    { code: "11", name: "states.MY.11" },
    { code: "12", name: "states.MY.12" },
    { code: "13", name: "states.MY.13" },
    { code: "14", name: "states.MY.14" },
    { code: "15", name: "states.MY.15" },
    { code: "16", name: "states.MY.16" },
  ],
  MZ: [
    { code: "A", name: "states.MZ.A" },
    { code: "B", name: "states.MZ.B" },
    { code: "G", name: "states.MZ.G" },
    { code: "I", name: "states.MZ.I" },
    { code: "L", name: "states.MZ.L" },
    { code: "MPM", name: "states.MZ.MPM" },
    { code: "N", name: "states.MZ.N" },
    { code: "P", name: "states.MZ.P" },
    { code: "Q", name: "states.MZ.Q" },
    { code: "S", name: "states.MZ.S" },
    { code: "T", name: "states.MZ.T" },
  ],
  NA: [
    { code: "CA", name: "states.NA.CA" },
    { code: "ER", name: "states.NA.ER" },
    { code: "HA", name: "states.NA.HA" },
    { code: "KA", name: "states.NA.KA" },
    { code: "KE", name: "states.NA.KE" },
    { code: "KH", name: "states.NA.KH" },
    { code: "KU", name: "states.NA.KU" },
    { code: "KW", name: "states.NA.KW" },
    { code: "OD", name: "states.NA.OD" },
    { code: "OH", name: "states.NA.OH" },
    { code: "ON", name: "states.NA.ON" },
    { code: "OS", name: "states.NA.OS" },
    { code: "OT", name: "states.NA.OT" },
    { code: "OW", name: "states.NA.OW" },
  ],
  NE: [
    { code: "1", name: "states.NE.1" },
    { code: "2", name: "states.NE.2" },
    { code: "3", name: "states.NE.3" },
    { code: "4", name: "states.NE.4" },
    { code: "5", name: "states.NE.5" },
    { code: "6", name: "states.NE.6" },
    { code: "7", name: "states.NE.7" },
  ],
  NG: [
    { code: "AB", name: "states.NG.AB" },
    { code: "AD", name: "states.NG.AD" },
    { code: "AK", name: "states.NG.AK" },
    { code: "AN", name: "states.NG.AN" },
    { code: "BA", name: "states.NG.BA" },
    { code: "BE", name: "states.NG.BE" },
    { code: "BO", name: "states.NG.BO" },
    { code: "BY", name: "states.NG.BY" },
    { code: "CR", name: "states.NG.CR" },
    { code: "DE", name: "states.NG.DE" },
    { code: "EB", name: "states.NG.EB" },
    { code: "ED", name: "states.NG.ED" },
    { code: "EK", name: "states.NG.EK" },
    { code: "EN", name: "states.NG.EN" },
    { code: "FC", name: "states.NG.FC" },
    { code: "GO", name: "states.NG.GO" },
    { code: "IM", name: "states.NG.IM" },
    { code: "JI", name: "states.NG.JI" },
    { code: "KD", name: "states.NG.KD" },
    { code: "KE", name: "states.NG.KE" },
    { code: "KN", name: "states.NG.KN" },
    { code: "KO", name: "states.NG.KO" },
    { code: "KT", name: "states.NG.KT" },
    { code: "KW", name: "states.NG.KW" },
    { code: "LA", name: "states.NG.LA" },
    { code: "NA", name: "states.NG.NA" },
    { code: "NI", name: "states.NG.NI" },
    { code: "OG", name: "states.NG.OG" },
    { code: "ON", name: "states.NG.ON" },
    { code: "OS", name: "states.NG.OS" },
    { code: "OY", name: "states.NG.OY" },
    { code: "PL", name: "states.NG.PL" },
    { code: "RI", name: "states.NG.RI" },
    { code: "SO", name: "states.NG.SO" },
    { code: "TA", name: "states.NG.TA" },
    { code: "YO", name: "states.NG.YO" },
    { code: "ZA", name: "states.NG.ZA" },
  ],
  NI: [
    { code: "AN", name: "states.NI.AN" },
    { code: "AS", name: "states.NI.AS" },
    { code: "BO", name: "states.NI.BO" },
    { code: "CA", name: "states.NI.CA" },
    { code: "CI", name: "states.NI.CI" },
    { code: "CO", name: "states.NI.CO" },
    { code: "ES", name: "states.NI.ES" },
    { code: "GR", name: "states.NI.GR" },
    { code: "JI", name: "states.NI.JI" },
    { code: "LE", name: "states.NI.LE" },
    { code: "MD", name: "states.NI.MD" },
    { code: "MN", name: "states.NI.MN" },
    { code: "MS", name: "states.NI.MS" },
    { code: "MT", name: "states.NI.MT" },
    { code: "NS", name: "states.NI.NS" },
    { code: "RI", name: "states.NI.RI" },
    { code: "SJ", name: "states.NI.SJ" },
  ],
  NL: [
    { code: "BQ1", name: "states.NL.BQ1" },
    { code: "BQ2", name: "states.NL.BQ2" },
    { code: "BQ3", name: "states.NL.BQ3" },
    { code: "DR", name: "states.NL.DR" },
    { code: "FL", name: "states.NL.FL" },
    { code: "FR", name: "states.NL.FR" },
    { code: "GE", name: "states.NL.GE" },
    { code: "GR", name: "states.NL.GR" },
    { code: "LI", name: "states.NL.LI" },
    { code: "NB", name: "states.NL.NB" },
    { code: "NH", name: "states.NL.NH" },
    { code: "OV", name: "states.NL.OV" },
    { code: "UT", name: "states.NL.UT" },
    { code: "ZE", name: "states.NL.ZE" },
    { code: "ZH", name: "states.NL.ZH" },
  ],
  NO: [
    { code: "01", name: "states.NO.01" },
    { code: "02", name: "states.NO.02" },
    { code: "03", name: "states.NO.03" },
    { code: "04", name: "states.NO.04" },
    { code: "05", name: "states.NO.05" },
    { code: "06", name: "states.NO.06" },
    { code: "07", name: "states.NO.07" },
    { code: "08", name: "states.NO.08" },
    { code: "10", name: "states.NO.10" },
    { code: "11", name: "states.NO.11" },
    { code: "12", name: "states.NO.12" },
    { code: "14", name: "states.NO.14" },
    { code: "15", name: "states.NO.15" },
    { code: "16", name: "states.NO.16" },
    { code: "17", name: "states.NO.17" },
    { code: "18", name: "states.NO.18" },
    { code: "19", name: "states.NO.19" },
    { code: "20", name: "states.NO.20" },
    { code: "21", name: "states.NO.21" },
    { code: "22", name: "states.NO.22" },
    { code: "50", name: "states.NO.50" },
  ],
  NP: [
    { code: "1", name: "states.NP.1" },
    { code: "2", name: "states.NP.2" },
    { code: "3", name: "states.NP.3" },
    { code: "4", name: "states.NP.4" },
    { code: "5", name: "states.NP.5" },
    { code: "BA", name: "states.NP.BA" },
    { code: "BH", name: "states.NP.BH" },
    { code: "DH", name: "states.NP.DH" },
    { code: "GA", name: "states.NP.GA" },
    { code: "JA", name: "states.NP.JA" },
    { code: "KA", name: "states.NP.KA" },
    { code: "KO", name: "states.NP.KO" },
    { code: "LU", name: "states.NP.LU" },
    { code: "MA", name: "states.NP.MA" },
    { code: "ME", name: "states.NP.ME" },
    { code: "NA", name: "states.NP.NA" },
    { code: "RA", name: "states.NP.RA" },
    { code: "SA", name: "states.NP.SA" },
    { code: "SE", name: "states.NP.SE" },
  ],
  NR: [
    { code: "01", name: "states.NR.01" },
    { code: "02", name: "states.NR.02" },
    { code: "03", name: "states.NR.03" },
    { code: "04", name: "states.NR.04" },
    { code: "05", name: "states.NR.05" },
    { code: "06", name: "states.NR.06" },
    { code: "07", name: "states.NR.07" },
    { code: "08", name: "states.NR.08" },
    { code: "09", name: "states.NR.09" },
    { code: "10", name: "states.NR.10" },
    { code: "11", name: "states.NR.11" },
    { code: "12", name: "states.NR.12" },
    { code: "13", name: "states.NR.13" },
    { code: "14", name: "states.NR.14" },
  ],
  NZ: [
    { code: "AUK", name: "states.NZ.AUK" },
    { code: "BOP", name: "states.NZ.BOP" },
    { code: "CAN", name: "states.NZ.CAN" },
    { code: "CIT", name: "states.NZ.CIT" },
    { code: "GIS", name: "states.NZ.GIS" },
    { code: "HKB", name: "states.NZ.HKB" },
    { code: "MBH", name: "states.NZ.MBH" },
    { code: "MWT", name: "states.NZ.MWT" },
    { code: "NSN", name: "states.NZ.NSN" },
    { code: "NTL", name: "states.NZ.NTL" },
    { code: "OTA", name: "states.NZ.OTA" },
    { code: "STL", name: "states.NZ.STL" },
    { code: "TAS", name: "states.NZ.TAS" },
    { code: "TKI", name: "states.NZ.TKI" },
    { code: "WGN", name: "states.NZ.WGN" },
    { code: "WKO", name: "states.NZ.WKO" },
    { code: "WTC", name: "states.NZ.WTC" },
  ],
  OM: [
    { code: "BA", name: "states.OM.BA" },
    { code: "BJ", name: "states.OM.BJ" },
    { code: "BS", name: "states.OM.BS" },
    { code: "BU", name: "states.OM.BU" },
    { code: "DA", name: "states.OM.DA" },
    { code: "MA", name: "states.OM.MA" },
    { code: "MU", name: "states.OM.MU" },
    { code: "SH", name: "states.OM.SH" },
    { code: "SJ", name: "states.OM.SJ" },
    { code: "SS", name: "states.OM.SS" },
    { code: "WU", name: "states.OM.WU" },
    { code: "ZA", name: "states.OM.ZA" },
    { code: "ZU", name: "states.OM.ZU" },
  ],
  PA: [
    { code: "1", name: "states.PA.1" },
    { code: "10", name: "states.PA.10" },
    { code: "2", name: "states.PA.2" },
    { code: "3", name: "states.PA.3" },
    { code: "4", name: "states.PA.4" },
    { code: "5", name: "states.PA.5" },
    { code: "6", name: "states.PA.6" },
    { code: "7", name: "states.PA.7" },
    { code: "8", name: "states.PA.8" },
    { code: "9", name: "states.PA.9" },
    { code: "EM", name: "states.PA.EM" },
    { code: "KY", name: "states.PA.KY" },
    { code: "NB", name: "states.PA.NB" },
  ],
  PE: [
    { code: "AMA", name: "states.PE.AMA" },
    { code: "ANC", name: "states.PE.ANC" },
    { code: "APU", name: "states.PE.APU" },
    { code: "ARE", name: "states.PE.ARE" },
    { code: "AYA", name: "states.PE.AYA" },
    { code: "CAJ", name: "states.PE.CAJ" },
    { code: "CAL", name: "states.PE.CAL" },
    { code: "CUS", name: "states.PE.CUS" },
    { code: "HUC", name: "states.PE.HUC" },
    { code: "HUV", name: "states.PE.HUV" },
    { code: "ICA", name: "states.PE.ICA" },
    { code: "JUN", name: "states.PE.JUN" },
    { code: "LAL", name: "states.PE.LAL" },
    { code: "LAM", name: "states.PE.LAM" },
    { code: "LIM", name: "states.PE.LIM" },
    { code: "LOR", name: "states.PE.LOR" },
    { code: "MDD", name: "states.PE.MDD" },
    { code: "MOQ", name: "states.PE.MOQ" },
    { code: "PAS", name: "states.PE.PAS" },
    { code: "PIU", name: "states.PE.PIU" },
    { code: "PUN", name: "states.PE.PUN" },
    { code: "SAM", name: "states.PE.SAM" },
    { code: "TAC", name: "states.PE.TAC" },
    { code: "TUM", name: "states.PE.TUM" },
    { code: "UCA", name: "states.PE.UCA" },
  ],
  PG: [
    { code: "CPK", name: "states.PG.CPK" },
    { code: "CPM", name: "states.PG.CPM" },
    { code: "EBR", name: "states.PG.EBR" },
    { code: "EHG", name: "states.PG.EHG" },
    { code: "EPW", name: "states.PG.EPW" },
    { code: "GPK", name: "states.PG.GPK" },
    { code: "HLA", name: "states.PG.HLA" },
    { code: "JWK", name: "states.PG.JWK" },
    { code: "MBA", name: "states.PG.MBA" },
    { code: "MPL", name: "states.PG.MPL" },
    { code: "MPM", name: "states.PG.MPM" },
    { code: "MRL", name: "states.PG.MRL" },
    { code: "NCD", name: "states.PG.NCD" },
    { code: "NIK", name: "states.PG.NIK" },
    { code: "NPP", name: "states.PG.NPP" },
    { code: "NSB", name: "states.PG.NSB" },
    { code: "SAN", name: "states.PG.SAN" },
    { code: "SHM", name: "states.PG.SHM" },
    { code: "WBK", name: "states.PG.WBK" },
    { code: "WHM", name: "states.PG.WHM" },
    { code: "WPD", name: "states.PG.WPD" },
  ],
  PH: [
    { code: "01", name: "states.PH.01" },
    { code: "02", name: "states.PH.02" },
    { code: "03", name: "states.PH.03" },
    { code: "05", name: "states.PH.05" },
    { code: "06", name: "states.PH.06" },
    { code: "07", name: "states.PH.07" },
    { code: "08", name: "states.PH.08" },
    { code: "09", name: "states.PH.09" },
    { code: "10", name: "states.PH.10" },
    { code: "11", name: "states.PH.11" },
    { code: "12", name: "states.PH.12" },
    { code: "13", name: "states.PH.13" },
    { code: "14", name: "states.PH.14" },
    { code: "15", name: "states.PH.15" },
    { code: "40", name: "states.PH.40" },
    { code: "41", name: "states.PH.41" },
    { code: "ABR", name: "states.PH.ABR" },
    { code: "AGN", name: "states.PH.AGN" },
    { code: "AGS", name: "states.PH.AGS" },
    { code: "AKL", name: "states.PH.AKL" },
    { code: "ALB", name: "states.PH.ALB" },
    { code: "ANT", name: "states.PH.ANT" },
    { code: "APA", name: "states.PH.APA" },
    { code: "AUR", name: "states.PH.AUR" },
    { code: "BAN", name: "states.PH.BAN" },
    { code: "BAS", name: "states.PH.BAS" },
    { code: "BEN", name: "states.PH.BEN" },
    { code: "BIL", name: "states.PH.BIL" },
    { code: "BOH", name: "states.PH.BOH" },
    { code: "BTG", name: "states.PH.BTG" },
    { code: "BTN", name: "states.PH.BTN" },
    { code: "BUK", name: "states.PH.BUK" },
    { code: "BUL", name: "states.PH.BUL" },
    { code: "CAG", name: "states.PH.CAG" },
    { code: "CAM", name: "states.PH.CAM" },
    { code: "CAN", name: "states.PH.CAN" },
    { code: "CAP", name: "states.PH.CAP" },
    { code: "CAS", name: "states.PH.CAS" },
    { code: "CAT", name: "states.PH.CAT" },
    { code: "CAV", name: "states.PH.CAV" },
    { code: "CEB", name: "states.PH.CEB" },
    { code: "COM", name: "states.PH.COM" },
    { code: "DAO", name: "states.PH.DAO" },
    { code: "DAS", name: "states.PH.DAS" },
    { code: "DAV", name: "states.PH.DAV" },
    { code: "DIN", name: "states.PH.DIN" },
    { code: "DVO", name: "states.PH.DVO" },
    { code: "EAS", name: "states.PH.EAS" },
    { code: "GUI", name: "states.PH.GUI" },
    { code: "IFU", name: "states.PH.IFU" },
    { code: "ILI", name: "states.PH.ILI" },
    { code: "ILN", name: "states.PH.ILN" },
    { code: "ILS", name: "states.PH.ILS" },
    { code: "ISA", name: "states.PH.ISA" },
    { code: "KAL", name: "states.PH.KAL" },
    { code: "LAG", name: "states.PH.LAG" },
    { code: "LAN", name: "states.PH.LAN" },
    { code: "LAS", name: "states.PH.LAS" },
    { code: "LEY", name: "states.PH.LEY" },
    { code: "LUN", name: "states.PH.LUN" },
    { code: "MAD", name: "states.PH.MAD" },
    { code: "MAG", name: "states.PH.MAG" },
    { code: "MAS", name: "states.PH.MAS" },
    { code: "MDC", name: "states.PH.MDC" },
    { code: "MDR", name: "states.PH.MDR" },
    { code: "MOU", name: "states.PH.MOU" },
    { code: "MSC", name: "states.PH.MSC" },
    { code: "MSR", name: "states.PH.MSR" },
    { code: "NCO", name: "states.PH.NCO" },
    { code: "NCR", name: "states.PH.NCR" },
    { code: "NEC", name: "states.PH.NEC" },
    { code: "NER", name: "states.PH.NER" },
    { code: "NSA", name: "states.PH.NSA" },
    { code: "NUE", name: "states.PH.NUE" },
    { code: "NUV", name: "states.PH.NUV" },
    { code: "PAM", name: "states.PH.PAM" },
    { code: "PAN", name: "states.PH.PAN" },
    { code: "PLW", name: "states.PH.PLW" },
    { code: "QUE", name: "states.PH.QUE" },
    { code: "QUI", name: "states.PH.QUI" },
    { code: "RIZ", name: "states.PH.RIZ" },
    { code: "ROM", name: "states.PH.ROM" },
    { code: "SAR", name: "states.PH.SAR" },
    { code: "SCO", name: "states.PH.SCO" },
    { code: "SIG", name: "states.PH.SIG" },
    { code: "SLE", name: "states.PH.SLE" },
    { code: "SLU", name: "states.PH.SLU" },
    { code: "SOR", name: "states.PH.SOR" },
    { code: "SUK", name: "states.PH.SUK" },
    { code: "SUN", name: "states.PH.SUN" },
    { code: "SUR", name: "states.PH.SUR" },
    { code: "TAR", name: "states.PH.TAR" },
    { code: "TAW", name: "states.PH.TAW" },
    { code: "ZAN", name: "states.PH.ZAN" },
    { code: "ZAS", name: "states.PH.ZAS" },
    { code: "ZMB", name: "states.PH.ZMB" },
    { code: "ZSI", name: "states.PH.ZSI" },
  ],
  PK: [
    { code: "BA", name: "states.PK.BA" },
    { code: "GB", name: "states.PK.GB" },
    { code: "IS", name: "states.PK.IS" },
    { code: "JK", name: "states.PK.JK" },
    { code: "KP", name: "states.PK.KP" },
    { code: "PB", name: "states.PK.PB" },
    { code: "SD", name: "states.PK.SD" },
    { code: "TA", name: "states.PK.TA" },
  ],
  PL: [
    { code: "DS", name: "states.PL.DS" },
    { code: "KP", name: "states.PL.KP" },
    { code: "LB", name: "states.PL.LB" },
    { code: "LD", name: "states.PL.LD" },
    { code: "LU", name: "states.PL.LU" },
    { code: "MA", name: "states.PL.MA" },
    { code: "MZ", name: "states.PL.MZ" },
    { code: "OP", name: "states.PL.OP" },
    { code: "PD", name: "states.PL.PD" },
    { code: "PK", name: "states.PL.PK" },
    { code: "PM", name: "states.PL.PM" },
    { code: "SK", name: "states.PL.SK" },
    { code: "SL", name: "states.PL.SL" },
    { code: "WN", name: "states.PL.WN" },
    { code: "WP", name: "states.PL.WP" },
    { code: "ZP", name: "states.PL.ZP" },
  ],
  PT: [
    { code: "01", name: "states.PT.01" },
    { code: "02", name: "states.PT.02" },
    { code: "03", name: "states.PT.03" },
    { code: "04", name: "states.PT.04" },
    { code: "05", name: "states.PT.05" },
    { code: "06", name: "states.PT.06" },
    { code: "07", name: "states.PT.07" },
    { code: "08", name: "states.PT.08" },
    { code: "09", name: "states.PT.09" },
    { code: "10", name: "states.PT.10" },
    { code: "11", name: "states.PT.11" },
    { code: "12", name: "states.PT.12" },
    { code: "13", name: "states.PT.13" },
    { code: "14", name: "states.PT.14" },
    { code: "15", name: "states.PT.15" },
    { code: "16", name: "states.PT.16" },
    { code: "17", name: "states.PT.17" },
    { code: "18", name: "states.PT.18" },
    { code: "20", name: "states.PT.20" },
    { code: "30", name: "states.PT.30" },
  ],
  PW: [
    { code: "002", name: "states.PW.002" },
    { code: "004", name: "states.PW.004" },
    { code: "010", name: "states.PW.010" },
    { code: "050", name: "states.PW.050" },
    { code: "100", name: "states.PW.100" },
    { code: "150", name: "states.PW.150" },
    { code: "212", name: "states.PW.212" },
    { code: "214", name: "states.PW.214" },
    { code: "218", name: "states.PW.218" },
    { code: "222", name: "states.PW.222" },
    { code: "224", name: "states.PW.224" },
    { code: "226", name: "states.PW.226" },
    { code: "227", name: "states.PW.227" },
    { code: "228", name: "states.PW.228" },
    { code: "350", name: "states.PW.350" },
    { code: "370", name: "states.PW.370" },
  ],
  PY: [
    { code: "1", name: "states.PY.1" },
    { code: "10", name: "states.PY.10" },
    { code: "11", name: "states.PY.11" },
    { code: "12", name: "states.PY.12" },
    { code: "13", name: "states.PY.13" },
    { code: "14", name: "states.PY.14" },
    { code: "15", name: "states.PY.15" },
    { code: "16", name: "states.PY.16" },
    { code: "19", name: "states.PY.19" },
    { code: "2", name: "states.PY.2" },
    { code: "3", name: "states.PY.3" },
    { code: "4", name: "states.PY.4" },
    { code: "5", name: "states.PY.5" },
    { code: "6", name: "states.PY.6" },
    { code: "7", name: "states.PY.7" },
    { code: "8", name: "states.PY.8" },
    { code: "9", name: "states.PY.9" },
  ],
  QA: [
    { code: "DA", name: "states.QA.DA" },
    { code: "KH", name: "states.QA.KH" },
    { code: "MS", name: "states.QA.MS" },
    { code: "RA", name: "states.QA.RA" },
    { code: "SH", name: "states.QA.SH" },
    { code: "US", name: "states.QA.US" },
    { code: "WA", name: "states.QA.WA" },
    { code: "ZA", name: "states.QA.ZA" },
  ],
  RO: [
    { code: "AB", name: "states.RO.AB" },
    { code: "AG", name: "states.RO.AG" },
    { code: "AR", name: "states.RO.AR" },
    { code: "B", name: "states.RO.B" },
    { code: "BC", name: "states.RO.BC" },
    { code: "BH", name: "states.RO.BH" },
    { code: "BN", name: "states.RO.BN" },
    { code: "BR", name: "states.RO.BR" },
    { code: "BT", name: "states.RO.BT" },
    { code: "BV", name: "states.RO.BV" },
    { code: "BZ", name: "states.RO.BZ" },
    { code: "CJ", name: "states.RO.CJ" },
    { code: "CL", name: "states.RO.CL" },
    { code: "CS", name: "states.RO.CS" },
    { code: "CT", name: "states.RO.CT" },
    { code: "CV", name: "states.RO.CV" },
    { code: "DB", name: "states.RO.DB" },
    { code: "DJ", name: "states.RO.DJ" },
    { code: "GJ", name: "states.RO.GJ" },
    { code: "GL", name: "states.RO.GL" },
    { code: "GR", name: "states.RO.GR" },
    { code: "HD", name: "states.RO.HD" },
    { code: "HR", name: "states.RO.HR" },
    { code: "IF", name: "states.RO.IF" },
    { code: "IL", name: "states.RO.IL" },
    { code: "IS", name: "states.RO.IS" },
    { code: "MH", name: "states.RO.MH" },
    { code: "MM", name: "states.RO.MM" },
    { code: "MS", name: "states.RO.MS" },
    { code: "NT", name: "states.RO.NT" },
    { code: "OT", name: "states.RO.OT" },
    { code: "PH", name: "states.RO.PH" },
    { code: "SB", name: "states.RO.SB" },
    { code: "SJ", name: "states.RO.SJ" },
    { code: "SM", name: "states.RO.SM" },
    { code: "SV", name: "states.RO.SV" },
    { code: "TL", name: "states.RO.TL" },
    { code: "TM", name: "states.RO.TM" },
    { code: "TR", name: "states.RO.TR" },
    { code: "VL", name: "states.RO.VL" },
    { code: "VN", name: "states.RO.VN" },
    { code: "VS", name: "states.RO.VS" },
  ],
  RS: [
    { code: "00", name: "states.RS.00" },
    { code: "01", name: "states.RS.01" },
    { code: "02", name: "states.RS.02" },
    { code: "03", name: "states.RS.03" },
    { code: "04", name: "states.RS.04" },
    { code: "05", name: "states.RS.05" },
    { code: "06", name: "states.RS.06" },
    { code: "07", name: "states.RS.07" },
    { code: "08", name: "states.RS.08" },
    { code: "09", name: "states.RS.09" },
    { code: "10", name: "states.RS.10" },
    { code: "11", name: "states.RS.11" },
    { code: "12", name: "states.RS.12" },
    { code: "13", name: "states.RS.13" },
    { code: "14", name: "states.RS.14" },
    { code: "15", name: "states.RS.15" },
    { code: "16", name: "states.RS.16" },
    { code: "17", name: "states.RS.17" },
    { code: "18", name: "states.RS.18" },
    { code: "19", name: "states.RS.19" },
    { code: "20", name: "states.RS.20" },
    { code: "21", name: "states.RS.21" },
    { code: "22", name: "states.RS.22" },
    { code: "23", name: "states.RS.23" },
    { code: "24", name: "states.RS.24" },
    { code: "VO", name: "states.RS.VO" },
  ],
  RU: [
    { code: "AD", name: "states.RU.AD" },
    { code: "AL", name: "states.RU.AL" },
    { code: "ALT", name: "states.RU.ALT" },
    { code: "AMU", name: "states.RU.AMU" },
    { code: "ARK", name: "states.RU.ARK" },
    { code: "AST", name: "states.RU.AST" },
    { code: "BA", name: "states.RU.BA" },
    { code: "BEL", name: "states.RU.BEL" },
    { code: "BRY", name: "states.RU.BRY" },
    { code: "BU", name: "states.RU.BU" },
    { code: "CE", name: "states.RU.CE" },
    { code: "CHE", name: "states.RU.CHE" },
    { code: "CHU", name: "states.RU.CHU" },
    { code: "CU", name: "states.RU.CU" },
    { code: "DA", name: "states.RU.DA" },
    { code: "IN", name: "states.RU.IN" },
    { code: "IRK", name: "states.RU.IRK" },
    { code: "IVA", name: "states.RU.IVA" },
    { code: "KAM", name: "states.RU.KAM" },
    { code: "KB", name: "states.RU.KB" },
    { code: "KC", name: "states.RU.KC" },
    { code: "KDA", name: "states.RU.KDA" },
    { code: "KEM", name: "states.RU.KEM" },
    { code: "KGD", name: "states.RU.KGD" },
    { code: "KGN", name: "states.RU.KGN" },
    { code: "KHA", name: "states.RU.KHA" },
    { code: "KHM", name: "states.RU.KHM" },
    { code: "KIR", name: "states.RU.KIR" },
    { code: "KK", name: "states.RU.KK" },
    { code: "KL", name: "states.RU.KL" },
    { code: "KLU", name: "states.RU.KLU" },
    { code: "KO", name: "states.RU.KO" },
    { code: "KOS", name: "states.RU.KOS" },
    { code: "KR", name: "states.RU.KR" },
    { code: "KRS", name: "states.RU.KRS" },
    { code: "KYA", name: "states.RU.KYA" },
    { code: "LEN", name: "states.RU.LEN" },
    { code: "LIP", name: "states.RU.LIP" },
    { code: "MAG", name: "states.RU.MAG" },
    { code: "ME", name: "states.RU.ME" },
    { code: "MO", name: "states.RU.MO" },
    { code: "MOS", name: "states.RU.MOS" },
    { code: "MOW", name: "states.RU.MOW" },
    { code: "MUR", name: "states.RU.MUR" },
    { code: "NEN", name: "states.RU.NEN" },
    { code: "NGR", name: "states.RU.NGR" },
    { code: "NIZ", name: "states.RU.NIZ" },
    { code: "NVS", name: "states.RU.NVS" },
    { code: "OMS", name: "states.RU.OMS" },
    { code: "ORE", name: "states.RU.ORE" },
    { code: "ORL", name: "states.RU.ORL" },
    { code: "PER", name: "states.RU.PER" },
    { code: "PNZ", name: "states.RU.PNZ" },
    { code: "PRI", name: "states.RU.PRI" },
    { code: "PSK", name: "states.RU.PSK" },
    { code: "ROS", name: "states.RU.ROS" },
    { code: "RYA", name: "states.RU.RYA" },
    { code: "SA", name: "states.RU.SA" },
    { code: "SAK", name: "states.RU.SAK" },
    { code: "SAM", name: "states.RU.SAM" },
    { code: "SAR", name: "states.RU.SAR" },
    { code: "SE", name: "states.RU.SE" },
    { code: "SMO", name: "states.RU.SMO" },
    { code: "SPE", name: "states.RU.SPE" },
    { code: "STA", name: "states.RU.STA" },
    { code: "SVE", name: "states.RU.SVE" },
    { code: "TA", name: "states.RU.TA" },
    { code: "TAM", name: "states.RU.TAM" },
    { code: "TOM", name: "states.RU.TOM" },
    { code: "TUL", name: "states.RU.TUL" },
    { code: "TVE", name: "states.RU.TVE" },
    { code: "TY", name: "states.RU.TY" },
    { code: "TYU", name: "states.RU.TYU" },
    { code: "UA-40", name: "states.RU.UA-40" },
    { code: "UD", name: "states.RU.UD" },
    { code: "ULY", name: "states.RU.ULY" },
    { code: "VGG", name: "states.RU.VGG" },
    { code: "VLA", name: "states.RU.VLA" },
    { code: "VLG", name: "states.RU.VLG" },
    { code: "VOR", name: "states.RU.VOR" },
    { code: "YAN", name: "states.RU.YAN" },
    { code: "YAR", name: "states.RU.YAR" },
    { code: "YEV", name: "states.RU.YEV" },
    { code: "ZAB", name: "states.RU.ZAB" },
  ],
  RW: [
    { code: "01", name: "states.RW.01" },
    { code: "02", name: "states.RW.02" },
    { code: "03", name: "states.RW.03" },
    { code: "04", name: "states.RW.04" },
    { code: "05", name: "states.RW.05" },
  ],
  SA: [
    { code: "01", name: "states.SA.01" },
    { code: "02", name: "states.SA.02" },
    { code: "03", name: "states.SA.03" },
    { code: "04", name: "states.SA.04" },
    { code: "05", name: "states.SA.05" },
    { code: "06", name: "states.SA.06" },
    { code: "07", name: "states.SA.07" },
    { code: "08", name: "states.SA.08" },
    { code: "09", name: "states.SA.09" },
    { code: "10", name: "states.SA.10" },
    { code: "11", name: "states.SA.11" },
    { code: "12", name: "states.SA.12" },
    { code: "14", name: "states.SA.14" },
  ],
  SB: [
    { code: "CE", name: "states.SB.CE" },
    { code: "CH", name: "states.SB.CH" },
    { code: "CT", name: "states.SB.CT" },
    { code: "GU", name: "states.SB.GU" },
    { code: "IS", name: "states.SB.IS" },
    { code: "MK", name: "states.SB.MK" },
    { code: "ML", name: "states.SB.ML" },
    { code: "RB", name: "states.SB.RB" },
    { code: "TE", name: "states.SB.TE" },
    { code: "WE", name: "states.SB.WE" },
  ],
  SC: [
    { code: "01", name: "states.SC.01" },
    { code: "02", name: "states.SC.02" },
    { code: "04", name: "states.SC.04" },
    { code: "05", name: "states.SC.05" },
    { code: "06", name: "states.SC.06" },
    { code: "07", name: "states.SC.07" },
    { code: "08", name: "states.SC.08" },
    { code: "09", name: "states.SC.09" },
    { code: "10", name: "states.SC.10" },
    { code: "11", name: "states.SC.11" },
    { code: "12", name: "states.SC.12" },
    { code: "13", name: "states.SC.13" },
    { code: "14", name: "states.SC.14" },
    { code: "15", name: "states.SC.15" },
    { code: "16", name: "states.SC.16" },
    { code: "17", name: "states.SC.17" },
    { code: "18", name: "states.SC.18" },
    { code: "19", name: "states.SC.19" },
    { code: "20", name: "states.SC.20" },
    { code: "21", name: "states.SC.21" },
    { code: "22", name: "states.SC.22" },
    { code: "23", name: "states.SC.23" },
    { code: "24", name: "states.SC.24" },
    { code: "25", name: "states.SC.25" },
  ],
  SD: [
    { code: "DC", name: "states.SD.DC" },
    { code: "DE", name: "states.SD.DE" },
    { code: "DN", name: "states.SD.DN" },
    { code: "DS", name: "states.SD.DS" },
    { code: "DW", name: "states.SD.DW" },
    { code: "GD", name: "states.SD.GD" },
    { code: "GK", name: "states.SD.GK" },
    { code: "GZ", name: "states.SD.GZ" },
    { code: "KA", name: "states.SD.KA" },
    { code: "KH", name: "states.SD.KH" },
    { code: "KN", name: "states.SD.KN" },
    { code: "KS", name: "states.SD.KS" },
    { code: "NB", name: "states.SD.NB" },
    { code: "NO", name: "states.SD.NO" },
    { code: "NR", name: "states.SD.NR" },
    { code: "NW", name: "states.SD.NW" },
    { code: "RS", name: "states.SD.RS" },
    { code: "SI", name: "states.SD.SI" },
  ],
  SE: [
    { code: "AB", name: "states.SE.AB" },
    { code: "AC", name: "states.SE.AC" },
    { code: "BD", name: "states.SE.BD" },
    { code: "C", name: "states.SE.C" },
    { code: "D", name: "states.SE.D" },
    { code: "E", name: "states.SE.E" },
    { code: "F", name: "states.SE.F" },
    { code: "G", name: "states.SE.G" },
    { code: "H", name: "states.SE.H" },
    { code: "I", name: "states.SE.I" },
    { code: "K", name: "states.SE.K" },
    { code: "M", name: "states.SE.M" },
    { code: "N", name: "states.SE.N" },
    { code: "O", name: "states.SE.O" },
    { code: "S", name: "states.SE.S" },
    { code: "T", name: "states.SE.T" },
    { code: "U", name: "states.SE.U" },
    { code: "W", name: "states.SE.W" },
    { code: "X", name: "states.SE.X" },
    { code: "Y", name: "states.SE.Y" },
  ],
  SG: [
    { code: "01", name: "states.SG.01" },
    { code: "02", name: "states.SG.02" },
    { code: "03", name: "states.SG.03" },
    { code: "04", name: "states.SG.04" },
    { code: "05", name: "states.SG.05" },
  ],
  SI: [
    { code: "001", name: "states.SI.001" },
    { code: "002", name: "states.SI.002" },
    { code: "003", name: "states.SI.003" },
    { code: "004", name: "states.SI.004" },
    { code: "005", name: "states.SI.005" },
    { code: "006", name: "states.SI.006" },
    { code: "007", name: "states.SI.007" },
    { code: "008", name: "states.SI.008" },
    { code: "009", name: "states.SI.009" },
    { code: "010", name: "states.SI.010" },
    { code: "011", name: "states.SI.011" },
    { code: "012", name: "states.SI.012" },
    { code: "013", name: "states.SI.013" },
    { code: "014", name: "states.SI.014" },
    { code: "015", name: "states.SI.015" },
    { code: "016", name: "states.SI.016" },
    { code: "017", name: "states.SI.017" },
    { code: "018", name: "states.SI.018" },
    { code: "019", name: "states.SI.019" },
    { code: "020", name: "states.SI.020" },
    { code: "021", name: "states.SI.021" },
    { code: "022", name: "states.SI.022" },
    { code: "023", name: "states.SI.023" },
    { code: "024", name: "states.SI.024" },
    { code: "025", name: "states.SI.025" },
    { code: "026", name: "states.SI.026" },
    { code: "027", name: "states.SI.027" },
    { code: "028", name: "states.SI.028" },
    { code: "029", name: "states.SI.029" },
    { code: "030", name: "states.SI.030" },
    { code: "031", name: "states.SI.031" },
    { code: "032", name: "states.SI.032" },
    { code: "033", name: "states.SI.033" },
    { code: "034", name: "states.SI.034" },
    { code: "035", name: "states.SI.035" },
    { code: "036", name: "states.SI.036" },
    { code: "037", name: "states.SI.037" },
    { code: "038", name: "states.SI.038" },
    { code: "039", name: "states.SI.039" },
    { code: "040", name: "states.SI.040" },
    { code: "041", name: "states.SI.041" },
    { code: "042", name: "states.SI.042" },
    { code: "043", name: "states.SI.043" },
    { code: "044", name: "states.SI.044" },
    { code: "045", name: "states.SI.045" },
    { code: "046", name: "states.SI.046" },
    { code: "047", name: "states.SI.047" },
    { code: "048", name: "states.SI.048" },
    { code: "049", name: "states.SI.049" },
    { code: "050", name: "states.SI.050" },
    { code: "051", name: "states.SI.051" },
    { code: "052", name: "states.SI.052" },
    { code: "053", name: "states.SI.053" },
    { code: "054", name: "states.SI.054" },
    { code: "055", name: "states.SI.055" },
    { code: "056", name: "states.SI.056" },
    { code: "057", name: "states.SI.057" },
    { code: "058", name: "states.SI.058" },
    { code: "059", name: "states.SI.059" },
    { code: "060", name: "states.SI.060" },
    { code: "061", name: "states.SI.061" },
    { code: "062", name: "states.SI.062" },
    { code: "063", name: "states.SI.063" },
    { code: "064", name: "states.SI.064" },
    { code: "065", name: "states.SI.065" },
    { code: "066", name: "states.SI.066" },
    { code: "067", name: "states.SI.067" },
    { code: "068", name: "states.SI.068" },
    { code: "069", name: "states.SI.069" },
    { code: "070", name: "states.SI.070" },
    { code: "071", name: "states.SI.071" },
    { code: "072", name: "states.SI.072" },
    { code: "073", name: "states.SI.073" },
    { code: "074", name: "states.SI.074" },
    { code: "075", name: "states.SI.075" },
    { code: "076", name: "states.SI.076" },
    { code: "077", name: "states.SI.077" },
    { code: "078", name: "states.SI.078" },
    { code: "079", name: "states.SI.079" },
    { code: "080", name: "states.SI.080" },
    { code: "081", name: "states.SI.081" },
    { code: "082", name: "states.SI.082" },
    { code: "083", name: "states.SI.083" },
    { code: "084", name: "states.SI.084" },
    { code: "085", name: "states.SI.085" },
    { code: "086", name: "states.SI.086" },
    { code: "087", name: "states.SI.087" },
    { code: "088", name: "states.SI.088" },
    { code: "089", name: "states.SI.089" },
    { code: "090", name: "states.SI.090" },
    { code: "091", name: "states.SI.091" },
    { code: "092", name: "states.SI.092" },
    { code: "093", name: "states.SI.093" },
    { code: "094", name: "states.SI.094" },
    { code: "095", name: "states.SI.095" },
    { code: "096", name: "states.SI.096" },
    { code: "097", name: "states.SI.097" },
    { code: "098", name: "states.SI.098" },
    { code: "099", name: "states.SI.099" },
    { code: "100", name: "states.SI.100" },
    { code: "101", name: "states.SI.101" },
    { code: "102", name: "states.SI.102" },
    { code: "103", name: "states.SI.103" },
    { code: "104", name: "states.SI.104" },
    { code: "105", name: "states.SI.105" },
    { code: "106", name: "states.SI.106" },
    { code: "107", name: "states.SI.107" },
    { code: "108", name: "states.SI.108" },
    { code: "109", name: "states.SI.109" },
    { code: "110", name: "states.SI.110" },
    { code: "111", name: "states.SI.111" },
    { code: "112", name: "states.SI.112" },
    { code: "113", name: "states.SI.113" },
    { code: "114", name: "states.SI.114" },
    { code: "115", name: "states.SI.115" },
    { code: "116", name: "states.SI.116" },
    { code: "117", name: "states.SI.117" },
    { code: "118", name: "states.SI.118" },
    { code: "119", name: "states.SI.119" },
    { code: "120", name: "states.SI.120" },
    { code: "121", name: "states.SI.121" },
    { code: "122", name: "states.SI.122" },
    { code: "123", name: "states.SI.123" },
    { code: "124", name: "states.SI.124" },
    { code: "125", name: "states.SI.125" },
    { code: "126", name: "states.SI.126" },
    { code: "127", name: "states.SI.127" },
    { code: "128", name: "states.SI.128" },
    { code: "129", name: "states.SI.129" },
    { code: "130", name: "states.SI.130" },
    { code: "131", name: "states.SI.131" },
    { code: "132", name: "states.SI.132" },
    { code: "134", name: "states.SI.134" },
    { code: "135", name: "states.SI.135" },
    { code: "136", name: "states.SI.136" },
    { code: "137", name: "states.SI.137" },
    { code: "138", name: "states.SI.138" },
    { code: "139", name: "states.SI.139" },
    { code: "140", name: "states.SI.140" },
    { code: "141", name: "states.SI.141" },
    { code: "142", name: "states.SI.142" },
    { code: "143", name: "states.SI.143" },
    { code: "144", name: "states.SI.144" },
    { code: "146", name: "states.SI.146" },
    { code: "147", name: "states.SI.147" },
    { code: "148", name: "states.SI.148" },
    { code: "149", name: "states.SI.149" },
    { code: "150", name: "states.SI.150" },
    { code: "151", name: "states.SI.151" },
    { code: "152", name: "states.SI.152" },
    { code: "153", name: "states.SI.153" },
    { code: "154", name: "states.SI.154" },
    { code: "155", name: "states.SI.155" },
    { code: "156", name: "states.SI.156" },
    { code: "157", name: "states.SI.157" },
    { code: "158", name: "states.SI.158" },
    { code: "159", name: "states.SI.159" },
    { code: "160", name: "states.SI.160" },
    { code: "161", name: "states.SI.161" },
    { code: "162", name: "states.SI.162" },
    { code: "163", name: "states.SI.163" },
    { code: "164", name: "states.SI.164" },
    { code: "165", name: "states.SI.165" },
    { code: "166", name: "states.SI.166" },
    { code: "167", name: "states.SI.167" },
    { code: "168", name: "states.SI.168" },
    { code: "169", name: "states.SI.169" },
    { code: "170", name: "states.SI.170" },
    { code: "171", name: "states.SI.171" },
    { code: "172", name: "states.SI.172" },
    { code: "173", name: "states.SI.173" },
    { code: "174", name: "states.SI.174" },
    { code: "175", name: "states.SI.175" },
    { code: "176", name: "states.SI.176" },
    { code: "177", name: "states.SI.177" },
    { code: "178", name: "states.SI.178" },
    { code: "179", name: "states.SI.179" },
    { code: "180", name: "states.SI.180" },
    { code: "181", name: "states.SI.181" },
    { code: "182", name: "states.SI.182" },
    { code: "183", name: "states.SI.183" },
    { code: "184", name: "states.SI.184" },
    { code: "185", name: "states.SI.185" },
    { code: "186", name: "states.SI.186" },
    { code: "187", name: "states.SI.187" },
    { code: "188", name: "states.SI.188" },
    { code: "189", name: "states.SI.189" },
    { code: "190", name: "states.SI.190" },
    { code: "191", name: "states.SI.191" },
    { code: "192", name: "states.SI.192" },
    { code: "193", name: "states.SI.193" },
    { code: "194", name: "states.SI.194" },
    { code: "195", name: "states.SI.195" },
    { code: "196", name: "states.SI.196" },
    { code: "197", name: "states.SI.197" },
    { code: "198", name: "states.SI.198" },
    { code: "199", name: "states.SI.199" },
    { code: "200", name: "states.SI.200" },
    { code: "201", name: "states.SI.201" },
    { code: "202", name: "states.SI.202" },
    { code: "203", name: "states.SI.203" },
    { code: "204", name: "states.SI.204" },
    { code: "205", name: "states.SI.205" },
    { code: "206", name: "states.SI.206" },
    { code: "207", name: "states.SI.207" },
    { code: "208", name: "states.SI.208" },
    { code: "209", name: "states.SI.209" },
    { code: "210", name: "states.SI.210" },
    { code: "211", name: "states.SI.211" },
    { code: "212", name: "states.SI.212" },
    { code: "213", name: "states.SI.213" },
  ],
  SK: [
    { code: "BC", name: "states.SK.BC" },
    { code: "BL", name: "states.SK.BL" },
    { code: "KI", name: "states.SK.KI" },
    { code: "NI", name: "states.SK.NI" },
    { code: "PV", name: "states.SK.PV" },
    { code: "TA", name: "states.SK.TA" },
    { code: "TC", name: "states.SK.TC" },
    { code: "ZI", name: "states.SK.ZI" },
  ],
  SL: [
    { code: "E", name: "states.SL.E" },
    { code: "N", name: "states.SL.N" },
    { code: "S", name: "states.SL.S" },
    { code: "W", name: "states.SL.W" },
  ],
  SM: [
    { code: "01", name: "states.SM.01" },
    { code: "02", name: "states.SM.02" },
    { code: "03", name: "states.SM.03" },
    { code: "04", name: "states.SM.04" },
    { code: "05", name: "states.SM.05" },
    { code: "06", name: "states.SM.06" },
    { code: "07", name: "states.SM.07" },
    { code: "08", name: "states.SM.08" },
    { code: "09", name: "states.SM.09" },
  ],
  SN: [
    { code: "DB", name: "states.SN.DB" },
    { code: "DK", name: "states.SN.DK" },
    { code: "FK", name: "states.SN.FK" },
    { code: "KA", name: "states.SN.KA" },
    { code: "KD", name: "states.SN.KD" },
    { code: "KE", name: "states.SN.KE" },
    { code: "KL", name: "states.SN.KL" },
    { code: "LG", name: "states.SN.LG" },
    { code: "MT", name: "states.SN.MT" },
    { code: "SE", name: "states.SN.SE" },
    { code: "SL", name: "states.SN.SL" },
    { code: "TC", name: "states.SN.TC" },
    { code: "TH", name: "states.SN.TH" },
    { code: "ZG", name: "states.SN.ZG" },
  ],
  SO: [
    { code: "AW", name: "states.SO.AW" },
    { code: "BK", name: "states.SO.BK" },
    { code: "BN", name: "states.SO.BN" },
    { code: "BR", name: "states.SO.BR" },
    { code: "BY", name: "states.SO.BY" },
    { code: "GA", name: "states.SO.GA" },
    { code: "GE", name: "states.SO.GE" },
    { code: "HI", name: "states.SO.HI" },
    { code: "JD", name: "states.SO.JD" },
    { code: "JH", name: "states.SO.JH" },
    { code: "MU", name: "states.SO.MU" },
    { code: "NU", name: "states.SO.NU" },
    { code: "SA", name: "states.SO.SA" },
    { code: "SD", name: "states.SO.SD" },
    { code: "SH", name: "states.SO.SH" },
    { code: "TO", name: "states.SO.TO" },
  ],
  SR: [
    { code: "BR", name: "states.SR.BR" },
    { code: "CM", name: "states.SR.CM" },
    { code: "CR", name: "states.SR.CR" },
    { code: "MA", name: "states.SR.MA" },
    { code: "NI", name: "states.SR.NI" },
    { code: "PM", name: "states.SR.PM" },
    { code: "PR", name: "states.SR.PR" },
    { code: "SA", name: "states.SR.SA" },
    { code: "SI", name: "states.SR.SI" },
    { code: "WA", name: "states.SR.WA" },
  ],
  SS: [
    { code: "BN", name: "states.SS.BN" },
    { code: "BW", name: "states.SS.BW" },
    { code: "EC", name: "states.SS.EC" },
    { code: "EE", name: "states.SS.EE" },
    { code: "EW", name: "states.SS.EW" },
    { code: "JG", name: "states.SS.JG" },
    { code: "LK", name: "states.SS.LK" },
    { code: "NU", name: "states.SS.NU" },
    { code: "UY", name: "states.SS.UY" },
    { code: "WR", name: "states.SS.WR" },
  ],
  ST: [
    { code: "P", name: "states.ST.P" },
    { code: "S", name: "states.ST.S" },
  ],
  SV: [
    { code: "AH", name: "states.SV.AH" },
    { code: "CA", name: "states.SV.CA" },
    { code: "CH", name: "states.SV.CH" },
    { code: "CU", name: "states.SV.CU" },
    { code: "LI", name: "states.SV.LI" },
    { code: "MO", name: "states.SV.MO" },
    { code: "PA", name: "states.SV.PA" },
    { code: "SA", name: "states.SV.SA" },
    { code: "SM", name: "states.SV.SM" },
    { code: "SO", name: "states.SV.SO" },
    { code: "SS", name: "states.SV.SS" },
    { code: "SV", name: "states.SV.SV" },
    { code: "UN", name: "states.SV.UN" },
    { code: "US", name: "states.SV.US" },
  ],
  SY: [
    { code: "DI", name: "states.SY.DI" },
    { code: "DR", name: "states.SY.DR" },
    { code: "DY", name: "states.SY.DY" },
    { code: "HA", name: "states.SY.HA" },
    { code: "HI", name: "states.SY.HI" },
    { code: "HL", name: "states.SY.HL" },
    { code: "HM", name: "states.SY.HM" },
    { code: "ID", name: "states.SY.ID" },
    { code: "LA", name: "states.SY.LA" },
    { code: "QU", name: "states.SY.QU" },
    { code: "RA", name: "states.SY.RA" },
    { code: "RD", name: "states.SY.RD" },
    { code: "SU", name: "states.SY.SU" },
    { code: "TA", name: "states.SY.TA" },
  ],
  SZ: [
    { code: "HH", name: "states.SZ.HH" },
    { code: "LU", name: "states.SZ.LU" },
    { code: "MA", name: "states.SZ.MA" },
    { code: "SH", name: "states.SZ.SH" },
  ],
  TD: [
    { code: "BA", name: "states.TD.BA" },
    { code: "BG", name: "states.TD.BG" },
    { code: "BO", name: "states.TD.BO" },
    { code: "EE", name: "states.TD.EE" },
    { code: "EN", name: "states.TD.EN" },
    { code: "EO", name: "states.TD.EO" },
    { code: "GR", name: "states.TD.GR" },
    { code: "HL", name: "states.TD.HL" },
    { code: "KA", name: "states.TD.KA" },
    { code: "LC", name: "states.TD.LC" },
    { code: "LO", name: "states.TD.LO" },
    { code: "LR", name: "states.TD.LR" },
    { code: "MA", name: "states.TD.MA" },
    { code: "MC", name: "states.TD.MC" },
    { code: "ME", name: "states.TD.ME" },
    { code: "MO", name: "states.TD.MO" },
    { code: "ND", name: "states.TD.ND" },
    { code: "OD", name: "states.TD.OD" },
    { code: "SA", name: "states.TD.SA" },
    { code: "SI", name: "states.TD.SI" },
    { code: "TA", name: "states.TD.TA" },
    { code: "TI", name: "states.TD.TI" },
    { code: "WF", name: "states.TD.WF" },
  ],
  TG: [
    { code: "C", name: "states.TG.C" },
    { code: "K", name: "states.TG.K" },
    { code: "M", name: "states.TG.M" },
    { code: "P", name: "states.TG.P" },
    { code: "S", name: "states.TG.S" },
  ],
  TH: [
    { code: "10", name: "states.TH.10" },
    { code: "11", name: "states.TH.11" },
    { code: "12", name: "states.TH.12" },
    { code: "13", name: "states.TH.13" },
    { code: "14", name: "states.TH.14" },
    { code: "15", name: "states.TH.15" },
    { code: "16", name: "states.TH.16" },
    { code: "17", name: "states.TH.17" },
    { code: "18", name: "states.TH.18" },
    { code: "19", name: "states.TH.19" },
    { code: "20", name: "states.TH.20" },
    { code: "21", name: "states.TH.21" },
    { code: "22", name: "states.TH.22" },
    { code: "23", name: "states.TH.23" },
    { code: "24", name: "states.TH.24" },
    { code: "25", name: "states.TH.25" },
    { code: "26", name: "states.TH.26" },
    { code: "27", name: "states.TH.27" },
    { code: "30", name: "states.TH.30" },
    { code: "31", name: "states.TH.31" },
    { code: "32", name: "states.TH.32" },
    { code: "33", name: "states.TH.33" },
    { code: "34", name: "states.TH.34" },
    { code: "35", name: "states.TH.35" },
    { code: "36", name: "states.TH.36" },
    { code: "37", name: "states.TH.37" },
    { code: "38", name: "states.TH.38" },
    { code: "39", name: "states.TH.39" },
    { code: "40", name: "states.TH.40" },
    { code: "41", name: "states.TH.41" },
    { code: "42", name: "states.TH.42" },
    { code: "43", name: "states.TH.43" },
    { code: "44", name: "states.TH.44" },
    { code: "45", name: "states.TH.45" },
    { code: "46", name: "states.TH.46" },
    { code: "47", name: "states.TH.47" },
    { code: "48", name: "states.TH.48" },
    { code: "49", name: "states.TH.49" },
    { code: "50", name: "states.TH.50" },
    { code: "51", name: "states.TH.51" },
    { code: "52", name: "states.TH.52" },
    { code: "53", name: "states.TH.53" },
    { code: "54", name: "states.TH.54" },
    { code: "55", name: "states.TH.55" },
    { code: "56", name: "states.TH.56" },
    { code: "57", name: "states.TH.57" },
    { code: "58", name: "states.TH.58" },
    { code: "60", name: "states.TH.60" },
    { code: "61", name: "states.TH.61" },
    { code: "62", name: "states.TH.62" },
    { code: "63", name: "states.TH.63" },
    { code: "64", name: "states.TH.64" },
    { code: "65", name: "states.TH.65" },
    { code: "66", name: "states.TH.66" },
    { code: "67", name: "states.TH.67" },
    { code: "70", name: "states.TH.70" },
    { code: "71", name: "states.TH.71" },
    { code: "72", name: "states.TH.72" },
    { code: "73", name: "states.TH.73" },
    { code: "74", name: "states.TH.74" },
    { code: "75", name: "states.TH.75" },
    { code: "76", name: "states.TH.76" },
    { code: "77", name: "states.TH.77" },
    { code: "80", name: "states.TH.80" },
    { code: "81", name: "states.TH.81" },
    { code: "82", name: "states.TH.82" },
    { code: "83", name: "states.TH.83" },
    { code: "84", name: "states.TH.84" },
    { code: "85", name: "states.TH.85" },
    { code: "86", name: "states.TH.86" },
    { code: "90", name: "states.TH.90" },
    { code: "91", name: "states.TH.91" },
    { code: "92", name: "states.TH.92" },
    { code: "93", name: "states.TH.93" },
    { code: "94", name: "states.TH.94" },
    { code: "95", name: "states.TH.95" },
    { code: "96", name: "states.TH.96" },
    { code: "S", name: "states.TH.S" },
  ],
  TJ: [
    { code: "GB", name: "states.TJ.GB" },
    { code: "KT", name: "states.TJ.KT" },
    { code: "RA", name: "states.TJ.RA" },
    { code: "SU", name: "states.TJ.SU" },
  ],
  TL: [
    { code: "AL", name: "states.TL.AL" },
    { code: "AN", name: "states.TL.AN" },
    { code: "BA", name: "states.TL.BA" },
    { code: "BO", name: "states.TL.BO" },
    { code: "CO", name: "states.TL.CO" },
    { code: "DI", name: "states.TL.DI" },
    { code: "ER", name: "states.TL.ER" },
    { code: "LA", name: "states.TL.LA" },
    { code: "LI", name: "states.TL.LI" },
    { code: "MF", name: "states.TL.MF" },
    { code: "MT", name: "states.TL.MT" },
    { code: "VI", name: "states.TL.VI" },
  ],
  TM: [
    { code: "A", name: "states.TM.A" },
    { code: "B", name: "states.TM.B" },
    { code: "D", name: "states.TM.D" },
    { code: "L", name: "states.TM.L" },
    { code: "M", name: "states.TM.M" },
    { code: "S", name: "states.TM.S" },
  ],
  TN: [
    { code: "11", name: "states.TN.11" },
    { code: "12", name: "states.TN.12" },
    { code: "13", name: "states.TN.13" },
    { code: "14", name: "states.TN.14" },
    { code: "22", name: "states.TN.22" },
    { code: "23", name: "states.TN.23" },
    { code: "31", name: "states.TN.31" },
    { code: "32", name: "states.TN.32" },
    { code: "33", name: "states.TN.33" },
    { code: "34", name: "states.TN.34" },
    { code: "41", name: "states.TN.41" },
    { code: "42", name: "states.TN.42" },
    { code: "43", name: "states.TN.43" },
    { code: "51", name: "states.TN.51" },
    { code: "52", name: "states.TN.52" },
    { code: "53", name: "states.TN.53" },
    { code: "61", name: "states.TN.61" },
    { code: "71", name: "states.TN.71" },
    { code: "72", name: "states.TN.72" },
    { code: "73", name: "states.TN.73" },
    { code: "81", name: "states.TN.81" },
    { code: "82", name: "states.TN.82" },
    { code: "83", name: "states.TN.83" },
  ],
  TO: [
    { code: "01", name: "states.TO.01" },
    { code: "02", name: "states.TO.02" },
    { code: "03", name: "states.TO.03" },
    { code: "04", name: "states.TO.04" },
    { code: "05", name: "states.TO.05" },
  ],
  TR: [
    { code: "01", name: "states.TR.01" },
    { code: "02", name: "states.TR.02" },
    { code: "03", name: "states.TR.03" },
    { code: "04", name: "states.TR.04" },
    { code: "05", name: "states.TR.05" },
    { code: "06", name: "states.TR.06" },
    { code: "07", name: "states.TR.07" },
    { code: "08", name: "states.TR.08" },
    { code: "09", name: "states.TR.09" },
    { code: "10", name: "states.TR.10" },
    { code: "11", name: "states.TR.11" },
    { code: "12", name: "states.TR.12" },
    { code: "13", name: "states.TR.13" },
    { code: "14", name: "states.TR.14" },
    { code: "15", name: "states.TR.15" },
    { code: "16", name: "states.TR.16" },
    { code: "17", name: "states.TR.17" },
    { code: "18", name: "states.TR.18" },
    { code: "19", name: "states.TR.19" },
    { code: "20", name: "states.TR.20" },
    { code: "21", name: "states.TR.21" },
    { code: "22", name: "states.TR.22" },
    { code: "23", name: "states.TR.23" },
    { code: "24", name: "states.TR.24" },
    { code: "25", name: "states.TR.25" },
    { code: "26", name: "states.TR.26" },
    { code: "27", name: "states.TR.27" },
    { code: "28", name: "states.TR.28" },
    { code: "29", name: "states.TR.29" },
    { code: "30", name: "states.TR.30" },
    { code: "31", name: "states.TR.31" },
    { code: "32", name: "states.TR.32" },
    { code: "33", name: "states.TR.33" },
    { code: "34", name: "states.TR.34" },
    { code: "35", name: "states.TR.35" },
    { code: "36", name: "states.TR.36" },
    { code: "37", name: "states.TR.37" },
    { code: "38", name: "states.TR.38" },
    { code: "39", name: "states.TR.39" },
    { code: "40", name: "states.TR.40" },
    { code: "41", name: "states.TR.41" },
    { code: "42", name: "states.TR.42" },
    { code: "43", name: "states.TR.43" },
    { code: "44", name: "states.TR.44" },
    { code: "45", name: "states.TR.45" },
    { code: "46", name: "states.TR.46" },
    { code: "47", name: "states.TR.47" },
    { code: "48", name: "states.TR.48" },
    { code: "49", name: "states.TR.49" },
    { code: "50", name: "states.TR.50" },
    { code: "51", name: "states.TR.51" },
    { code: "52", name: "states.TR.52" },
    { code: "53", name: "states.TR.53" },
    { code: "54", name: "states.TR.54" },
    { code: "55", name: "states.TR.55" },
    { code: "56", name: "states.TR.56" },
    { code: "57", name: "states.TR.57" },
    { code: "58", name: "states.TR.58" },
    { code: "59", name: "states.TR.59" },
    { code: "60", name: "states.TR.60" },
    { code: "61", name: "states.TR.61" },
    { code: "62", name: "states.TR.62" },
    { code: "63", name: "states.TR.63" },
    { code: "64", name: "states.TR.64" },
    { code: "65", name: "states.TR.65" },
    { code: "66", name: "states.TR.66" },
    { code: "67", name: "states.TR.67" },
    { code: "68", name: "states.TR.68" },
    { code: "69", name: "states.TR.69" },
    { code: "70", name: "states.TR.70" },
    { code: "71", name: "states.TR.71" },
    { code: "72", name: "states.TR.72" },
    { code: "73", name: "states.TR.73" },
    { code: "74", name: "states.TR.74" },
    { code: "75", name: "states.TR.75" },
    { code: "76", name: "states.TR.76" },
    { code: "77", name: "states.TR.77" },
    { code: "78", name: "states.TR.78" },
    { code: "79", name: "states.TR.79" },
    { code: "80", name: "states.TR.80" },
    { code: "81", name: "states.TR.81" },
  ],
  TT: [
    { code: "ARI", name: "states.TT.ARI" },
    { code: "CHA", name: "states.TT.CHA" },
    { code: "CTT", name: "states.TT.CTT" },
    { code: "DMN", name: "states.TT.DMN" },
    { code: "ETO", name: "states.TT.ETO" },
    { code: "MRC", name: "states.TT.MRC" },
    { code: "PED", name: "states.TT.PED" },
    { code: "POS", name: "states.TT.POS" },
    { code: "PRT", name: "states.TT.PRT" },
    { code: "PTF", name: "states.TT.PTF" },
    { code: "SFO", name: "states.TT.SFO" },
    { code: "SGE", name: "states.TT.SGE" },
    { code: "SIP", name: "states.TT.SIP" },
    { code: "SJL", name: "states.TT.SJL" },
    { code: "TUP", name: "states.TT.TUP" },
    { code: "WTO", name: "states.TT.WTO" },
  ],
  TV: [
    { code: "FUN", name: "states.TV.FUN" },
    { code: "NIT", name: "states.TV.NIT" },
    { code: "NKF", name: "states.TV.NKF" },
    { code: "NKL", name: "states.TV.NKL" },
    { code: "NMA", name: "states.TV.NMA" },
    { code: "NMG", name: "states.TV.NMG" },
    { code: "NUI", name: "states.TV.NUI" },
    { code: "VAI", name: "states.TV.VAI" },
  ],
  TW: [
    { code: "CHA", name: "states.TW.CHA" },
    { code: "CYI", name: "states.TW.CYI" },
    { code: "CYQ", name: "states.TW.CYQ" },
    { code: "HSQ", name: "states.TW.HSQ" },
    { code: "HSZ", name: "states.TW.HSZ" },
    { code: "HUA", name: "states.TW.HUA" },
    { code: "ILA", name: "states.TW.ILA" },
    { code: "KEE", name: "states.TW.KEE" },
    { code: "KHH", name: "states.TW.KHH" },
    { code: "KIN", name: "states.TW.KIN" },
    { code: "LIE", name: "states.TW.LIE" },
    { code: "MIA", name: "states.TW.MIA" },
    { code: "NAN", name: "states.TW.NAN" },
    { code: "NWT", name: "states.TW.NWT" },
    { code: "PEN", name: "states.TW.PEN" },
    { code: "PIF", name: "states.TW.PIF" },
    { code: "TAO", name: "states.TW.TAO" },
    { code: "TNN", name: "states.TW.TNN" },
    { code: "TPE", name: "states.TW.TPE" },
    { code: "TTT", name: "states.TW.TTT" },
    { code: "TXG", name: "states.TW.TXG" },
    { code: "YUN", name: "states.TW.YUN" },
  ],
  TZ: [
    { code: "01", name: "states.TZ.01" },
    { code: "02", name: "states.TZ.02" },
    { code: "03", name: "states.TZ.03" },
    { code: "04", name: "states.TZ.04" },
    { code: "05", name: "states.TZ.05" },
    { code: "06", name: "states.TZ.06" },
    { code: "07", name: "states.TZ.07" },
    { code: "08", name: "states.TZ.08" },
    { code: "09", name: "states.TZ.09" },
    { code: "10", name: "states.TZ.10" },
    { code: "11", name: "states.TZ.11" },
    { code: "12", name: "states.TZ.12" },
    { code: "13", name: "states.TZ.13" },
    { code: "14", name: "states.TZ.14" },
    { code: "15", name: "states.TZ.15" },
    { code: "16", name: "states.TZ.16" },
    { code: "17", name: "states.TZ.17" },
    { code: "18", name: "states.TZ.18" },
    { code: "19", name: "states.TZ.19" },
    { code: "20", name: "states.TZ.20" },
    { code: "21", name: "states.TZ.21" },
    { code: "22", name: "states.TZ.22" },
    { code: "23", name: "states.TZ.23" },
    { code: "24", name: "states.TZ.24" },
    { code: "25", name: "states.TZ.25" },
    { code: "26", name: "states.TZ.26" },
    { code: "27", name: "states.TZ.27" },
    { code: "28", name: "states.TZ.28" },
    { code: "29", name: "states.TZ.29" },
    { code: "30", name: "states.TZ.30" },
    { code: "31", name: "states.TZ.31" },
  ],
  UA: [
    { code: "05", name: "states.UA.05" },
    { code: "07", name: "states.UA.07" },
    { code: "09", name: "states.UA.09" },
    { code: "12", name: "states.UA.12" },
    { code: "14", name: "states.UA.14" },
    { code: "18", name: "states.UA.18" },
    { code: "21", name: "states.UA.21" },
    { code: "23", name: "states.UA.23" },
    { code: "26", name: "states.UA.26" },
    { code: "30", name: "states.UA.30" },
    { code: "32", name: "states.UA.32" },
    { code: "35", name: "states.UA.35" },
    { code: "43", name: "states.UA.43" },
    { code: "46", name: "states.UA.46" },
    { code: "48", name: "states.UA.48" },
    { code: "51", name: "states.UA.51" },
    { code: "53", name: "states.UA.53" },
    { code: "56", name: "states.UA.56" },
    { code: "59", name: "states.UA.59" },
    { code: "61", name: "states.UA.61" },
    { code: "63", name: "states.UA.63" },
    { code: "65", name: "states.UA.65" },
    { code: "68", name: "states.UA.68" },
    { code: "71", name: "states.UA.71" },
    { code: "74", name: "states.UA.74" },
    { code: "77", name: "states.UA.77" },
  ],
  UG: [
    { code: "101", name: "states.UG.101" },
    { code: "102", name: "states.UG.102" },
    { code: "103", name: "states.UG.103" },
    { code: "104", name: "states.UG.104" },
    { code: "105", name: "states.UG.105" },
    { code: "106", name: "states.UG.106" },
    { code: "107", name: "states.UG.107" },
    { code: "108", name: "states.UG.108" },
    { code: "109", name: "states.UG.109" },
    { code: "110", name: "states.UG.110" },
    { code: "111", name: "states.UG.111" },
    { code: "112", name: "states.UG.112" },
    { code: "113", name: "states.UG.113" },
    { code: "114", name: "states.UG.114" },
    { code: "115", name: "states.UG.115" },
    { code: "116", name: "states.UG.116" },
    { code: "117", name: "states.UG.117" },
    { code: "118", name: "states.UG.118" },
    { code: "119", name: "states.UG.119" },
    { code: "120", name: "states.UG.120" },
    { code: "121", name: "states.UG.121" },
    { code: "122", name: "states.UG.122" },
    { code: "123", name: "states.UG.123" },
    { code: "124", name: "states.UG.124" },
    { code: "125", name: "states.UG.125" },
    { code: "201", name: "states.UG.201" },
    { code: "202", name: "states.UG.202" },
    { code: "203", name: "states.UG.203" },
    { code: "204", name: "states.UG.204" },
    { code: "205", name: "states.UG.205" },
    { code: "206", name: "states.UG.206" },
    { code: "207", name: "states.UG.207" },
    { code: "208", name: "states.UG.208" },
    { code: "209", name: "states.UG.209" },
    { code: "210", name: "states.UG.210" },
    { code: "211", name: "states.UG.211" },
    { code: "212", name: "states.UG.212" },
    { code: "213", name: "states.UG.213" },
    { code: "214", name: "states.UG.214" },
    { code: "215", name: "states.UG.215" },
    { code: "216", name: "states.UG.216" },
    { code: "217", name: "states.UG.217" },
    { code: "218", name: "states.UG.218" },
    { code: "219", name: "states.UG.219" },
    { code: "220", name: "states.UG.220" },
    { code: "221", name: "states.UG.221" },
    { code: "222", name: "states.UG.222" },
    { code: "223", name: "states.UG.223" },
    { code: "224", name: "states.UG.224" },
    { code: "225", name: "states.UG.225" },
    { code: "226", name: "states.UG.226" },
    { code: "227", name: "states.UG.227" },
    { code: "228", name: "states.UG.228" },
    { code: "229", name: "states.UG.229" },
    { code: "230", name: "states.UG.230" },
    { code: "231", name: "states.UG.231" },
    { code: "232", name: "states.UG.232" },
    { code: "233", name: "states.UG.233" },
    { code: "234", name: "states.UG.234" },
    { code: "301", name: "states.UG.301" },
    { code: "302", name: "states.UG.302" },
    { code: "303", name: "states.UG.303" },
    { code: "304", name: "states.UG.304" },
    { code: "305", name: "states.UG.305" },
    { code: "306", name: "states.UG.306" },
    { code: "307", name: "states.UG.307" },
    { code: "308", name: "states.UG.308" },
    { code: "309", name: "states.UG.309" },
    { code: "310", name: "states.UG.310" },
    { code: "311", name: "states.UG.311" },
    { code: "312", name: "states.UG.312" },
    { code: "313", name: "states.UG.313" },
    { code: "314", name: "states.UG.314" },
    { code: "315", name: "states.UG.315" },
    { code: "316", name: "states.UG.316" },
    { code: "317", name: "states.UG.317" },
    { code: "318", name: "states.UG.318" },
    { code: "319", name: "states.UG.319" },
    { code: "320", name: "states.UG.320" },
    { code: "321", name: "states.UG.321" },
    { code: "322", name: "states.UG.322" },
    { code: "323", name: "states.UG.323" },
    { code: "324", name: "states.UG.324" },
    { code: "325", name: "states.UG.325" },
    { code: "326", name: "states.UG.326" },
    { code: "327", name: "states.UG.327" },
    { code: "328", name: "states.UG.328" },
    { code: "329", name: "states.UG.329" },
    { code: "330", name: "states.UG.330" },
    { code: "331", name: "states.UG.331" },
    { code: "332", name: "states.UG.332" },
    { code: "401", name: "states.UG.401" },
    { code: "402", name: "states.UG.402" },
    { code: "404", name: "states.UG.404" },
    { code: "405", name: "states.UG.405" },
    { code: "406", name: "states.UG.406" },
    { code: "407", name: "states.UG.407" },
    { code: "408", name: "states.UG.408" },
    { code: "409", name: "states.UG.409" },
    { code: "410", name: "states.UG.410" },
    { code: "411", name: "states.UG.411" },
    { code: "412", name: "states.UG.412" },
    { code: "413", name: "states.UG.413" },
    { code: "414", name: "states.UG.414" },
    { code: "415", name: "states.UG.415" },
    { code: "416", name: "states.UG.416" },
    { code: "417", name: "states.UG.417" },
    { code: "418", name: "states.UG.418" },
    { code: "419", name: "states.UG.419" },
    { code: "420", name: "states.UG.420" },
    { code: "421", name: "states.UG.421" },
    { code: "422", name: "states.UG.422" },
    { code: "423", name: "states.UG.423" },
    { code: "424", name: "states.UG.424" },
    { code: "425", name: "states.UG.425" },
    { code: "426", name: "states.UG.426" },
    { code: "427", name: "states.UG.427" },
    { code: "428", name: "states.UG.428" },
    { code: "429", name: "states.UG.429" },
    { code: "430", name: "states.UG.430" },
    { code: "431", name: "states.UG.431" },
    { code: "C", name: "states.UG.C" },
    { code: "E", name: "states.UG.E" },
    { code: "N", name: "states.UG.N" },
    { code: "W", name: "states.UG.W" },
  ],
  US: [
    { code: "AK", name: "states.US.AK" },
    { code: "AL", name: "states.US.AL" },
    { code: "AR", name: "states.US.AR" },
    { code: "AS", name: "states.US.AS" },
    { code: "AZ", name: "states.US.AZ" },
    { code: "CA", name: "states.US.CA" },
    { code: "CO", name: "states.US.CO" },
    { code: "CT", name: "states.US.CT" },
    { code: "DC", name: "states.US.DC" },
    { code: "DE", name: "states.US.DE" },
    { code: "FL", name: "states.US.FL" },
    { code: "GA", name: "states.US.GA" },
    { code: "GU", name: "states.US.GU" },
    { code: "HI", name: "states.US.HI" },
    { code: "IA", name: "states.US.IA" },
    { code: "ID", name: "states.US.ID" },
    { code: "IL", name: "states.US.IL" },
    { code: "IN", name: "states.US.IN" },
    { code: "KS", name: "states.US.KS" },
    { code: "KY", name: "states.US.KY" },
    { code: "LA", name: "states.US.LA" },
    { code: "MA", name: "states.US.MA" },
    { code: "MD", name: "states.US.MD" },
    { code: "ME", name: "states.US.ME" },
    { code: "MI", name: "states.US.MI" },
    { code: "MN", name: "states.US.MN" },
    { code: "MO", name: "states.US.MO" },
    { code: "MP", name: "states.US.MP" },
    { code: "MS", name: "states.US.MS" },
    { code: "MT", name: "states.US.MT" },
    { code: "NC", name: "states.US.NC" },
    { code: "ND", name: "states.US.ND" },
    { code: "NE", name: "states.US.NE" },
    { code: "NH", name: "states.US.NH" },
    { code: "NJ", name: "states.US.NJ" },
    { code: "NM", name: "states.US.NM" },
    { code: "NV", name: "states.US.NV" },
    { code: "NY", name: "states.US.NY" },
    { code: "OH", name: "states.US.OH" },
    { code: "OK", name: "states.US.OK" },
    { code: "OR", name: "states.US.OR" },
    { code: "PA", name: "states.US.PA" },
    { code: "PR", name: "states.US.PR" },
    { code: "RI", name: "states.US.RI" },
    { code: "SC", name: "states.US.SC" },
    { code: "SD", name: "states.US.SD" },
    { code: "TN", name: "states.US.TN" },
    { code: "TX", name: "states.US.TX" },
    { code: "UM", name: "states.US.UM" },
    { code: "UM-67", name: "states.US.UM-67" },
    { code: "UM-71", name: "states.US.UM-71" },
    { code: "UM-76", name: "states.US.UM-76" },
    { code: "UM-79", name: "states.US.UM-79" },
    { code: "UM-81", name: "states.US.UM-81" },
    { code: "UM-84", name: "states.US.UM-84" },
    { code: "UM-86", name: "states.US.UM-86" },
    { code: "UM-89", name: "states.US.UM-89" },
    { code: "UM-95", name: "states.US.UM-95" },
    { code: "UT", name: "states.US.UT" },
    { code: "VA", name: "states.US.VA" },
    { code: "VI", name: "states.US.VI" },
    { code: "VT", name: "states.US.VT" },
    { code: "WA", name: "states.US.WA" },
    { code: "WI", name: "states.US.WI" },
    { code: "WV", name: "states.US.WV" },
    { code: "WY", name: "states.US.WY" },
  ],
  UY: [
    { code: "AR", name: "states.UY.AR" },
    { code: "CA", name: "states.UY.CA" },
    { code: "CL", name: "states.UY.CL" },
    { code: "CO", name: "states.UY.CO" },
    { code: "DU", name: "states.UY.DU" },
    { code: "FD", name: "states.UY.FD" },
    { code: "FS", name: "states.UY.FS" },
    { code: "LA", name: "states.UY.LA" },
    { code: "MA", name: "states.UY.MA" },
    { code: "MO", name: "states.UY.MO" },
    { code: "PA", name: "states.UY.PA" },
    { code: "RN", name: "states.UY.RN" },
    { code: "RO", name: "states.UY.RO" },
    { code: "RV", name: "states.UY.RV" },
    { code: "SA", name: "states.UY.SA" },
    { code: "SJ", name: "states.UY.SJ" },
    { code: "SO", name: "states.UY.SO" },
    { code: "TA", name: "states.UY.TA" },
    { code: "TT", name: "states.UY.TT" },
  ],
  UZ: [
    { code: "AN", name: "states.UZ.AN" },
    { code: "BU", name: "states.UZ.BU" },
    { code: "FA", name: "states.UZ.FA" },
    { code: "JI", name: "states.UZ.JI" },
    { code: "NG", name: "states.UZ.NG" },
    { code: "NW", name: "states.UZ.NW" },
    { code: "QA", name: "states.UZ.QA" },
    { code: "QR", name: "states.UZ.QR" },
    { code: "SA", name: "states.UZ.SA" },
    { code: "SI", name: "states.UZ.SI" },
    { code: "SU", name: "states.UZ.SU" },
    { code: "TK", name: "states.UZ.TK" },
    { code: "TO", name: "states.UZ.TO" },
    { code: "XO", name: "states.UZ.XO" },
  ],
  VC: [
    { code: "01", name: "states.VC.01" },
    { code: "02", name: "states.VC.02" },
    { code: "03", name: "states.VC.03" },
    { code: "04", name: "states.VC.04" },
    { code: "05", name: "states.VC.05" },
    { code: "06", name: "states.VC.06" },
  ],
  VE: [
    { code: "A", name: "states.VE.A" },
    { code: "B", name: "states.VE.B" },
    { code: "C", name: "states.VE.C" },
    { code: "D", name: "states.VE.D" },
    { code: "E", name: "states.VE.E" },
    { code: "F", name: "states.VE.F" },
    { code: "G", name: "states.VE.G" },
    { code: "H", name: "states.VE.H" },
    { code: "I", name: "states.VE.I" },
    { code: "J", name: "states.VE.J" },
    { code: "K", name: "states.VE.K" },
    { code: "L", name: "states.VE.L" },
    { code: "M", name: "states.VE.M" },
    { code: "N", name: "states.VE.N" },
    { code: "O", name: "states.VE.O" },
    { code: "P", name: "states.VE.P" },
    { code: "R", name: "states.VE.R" },
    { code: "S", name: "states.VE.S" },
    { code: "T", name: "states.VE.T" },
    { code: "U", name: "states.VE.U" },
    { code: "V", name: "states.VE.V" },
    { code: "W", name: "states.VE.W" },
    { code: "X", name: "states.VE.X" },
    { code: "Y", name: "states.VE.Y" },
    { code: "Z", name: "states.VE.Z" },
  ],
  VN: [
    { code: "01", name: "states.VN.01" },
    { code: "02", name: "states.VN.02" },
    { code: "03", name: "states.VN.03" },
    { code: "04", name: "states.VN.04" },
    { code: "05", name: "states.VN.05" },
    { code: "06", name: "states.VN.06" },
    { code: "07", name: "states.VN.07" },
    { code: "09", name: "states.VN.09" },
    { code: "13", name: "states.VN.13" },
    { code: "14", name: "states.VN.14" },
    { code: "18", name: "states.VN.18" },
    { code: "20", name: "states.VN.20" },
    { code: "21", name: "states.VN.21" },
    { code: "22", name: "states.VN.22" },
    { code: "23", name: "states.VN.23" },
    { code: "24", name: "states.VN.24" },
    { code: "25", name: "states.VN.25" },
    { code: "26", name: "states.VN.26" },
    { code: "27", name: "states.VN.27" },
    { code: "28", name: "states.VN.28" },
    { code: "29", name: "states.VN.29" },
    { code: "30", name: "states.VN.30" },
    { code: "31", name: "states.VN.31" },
    { code: "32", name: "states.VN.32" },
    { code: "33", name: "states.VN.33" },
    { code: "34", name: "states.VN.34" },
    { code: "35", name: "states.VN.35" },
    { code: "36", name: "states.VN.36" },
    { code: "37", name: "states.VN.37" },
    { code: "39", name: "states.VN.39" },
    { code: "40", name: "states.VN.40" },
    { code: "41", name: "states.VN.41" },
    { code: "43", name: "states.VN.43" },
    { code: "44", name: "states.VN.44" },
    { code: "45", name: "states.VN.45" },
    { code: "46", name: "states.VN.46" },
    { code: "47", name: "states.VN.47" },
    { code: "49", name: "states.VN.49" },
    { code: "50", name: "states.VN.50" },
    { code: "51", name: "states.VN.51" },
    { code: "52", name: "states.VN.52" },
    { code: "53", name: "states.VN.53" },
    { code: "54", name: "states.VN.54" },
    { code: "55", name: "states.VN.55" },
    { code: "56", name: "states.VN.56" },
    { code: "57", name: "states.VN.57" },
    { code: "58", name: "states.VN.58" },
    { code: "59", name: "states.VN.59" },
    { code: "61", name: "states.VN.61" },
    { code: "63", name: "states.VN.63" },
    { code: "66", name: "states.VN.66" },
    { code: "67", name: "states.VN.67" },
    { code: "68", name: "states.VN.68" },
    { code: "69", name: "states.VN.69" },
    { code: "70", name: "states.VN.70" },
    { code: "71", name: "states.VN.71" },
    { code: "72", name: "states.VN.72" },
    { code: "73", name: "states.VN.73" },
    { code: "CT", name: "states.VN.CT" },
    { code: "DN", name: "states.VN.DN" },
    { code: "HN", name: "states.VN.HN" },
    { code: "HP", name: "states.VN.HP" },
    { code: "SG", name: "states.VN.SG" },
  ],
  VU: [
    { code: "MAP", name: "states.VU.MAP" },
    { code: "PAM", name: "states.VU.PAM" },
    { code: "SAM", name: "states.VU.SAM" },
    { code: "SEE", name: "states.VU.SEE" },
    { code: "TAE", name: "states.VU.TAE" },
    { code: "TOB", name: "states.VU.TOB" },
  ],
  WS: [
    { code: "AA", name: "states.WS.AA" },
    { code: "AL", name: "states.WS.AL" },
    { code: "AT", name: "states.WS.AT" },
    { code: "FA", name: "states.WS.FA" },
    { code: "GE", name: "states.WS.GE" },
    { code: "GI", name: "states.WS.GI" },
    { code: "PA", name: "states.WS.PA" },
    { code: "SA", name: "states.WS.SA" },
    { code: "TU", name: "states.WS.TU" },
    { code: "VF", name: "states.WS.VF" },
    { code: "VS", name: "states.WS.VS" },
  ],
  XK: [
    { code: "XDG", name: "states.XK.XDG" },
    { code: "XGJ", name: "states.XK.XGJ" },
    { code: "XKM", name: "states.XK.XKM" },
    { code: "XPE", name: "states.XK.XPE" },
    { code: "XPI", name: "states.XK.XPI" },
    { code: "XPR", name: "states.XK.XPR" },
    { code: "XUF", name: "states.XK.XUF" },
  ],
  YE: [
    { code: "AB", name: "states.YE.AB" },
    { code: "AD", name: "states.YE.AD" },
    { code: "AM", name: "states.YE.AM" },
    { code: "BA", name: "states.YE.BA" },
    { code: "DH", name: "states.YE.DH" },
    { code: "HD", name: "states.YE.HD" },
    { code: "HJ", name: "states.YE.HJ" },
    { code: "HU", name: "states.YE.HU" },
    { code: "IB", name: "states.YE.IB" },
    { code: "JA", name: "states.YE.JA" },
    { code: "LA", name: "states.YE.LA" },
    { code: "MA", name: "states.YE.MA" },
    { code: "MR", name: "states.YE.MR" },
    { code: "MW", name: "states.YE.MW" },
    { code: "RA", name: "states.YE.RA" },
    { code: "SA", name: "states.YE.SA" },
    { code: "SD", name: "states.YE.SD" },
    { code: "SH", name: "states.YE.SH" },
    { code: "SN", name: "states.YE.SN" },
    { code: "SU", name: "states.YE.SU" },
    { code: "TA", name: "states.YE.TA" },
  ],
  ZA: [
    { code: "EC", name: "states.ZA.EC" },
    { code: "FS", name: "states.ZA.FS" },
    { code: "GP", name: "states.ZA.GP" },
    { code: "KZN", name: "states.ZA.KZN" },
    { code: "LP", name: "states.ZA.LP" },
    { code: "MP", name: "states.ZA.MP" },
    { code: "NC", name: "states.ZA.NC" },
    { code: "NW", name: "states.ZA.NW" },
    { code: "WC", name: "states.ZA.WC" },
  ],
  ZM: [
    { code: "01", name: "states.ZM.01" },
    { code: "02", name: "states.ZM.02" },
    { code: "03", name: "states.ZM.03" },
    { code: "04", name: "states.ZM.04" },
    { code: "05", name: "states.ZM.05" },
    { code: "06", name: "states.ZM.06" },
    { code: "07", name: "states.ZM.07" },
    { code: "08", name: "states.ZM.08" },
    { code: "09", name: "states.ZM.09" },
    { code: "10", name: "states.ZM.10" },
  ],
  ZW: [
    { code: "BU", name: "states.ZW.BU" },
    { code: "HA", name: "states.ZW.HA" },
    { code: "MA", name: "states.ZW.MA" },
    { code: "MC", name: "states.ZW.MC" },
    { code: "ME", name: "states.ZW.ME" },
    { code: "MI", name: "states.ZW.MI" },
    { code: "MN", name: "states.ZW.MN" },
    { code: "MS", name: "states.ZW.MS" },
    { code: "MV", name: "states.ZW.MV" },
    { code: "MW", name: "states.ZW.MW" },
  ],
};

export default states;
